
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("3eDML", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");

var $45b37b14fa726fb4$exports = {};
$45b37b14fa726fb4$exports = new URL("error-icon.fcea7b28.svg", import.meta.url).toString();





const $d73abe7c8884822c$var$_default_1 = (0, $kSwu1.defineMessages)({
    genericErrorHeading: {
        id: "company-hub.generic-error-page.heading",
        defaultMessage: "We're on it"
    },
    genericErrorDescription: {
        id: "company-hub.generic-error-page.description",
        defaultMessage: "An unexpected error has occured when processing your request. Our team is working to get things back up and running."
    }
});
var $d73abe7c8884822c$export$2e2bcd8739ae039 = $d73abe7c8884822c$var$_default_1;


const $a28e4467baac2569$var$styles = {
    image: "_1bsbclpc",
    root: "_4t3i1osq _n3tdxncg",
    content: "_y3gn1h6o _p12f1dup"
};
const $a28e4467baac2569$export$5d76009b056f3e5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($45b37b14fa726fb4$exports))),
            alt: "error page",
            className: (0, $hekY6.default)([
                $a28e4467baac2569$var$styles.image
            ])
        });
        t1 = (0, $hekY6.default)([
            $a28e4467baac2569$var$styles.content
        ]);
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xlarge"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $d73abe7c8884822c$export$2e2bcd8739ae039).genericErrorHeading));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            alignInline: "center",
            space: "space.200",
            alignBlock: "center",
            xcss: $a28e4467baac2569$var$styles.root
        }, t0, /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t2, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $d73abe7c8884822c$export$2e2bcd8739ae039).genericErrorDescription)))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        alignInline: "center",
        space: "space.200",
        alignBlock: "center",
        xcss: $a28e4467baac2569$var$styles.root
    }, /*#__PURE__*/ $cozmU.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($45b37b14fa726fb4$exports))),
        alt: "error page",
        className: (0, $hekY6.default)([
            $a28e4467baac2569$var$styles.image
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $a28e4467baac2569$var$styles.content
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xlarge"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $d73abe7c8884822c$export$2e2bcd8739ae039).genericErrorHeading)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $d73abe7c8884822c$export$2e2bcd8739ae039).genericErrorDescription)))));
};
module.exports["GenericErrorPage"] = $a28e4467baac2569$export$5d76009b056f3e5d;

});

parcelRegister("ame4Z", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $iDrrr = parcelRequire("iDrrr");


var $h6BA0 = parcelRequire("h6BA0");


var $h9r4d = parcelRequire("h9r4d");


var $6qzJ0 = parcelRequire("6qzJ0");

const $254f47a48ddd9760$var$isFetchClientError = (err)=>{
    return err?.status < 500;
};
const $254f47a48ddd9760$export$ba2f52e216142b3d = ({ children: children, packageName: packageName, id: id, fallback: fallback, shouldForceError: shouldForceError, operationNames: operationNames })=>{
    const logError = (0, $h6BA0.useUFOReportError)();
    const onError = (error)=>{
        if ($254f47a48ddd9760$var$isFetchClientError(error)) // skip fetch client error e.g. 4xx
        return;
        // react-ufo does not expose a dedicated traceId/attribute field, so the trace ID is
        // appended to the error message. fireErrorAnalytics additionally receives it as an attribute.
        let traceId;
        if (operationNames && (0, $iDrrr.fg)('hub_error_analytics_trace_id')) {
            const traceIds = operationNames.flatMap((name)=>(0, $6qzJ0.getTraceIds)(name));
            traceId = traceIds.find(Boolean);
        }
        // Fire additional error analytics
        try {
            // Log rUFO error metrics
            logError({
                name: error.name,
                errorMessage: traceId ? `${error.message} (traceId: ${traceId})` : error.message,
                errorStack: error.stack,
                forcedError: shouldForceError
            });
            (0, $h9r4d.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: id,
                    packageName: packageName
                },
                attributes: traceId ? {
                    traceId: traceId
                } : undefined
            });
        } catch (err) {
            // Added to silently fail Uncaught ReferenceError: __SERVER__ is not defined
            // eslint-disable-next-line no-console
            console.warn('Failed to fire error analytics:', err);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        onError: onError,
        fallback: fallback
    }, children);
};
module.exports["HubErrorBoundary"] = $254f47a48ddd9760$export$ba2f52e216142b3d;

});

parcelRegister("4pBmf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $9DHhW = parcelRequire("9DHhW");


var $jYwtP = parcelRequire("jYwtP");


var $5tPGk = parcelRequire("5tPGk");

var $h2czO = parcelRequire("h2czO");

const $67b5dfbfac59bcd7$export$944f75ec5697b362 = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);


function $202f41dcc05e785f$export$34d09c4a771c46ef(r, g, b) {
    const chars = (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    return `#${chars}`;
}
function $202f41dcc05e785f$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $202f41dcc05e785f$export$b36dbdb4f463f05c(hex) {
    if (!(0, $67b5dfbfac59bcd7$export$944f75ec5697b362)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $202f41dcc05e785f$export$1212645cf40ebf71(hex)
    ];
}
function $202f41dcc05e785f$export$5a544e13ad4e1fa5(hex) {
    if (!(0, $67b5dfbfac59bcd7$export$944f75ec5697b362)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $202f41dcc05e785f$export$47ea145a83f50dc0(hex) {
    if (!(0, $67b5dfbfac59bcd7$export$944f75ec5697b362)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let r = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    g = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $202f41dcc05e785f$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $202f41dcc05e785f$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $202f41dcc05e785f$export$d061e26956a60b0a(foreground, background) {
    if (!(0, $67b5dfbfac59bcd7$export$944f75ec5697b362)(foreground) || !(0, $67b5dfbfac59bcd7$export$944f75ec5697b362)(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $202f41dcc05e785f$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $202f41dcc05e785f$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $202f41dcc05e785f$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $202f41dcc05e785f$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $202f41dcc05e785f$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $202f41dcc05e785f$var$rgbToLab(rgbA);
    let labB = $202f41dcc05e785f$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $202f41dcc05e785f$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}


/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $d3a4e0582a448fde$export$23e3e2011c250f0f(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
function $d3a4e0582a448fde$export$3a89f8d6f6bf6c9f(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
function $d3a4e0582a448fde$export$d0498fe3d58e384f(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $d3a4e0582a448fde$export$62d511a4580feff(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $d3a4e0582a448fde$export$7417613e514a9e72(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
function $d3a4e0582a448fde$export$be586f9fe0391d67(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}


/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $dbbfb01dc85c2ef6$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $dbbfb01dc85c2ef6$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $dbbfb01dc85c2ef6$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
function $dbbfb01dc85c2ef6$export$58a74b9f8e513b7b(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
function $dbbfb01dc85c2ef6$export$7928ddf440518d19(linrgb) {
    const r = $dbbfb01dc85c2ef6$export$777e26aa2ec02b1(linrgb[0]);
    const g = $dbbfb01dc85c2ef6$export$777e26aa2ec02b1(linrgb[1]);
    const b = $dbbfb01dc85c2ef6$export$777e26aa2ec02b1(linrgb[2]);
    return $dbbfb01dc85c2ef6$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Returns the alpha component of a color in ARGB format.
 */ function $dbbfb01dc85c2ef6$var$alphaFromArgb(argb) {
    return argb >> 24 & 255;
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $dbbfb01dc85c2ef6$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $dbbfb01dc85c2ef6$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $dbbfb01dc85c2ef6$var$blueFromArgb(argb) {
    return argb & 255;
}
function $dbbfb01dc85c2ef6$export$cbbbbc8b222df20(x, y, z) {
    const matrix = $dbbfb01dc85c2ef6$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $dbbfb01dc85c2ef6$export$777e26aa2ec02b1(linearR);
    const g = $dbbfb01dc85c2ef6$export$777e26aa2ec02b1(linearG);
    const b = $dbbfb01dc85c2ef6$export$777e26aa2ec02b1(linearB);
    return $dbbfb01dc85c2ef6$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $dbbfb01dc85c2ef6$var$xyzFromArgb(argb) {
    const r = $dbbfb01dc85c2ef6$export$dec6bcda7bf47f2c($dbbfb01dc85c2ef6$var$redFromArgb(argb));
    const g = $dbbfb01dc85c2ef6$export$dec6bcda7bf47f2c($dbbfb01dc85c2ef6$var$greenFromArgb(argb));
    const b = $dbbfb01dc85c2ef6$export$dec6bcda7bf47f2c($dbbfb01dc85c2ef6$var$blueFromArgb(argb));
    return $d3a4e0582a448fde$export$be586f9fe0391d67([
        r,
        g,
        b
    ], $dbbfb01dc85c2ef6$var$SRGB_TO_XYZ);
}
function $dbbfb01dc85c2ef6$export$ae8c227f6d0cbddb(lstar) {
    const y = $dbbfb01dc85c2ef6$export$7f3071c4a5db05a0(lstar);
    const component = $dbbfb01dc85c2ef6$export$777e26aa2ec02b1(y);
    return $dbbfb01dc85c2ef6$export$58a74b9f8e513b7b(component, component, component);
}
function $dbbfb01dc85c2ef6$export$8b8f7ef2e0a71c61(argb) {
    const y = $dbbfb01dc85c2ef6$var$xyzFromArgb(argb)[1];
    return 116.0 * $dbbfb01dc85c2ef6$var$labF(y / 100.0) - 16.0;
}
function $dbbfb01dc85c2ef6$export$7f3071c4a5db05a0(lstar) {
    return 100.0 * $dbbfb01dc85c2ef6$var$labInvf((lstar + 16.0) / 116.0);
}
function $dbbfb01dc85c2ef6$export$bfc0d1dd9c64ada2(y) {
    return $dbbfb01dc85c2ef6$var$labF(y / 100.0) * 116.0 - 16.0;
}
function $dbbfb01dc85c2ef6$export$dec6bcda7bf47f2c(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
function $dbbfb01dc85c2ef6$export$777e26aa2ec02b1(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $d3a4e0582a448fde$export$d0498fe3d58e384f(0, 255, Math.round(delinearized * 255.0));
}
function $dbbfb01dc85c2ef6$export$d4534a444c6526c3() {
    return $dbbfb01dc85c2ef6$var$WHITE_POINT_D65;
}
function $dbbfb01dc85c2ef6$export$fb1fd26c787a8662(argb) {
    const r = $dbbfb01dc85c2ef6$var$redFromArgb(argb);
    const g = $dbbfb01dc85c2ef6$var$greenFromArgb(argb);
    const b = $dbbfb01dc85c2ef6$var$blueFromArgb(argb);
    const a = $dbbfb01dc85c2ef6$var$alphaFromArgb(argb);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $dbbfb01dc85c2ef6$export$9128c3a9233ad1fd({ r: r, g: g, b: b, a: a }) {
    const rValue = $dbbfb01dc85c2ef6$var$clampComponent(r);
    const gValue = $dbbfb01dc85c2ef6$var$clampComponent(g);
    const bValue = $dbbfb01dc85c2ef6$var$clampComponent(b);
    const aValue = $dbbfb01dc85c2ef6$var$clampComponent(a);
    return aValue << 24 | rValue << 16 | gValue << 8 | bValue;
}
function $dbbfb01dc85c2ef6$var$clampComponent(value) {
    if (value < 0) return 0;
    if (value > 255) return 255;
    return value;
}
function $dbbfb01dc85c2ef6$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $dbbfb01dc85c2ef6$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}


/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace


class $fb81abfcf0111fe2$export$656ae42051d0ca86 {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $d3a4e0582a448fde$export$62d511a4580feff(0.0, 100.0, toneA);
        toneB = $d3a4e0582a448fde$export$62d511a4580feff(0.0, 100.0, toneB);
        return $fb81abfcf0111fe2$export$656ae42051d0ca86.ratioOfYs($dbbfb01dc85c2ef6$export$7f3071c4a5db05a0(toneA), $dbbfb01dc85c2ef6$export$7f3071c4a5db05a0(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $dbbfb01dc85c2ef6$export$7f3071c4a5db05a0(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $fb81abfcf0111fe2$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $dbbfb01dc85c2ef6$export$bfc0d1dd9c64ada2(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $dbbfb01dc85c2ef6$export$7f3071c4a5db05a0(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $fb81abfcf0111fe2$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $dbbfb01dc85c2ef6$export$bfc0d1dd9c64ada2(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $fb81abfcf0111fe2$export$656ae42051d0ca86.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $fb81abfcf0111fe2$export$656ae42051d0ca86.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}




var $e8a0cc5f8fb1c6fe$var$_ViewingConditions;
class $e8a0cc5f8fb1c6fe$export$91d2e033b3924566 {
    static from(hue, chroma, tone) {
        return new $e8a0cc5f8fb1c6fe$export$91d2e033b3924566($e8a0cc5f8fb1c6fe$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $e8a0cc5f8fb1c6fe$export$91d2e033b3924566(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($e8a0cc5f8fb1c6fe$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($e8a0cc5f8fb1c6fe$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /**
   * Lightness. Ranges from 0 to 100.
   */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($e8a0cc5f8fb1c6fe$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    setInternalState(argb) {
        const cam = $e8a0cc5f8fb1c6fe$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $dbbfb01dc85c2ef6$export$8b8f7ef2e0a71c61(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $e8a0cc5f8fb1c6fe$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $e8a0cc5f8fb1c6fe$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $e8a0cc5f8fb1c6fe$export$159586e3808c6277.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $e8a0cc5f8fb1c6fe$export$91d2e033b3924566.from(recastInVc.hue, recastInVc.chroma, $dbbfb01dc85c2ef6$export$bfc0d1dd9c64ada2(viewedInVc[1]));
        return recastHct;
    }
    constructor(argb){
        this.argb = argb;
        /**
     * @param hue 0 <= hue < 360; invalid values are corrected.
     * @param chroma 0 <= chroma < ?; Informally, colorfulness. The color
     *     returned may be lower than the requested chroma. Chroma has a different
     *     maximum for any given hue and tone.
     * @param tone 0 <= tone <= 100; invalid values are corrected.
     * @return HCT representation of a color in default viewing conditions.
     */ this.internalHue = void 0;
        this.internalChroma = void 0;
        this.internalTone = void 0;
        const cam = $e8a0cc5f8fb1c6fe$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $dbbfb01dc85c2ef6$export$8b8f7ef2e0a71c61(argb);
        this.argb = argb;
    }
}
/**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $e8a0cc5f8fb1c6fe$var$Cam16 {
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $e8a0cc5f8fb1c6fe$var$Cam16.fromIntInViewingConditions(argb, $e8a0cc5f8fb1c6fe$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $dbbfb01dc85c2ef6$export$dec6bcda7bf47f2c(red);
        const greenL = $dbbfb01dc85c2ef6$export$dec6bcda7bf47f2c(green);
        const blueL = $dbbfb01dc85c2ef6$export$dec6bcda7bf47f2c(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $d3a4e0582a448fde$export$23e3e2011c250f0f(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $d3a4e0582a448fde$export$23e3e2011c250f0f(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $d3a4e0582a448fde$export$23e3e2011c250f0f(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $e8a0cc5f8fb1c6fe$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $e8a0cc5f8fb1c6fe$var$Cam16.fromJchInViewingConditions(j, c, h, $e8a0cc5f8fb1c6fe$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $e8a0cc5f8fb1c6fe$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $e8a0cc5f8fb1c6fe$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $e8a0cc5f8fb1c6fe$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $e8a0cc5f8fb1c6fe$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($e8a0cc5f8fb1c6fe$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $d3a4e0582a448fde$export$23e3e2011c250f0f(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $d3a4e0582a448fde$export$23e3e2011c250f0f(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $d3a4e0582a448fde$export$23e3e2011c250f0f(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $dbbfb01dc85c2ef6$export$cbbbbc8b222df20(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $d3a4e0582a448fde$export$23e3e2011c250f0f(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $d3a4e0582a448fde$export$23e3e2011c250f0f(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $d3a4e0582a448fde$export$23e3e2011c250f0f(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $e8a0cc5f8fb1c6fe$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $d3a4e0582a448fde$export$23e3e2011c250f0f(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $d3a4e0582a448fde$export$23e3e2011c250f0f(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $d3a4e0582a448fde$export$23e3e2011c250f0f(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
}
// This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $e8a0cc5f8fb1c6fe$var$HctSolver {
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $d3a4e0582a448fde$export$23e3e2011c250f0f(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $d3a4e0582a448fde$export$be586f9fe0391d67(linrgb, $e8a0cc5f8fb1c6fe$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $e8a0cc5f8fb1c6fe$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $e8a0cc5f8fb1c6fe$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $e8a0cc5f8fb1c6fe$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $e8a0cc5f8fb1c6fe$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $e8a0cc5f8fb1c6fe$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $e8a0cc5f8fb1c6fe$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $e8a0cc5f8fb1c6fe$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $e8a0cc5f8fb1c6fe$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $e8a0cc5f8fb1c6fe$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $e8a0cc5f8fb1c6fe$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($e8a0cc5f8fb1c6fe$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($e8a0cc5f8fb1c6fe$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($e8a0cc5f8fb1c6fe$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $e8a0cc5f8fb1c6fe$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $e8a0cc5f8fb1c6fe$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $e8a0cc5f8fb1c6fe$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($e8a0cc5f8fb1c6fe$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $e8a0cc5f8fb1c6fe$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $e8a0cc5f8fb1c6fe$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $e8a0cc5f8fb1c6fe$var$HctSolver.criticalPlaneBelow($e8a0cc5f8fb1c6fe$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $e8a0cc5f8fb1c6fe$var$HctSolver.criticalPlaneAbove($e8a0cc5f8fb1c6fe$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $e8a0cc5f8fb1c6fe$var$HctSolver.criticalPlaneAbove($e8a0cc5f8fb1c6fe$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $e8a0cc5f8fb1c6fe$var$HctSolver.criticalPlaneBelow($e8a0cc5f8fb1c6fe$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $e8a0cc5f8fb1c6fe$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $e8a0cc5f8fb1c6fe$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $e8a0cc5f8fb1c6fe$var$HctSolver.hueOf(mid);
                    if ($e8a0cc5f8fb1c6fe$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $e8a0cc5f8fb1c6fe$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $d3a4e0582a448fde$export$23e3e2011c250f0f(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $e8a0cc5f8fb1c6fe$export$159586e3808c6277.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $e8a0cc5f8fb1c6fe$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $e8a0cc5f8fb1c6fe$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $e8a0cc5f8fb1c6fe$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $d3a4e0582a448fde$export$be586f9fe0391d67([
                rCScaled,
                gCScaled,
                bCScaled
            ], $e8a0cc5f8fb1c6fe$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $e8a0cc5f8fb1c6fe$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $e8a0cc5f8fb1c6fe$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $e8a0cc5f8fb1c6fe$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $dbbfb01dc85c2ef6$export$7928ddf440518d19(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $dbbfb01dc85c2ef6$export$ae8c227f6d0cbddb(lstar);
        hueDegrees = $d3a4e0582a448fde$export$7417613e514a9e72(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $dbbfb01dc85c2ef6$export$7f3071c4a5db05a0(lstar);
        const exactAnswer = $e8a0cc5f8fb1c6fe$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $e8a0cc5f8fb1c6fe$var$HctSolver.bisectToLimit(y, hueRadians);
        return $dbbfb01dc85c2ef6$export$7928ddf440518d19(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $e8a0cc5f8fb1c6fe$var$Cam16.fromInt($e8a0cc5f8fb1c6fe$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
$e8a0cc5f8fb1c6fe$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB = [
    [
        0.001200833568784504,
        0.002389694492170889,
        0.0002795742885861124
    ],
    [
        0.0005891086651375999,
        0.0029785502573438758,
        0.0003270666104008398
    ],
    [
        0.00010146692491640572,
        0.0005364214359186694,
        0.0032979401770712076
    ]
];
$e8a0cc5f8fb1c6fe$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT = [
    [
        1373.2198709594231,
        -1100.4251190754821,
        -7.278681089101213
    ],
    [
        -271.815969077903,
        559.6580465940733,
        -32.46047482791194
    ],
    [
        1.9622899599665666,
        -57.173814538844006,
        308.7233197812385
    ]
];
$e8a0cc5f8fb1c6fe$var$HctSolver.Y_FROM_LINRGB = [
    0.2126,
    0.7152,
    0.0722
];
$e8a0cc5f8fb1c6fe$var$HctSolver.CRITICAL_PLANES = [
    0.015176349177441876,
    0.045529047532325624,
    0.07588174588720938,
    0.10623444424209313,
    0.13658714259697685,
    0.16693984095186062,
    0.19729253930674434,
    0.2276452376616281,
    0.2579979360165119,
    0.28835063437139563,
    0.3188300904430532,
    0.350925934958123,
    0.3848314933096426,
    0.42057480301049466,
    0.458183274052838,
    0.4976837250274023,
    0.5391024159806381,
    0.5824650784040898,
    0.6277969426914107,
    0.6751227633498623,
    0.7244668422128921,
    0.775853049866786,
    0.829304845476233,
    0.8848452951698498,
    0.942497089126609,
    1.0022825574869039,
    1.0642236851973577,
    1.1283421258858297,
    1.1946592148522128,
    1.2631959812511864,
    1.3339731595349034,
    1.407011200216447,
    1.4823302800086415,
    1.5599503113873272,
    1.6398909516233677,
    1.7221716113234105,
    1.8068114625156377,
    1.8938294463134073,
    1.9832442801866852,
    2.075074464868551,
    2.1693382909216234,
    2.2660538449872063,
    2.36523901573795,
    2.4669114995532007,
    2.5710888059345764,
    2.6777882626779785,
    2.7870270208169257,
    2.898822059350997,
    3.0131901897720907,
    3.1301480604002863,
    3.2497121605402226,
    3.3718988244681087,
    3.4967242352587946,
    3.624204428461639,
    3.754355295633311,
    3.887192587735158,
    4.022731918402185,
    4.160988767090289,
    4.301978482107941,
    4.445716283538092,
    4.592217266055746,
    4.741496401646282,
    4.893568542229298,
    5.048448422192488,
    5.20615066083972,
    5.3666897647573375,
    5.5300801301023865,
    5.696336044816294,
    5.865471690767354,
    6.037501145825082,
    6.212438385869475,
    6.390297286737924,
    6.571091626112461,
    6.7548350853498045,
    6.941541251256611,
    7.131223617812143,
    7.323895587840543,
    7.5195704746346665,
    7.7182615035334345,
    7.919981813454504,
    8.124744458384042,
    8.332562408825165,
    8.543448553206703,
    8.757415699253682,
    8.974476575321063,
    9.194643831691977,
    9.417930041841839,
    9.644347703669503,
    9.873909240696694,
    10.106627003236781,
    10.342513269534024,
    10.58158024687427,
    10.8238400726681,
    11.069304815507364,
    11.317986476196008,
    11.569896988756009,
    11.825048221409341,
    12.083451977536606,
    12.345119996613247,
    12.610063955123938,
    12.878295467455942,
    13.149826086772048,
    13.42466730586372,
    13.702830557985108,
    13.984327217668513,
    14.269168601521828,
    14.55736596900856,
    14.848930523210871,
    15.143873411576273,
    15.44220572664832,
    15.743938506781891,
    16.04908273684337,
    16.35764934889634,
    16.66964922287304,
    16.985093187232053,
    17.30399201960269,
    17.62635644741625,
    17.95219714852476,
    18.281524751807332,
    18.614349837764564,
    18.95068293910138,
    19.290534541298456,
    19.633915083172692,
    19.98083495742689,
    20.331304511189067,
    20.685334046541502,
    21.042933821039977,
    21.404114048223256,
    21.76888489811322,
    22.137256497705877,
    22.50923893145328,
    22.884842241736916,
    23.264076429332462,
    23.6469514538663,
    24.033477234264016,
    24.42366364919083,
    24.817520537484558,
    25.21505769858089,
    25.61628489293138,
    26.021211842414342,
    26.429848230738664,
    26.842203703840827,
    27.258287870275353,
    27.678110301598522,
    28.10168053274597,
    28.529008062403893,
    28.96010235337422,
    29.39497283293396,
    29.83362889318845,
    30.276079891419332,
    30.722335150426627,
    31.172403958865512,
    31.62629557157785,
    32.08401920991837,
    32.54558406207592,
    33.010999283389665,
    33.4802739966603,
    33.953417292456834,
    34.430438229418264,
    34.911345834551085,
    35.39614910352207,
    35.88485700094671,
    36.37747846067349,
    36.87402238606382,
    37.37449765026789,
    37.87891309649659,
    38.38727753828926,
    38.89959975977785,
    39.41588851594697,
    39.93615253289054,
    40.460400508064545,
    40.98864111053629,
    41.520882981230194,
    42.05713473317016,
    42.597404951718396,
    43.141702194811224,
    43.6900349931913,
    44.24241185063697,
    44.798841244188324,
    45.35933162437017,
    45.92389141541209,
    46.49252901546552,
    47.065252796817916,
    47.64207110610409,
    48.22299226451468,
    48.808024568002054,
    49.3971762874833,
    49.9904556690408,
    50.587870934119984,
    51.189430279724725,
    51.79514187861014,
    52.40501387947288,
    53.0190544071392,
    53.637271562750364,
    54.259673423945976,
    54.88626804504493,
    55.517063457223934,
    56.15206766869424,
    56.79128866487574,
    57.43473440856916,
    58.08241284012621,
    58.734331877617365,
    59.39049941699807,
    60.05092333227251,
    60.715611475655585,
    61.38457167773311,
    62.057811747619894,
    62.7353394731159,
    63.417162620860914,
    64.10328893648692,
    64.79372614476921,
    65.48848194977529,
    66.18756403501224,
    66.89098006357258,
    67.59873767827808,
    68.31084450182222,
    69.02730813691093,
    69.74813616640164,
    70.47333615344107,
    71.20291564160104,
    71.93688215501312,
    72.67524319850172,
    73.41800625771542,
    74.16517879925733,
    74.9167682708136,
    75.67278210128072,
    76.43322770089146,
    77.1981124613393,
    77.96744375590167,
    78.74122893956174,
    79.51947534912904,
    80.30219030335869,
    81.08938110306934,
    81.88105503125999,
    82.67721935322541,
    83.4778813166706,
    84.28304815182372,
    85.09272707154808,
    85.90692527145302,
    86.72564993000343,
    87.54890820862819,
    88.3767072518277,
    89.2090541872801,
    90.04595612594655,
    90.88742016217518,
    91.73345337380438,
    92.58406282226491,
    93.43925555268066,
    94.29903859396902,
    95.16341895893969,
    96.03240364439274,
    96.9059996312159,
    97.78421388448044,
    98.6670533535366,
    99.55452497210776
];
class $e8a0cc5f8fb1c6fe$export$159586e3808c6277 {
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $dbbfb01dc85c2ef6$export$d4534a444c6526c3(), adaptingLuminance = 200.0 / Math.PI * $dbbfb01dc85c2ef6$export$7f3071c4a5db05a0(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $d3a4e0582a448fde$export$3a89f8d6f6bf6c9f(0.59, 0.69, (f - 0.9) * 10.0) : $d3a4e0582a448fde$export$3a89f8d6f6bf6c9f(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $dbbfb01dc85c2ef6$export$7f3071c4a5db05a0(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $e8a0cc5f8fb1c6fe$export$159586e3808c6277(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}
$e8a0cc5f8fb1c6fe$var$_ViewingConditions = $e8a0cc5f8fb1c6fe$export$159586e3808c6277;
/**
 * sRGB-like viewing conditions.
 */ $e8a0cc5f8fb1c6fe$export$159586e3808c6277.DEFAULT = $e8a0cc5f8fb1c6fe$var$_ViewingConditions.make();


const $1a64fdb52b084b52$var$lowLuminanceContrastRatios = [
    1.12,
    1.33,
    2.03,
    2.73,
    3.33,
    4.27,
    5.2,
    6.62,
    12.46,
    14.25
];
const $1a64fdb52b084b52$var$highLuminanceContrastRatios = [
    1.08,
    1.24,
    1.55,
    1.99,
    2.45,
    3.34,
    4.64,
    6.1,
    10.19,
    12.6
];
const $1a64fdb52b084b52$export$b102e016d69678f3 = (themeRamp, brandColor)=>{
    // Iterate over themeRamp and find whichever color is closest to brandColor
    let closestColorIndex = 0;
    let closestColorDistance = null;
    themeRamp.forEach((value, index)=>{
        const distance = (0, $202f41dcc05e785f$export$e8ddad763b4bebf9)((0, $202f41dcc05e785f$export$5a544e13ad4e1fa5)(value), (0, $202f41dcc05e785f$export$5a544e13ad4e1fa5)(brandColor));
        if (closestColorDistance === null || distance < closestColorDistance) {
            closestColorIndex = index;
            closestColorDistance = distance;
        }
    });
    return closestColorIndex;
};
const $1a64fdb52b084b52$export$253cd51ce7d49924 = (brandColor)=>{
    // Determine luminance
    const HSLBrandColorHue = (0, $202f41dcc05e785f$export$47ea145a83f50dc0)(brandColor)[0];
    const baseRgb = (0, $202f41dcc05e785f$export$1ff93e992dd58bec)(HSLBrandColorHue, 100, 60);
    const isLowLuminance = (0, $202f41dcc05e785f$export$e770b01b744f3745)(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
    // Choose right palette
    const themeRatios = isLowLuminance ? $1a64fdb52b084b52$var$lowLuminanceContrastRatios : $1a64fdb52b084b52$var$highLuminanceContrastRatios;
    const brandRgba = (0, $202f41dcc05e785f$export$b36dbdb4f463f05c)(brandColor);
    const hctColor = (0, $e8a0cc5f8fb1c6fe$export$91d2e033b3924566).fromInt((0, $dbbfb01dc85c2ef6$export$9128c3a9233ad1fd)({
        r: brandRgba[0],
        g: brandRgba[1],
        b: brandRgba[2],
        a: brandRgba[3]
    }));
    const themeRamp = themeRatios.map((contrast)=>{
        const rgbaColor = (0, $dbbfb01dc85c2ef6$export$fb1fd26c787a8662)((0, $e8a0cc5f8fb1c6fe$export$91d2e033b3924566).from(hctColor.hue, hctColor.chroma, (0, $fb81abfcf0111fe2$export$656ae42051d0ca86).darker(100, contrast) + 0.25).toInt());
        return (0, $202f41dcc05e785f$export$34d09c4a771c46ef)(rgbaColor.r, rgbaColor.g, rgbaColor.b);
    });
    const closestColorIndex = $1a64fdb52b084b52$export$b102e016d69678f3(themeRamp, brandColor);
    // Replace closet color with brandColor
    const updatedThemeRamp = [
        ...themeRamp
    ];
    updatedThemeRamp[closestColorIndex] = brandColor;
    return updatedThemeRamp;
};
const $1a64fdb52b084b52$export$3a180ce5632a9d57 = (primaryColor)=>{
    const colors = $1a64fdb52b084b52$export$253cd51ce7d49924(primaryColor);
    return {
        color100: colors[0],
        color200: colors[1],
        color300: colors[2],
        color400: colors[3],
        color500: colors[4],
        color600: colors[5],
        color700: colors[6],
        color800: colors[7],
        color900: colors[8],
        color1000: colors[9]
    };
};



/**
 * Default primary color for CSM branding
 */ const $65d6b82e468775dc$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR = '#B5B5B5';
const $65d6b82e468775dc$export$c1410db1c88d6e0f = (primaryColour)=>(0, $1a64fdb52b084b52$export$3a180ce5632a9d57)((0, $67b5dfbfac59bcd7$export$944f75ec5697b362)(primaryColour) ? primaryColour : $65d6b82e468775dc$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR);



var $5KWZf = parcelRequire("5KWZf");


var $r8hvx = parcelRequire("r8hvx");


var $hITUV = parcelRequire("hITUV");




var $bDgLe = parcelRequire("bDgLe");




/**
 * Build a 20-shade `HubBrandPalette` from a (primary, accent) brand colour
 * pair, per §4.1 of the Advanced Theming v2 design.
 *
 * Implementation note: this is a thin wrapper around the existing CSM colour
 * theme generator (which is also what `setHubBrandingStyle` already uses).
 * That generator runs the same Material-HCT-based 10-step ramp algorithm as
 * `@atlaskit/tokens`'s internal `generateColors`, but is exposed via a public
 * entry-point and is already a hubs dependency, so we don't have to duplicate
 * the colour science.
 *
 * Pure and synchronous — safe to call during render, including SSR.
 */ 
const $db95d88045160150$var$SHADES = [
    [
        '100',
        'color100'
    ],
    [
        '200',
        'color200'
    ],
    [
        '300',
        'color300'
    ],
    [
        '400',
        'color400'
    ],
    [
        '500',
        'color500'
    ],
    [
        '600',
        'color600'
    ],
    [
        '700',
        'color700'
    ],
    [
        '800',
        'color800'
    ],
    [
        '900',
        'color900'
    ],
    [
        '1000',
        'color1000'
    ]
];
const $db95d88045160150$var$buildFamily = (family, hex)=>{
    const ramp = (0, $65d6b82e468775dc$export$c1410db1c88d6e0f)(hex);
    const out = {};
    for (const [shade, rampKey] of $db95d88045160150$var$SHADES){
        const key = `${family}.${shade}`;
        out[key] = ramp[rampKey];
    }
    return out;
};
const $db95d88045160150$export$fb2e77ab23c1ab27 = ({ primary: primary, accent: accent })=>{
    return {
        ...$db95d88045160150$var$buildFamily('primary', primary),
        ...$db95d88045160150$var$buildFamily('accent', accent)
    };
};


const $d6c8448a36deb3c2$export$52531ed83ceae9ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? (inputs)=>{
    const $ = (0, $bDgLe.c)(3);
    const { primary: primary, accent: accent } = inputs;
    let t0;
    if ($[0] !== accent || $[1] !== primary) {
        t0 = (0, $db95d88045160150$export$fb2e77ab23c1ab27)({
            primary: primary,
            accent: accent
        });
        $[0] = accent;
        $[1] = primary;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (inputs)=>{
    const { primary: primary, accent: accent } = inputs;
    return (0, $cozmU.useMemo)(()=>(0, $db95d88045160150$export$fb2e77ab23c1ab27)({
            primary: primary,
            accent: accent
        }), [
        primary,
        accent
    ]);
};



var $4WDWC = parcelRequire("4WDWC");





var $lCJ1A = parcelRequire("lCJ1A");

/**
 * Single source of truth for the day-0 brand-colour defaults.
 *
 * A hub with no persisted primary/accent falls back to these, and the analytics
 * "customized vs default" check compares against them — so BOTH
 * `controllers/hub-theming-context` (which applies them) and
 * `utils/hub-theming-analytics` (which measures against them) import from here.
 * Do not re-declare these anywhere else, or day-0 hubs get mis-flagged as
 * customized when only one copy is updated.
 *
 * The other two dimensions' defaults already live with their own modules and
 * should be imported from there: `HUB_CORNER_RADIUS_DEFAULT` from
 * `utils/hub-corner-radius`, `DEFAULT_SPACE_DENSITY` from `utils/hub-space-density`.
 *
 * Kept dependency-free (no React/relay) so the pure analytics helper can import
 * it without pulling in the framework or creating an import cycle with
 * `hub-theming-context` (which imports the analytics helper).
 */ const $c7da5ed97c2620f2$export$b9864279fc70d379 = '#003172';
const $c7da5ed97c2620f2$export$74ca527397fc1422 = '#DDDEE1';


const $290430c0b7ae0136$export$8173e092749d2f38 = ({ primaryColor: primaryColor, accentColor: accentColor, typography: typography, cornerRadius: cornerRadius, spaceDensity: spaceDensity })=>{
    const colorsCustomized = !!primaryColor && primaryColor.toUpperCase() !== (0, $c7da5ed97c2620f2$export$b9864279fc70d379) || !!accentColor && accentColor.toUpperCase() !== (0, $c7da5ed97c2620f2$export$74ca527397fc1422);
    const typographyCustomized = !!typography;
    const cornerRadiusCustomized = typeof cornerRadius === 'number' && cornerRadius !== (0, $4WDWC.HUB_CORNER_RADIUS_DEFAULT);
    const spaceDensityCustomized = !!spaceDensity && spaceDensity !== (0, $lCJ1A.DEFAULT_SPACE_DENSITY);
    const customizedDimensionCount = Number(colorsCustomized) + Number(typographyCustomized) + Number(cornerRadiusCustomized) + Number(spaceDensityCustomized);
    return {
        customizedDimensionCount: customizedDimensionCount,
        colorsCustomized: colorsCustomized,
        typographyCustomized: typographyCustomized,
        cornerRadiusCustomized: cornerRadiusCustomized,
        spaceDensityCustomized: spaceDensityCustomized,
        primaryColor: primaryColor,
        accentColor: accentColor,
        bodyFont: typography?.body,
        headingFont: typography?.heading,
        cornerRadius: cornerRadius,
        spaceDensity: spaceDensity
    };
};




var $4pfdN = parcelRequire("4pfdN");


var $j0Q3v = parcelRequire("j0Q3v");

const $08727b03dc7c3907$export$a6017cadbc9d9217 = '#DCDFE4'; // matches `color.border`
const $08727b03dc7c3907$export$29b411f689221690 = '#758195'; // matches `color.border.bold`
const $08727b03dc7c3907$var$HubThemingContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $08727b03dc7c3907$var$readableHubTextColor = (color)=>(0, $h2czO.readableTextColor)(color, '@atlassian/company-hub-common');
const $08727b03dc7c3907$export$637b3c4e057a01d3 = ({ children: children })=>{
    (0, $6cFsl.di)((0, $r8hvx.useHubContext), (0, $j0Q3v.useIsAdvancedThemingEnabled), (0, $9DHhW.useAnalyticsEvents));
    const { branding: branding, env: env, hubType: hubType, isInPreviewMode: isInPreviewMode } = (0, $r8hvx.useHubContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEnabled = (0, $j0Q3v.useIsAdvancedThemingEnabled)();
    const primaryColor = branding?.colors?.primary ?? (0, $c7da5ed97c2620f2$export$b9864279fc70d379);
    // Accent comes from the BE (`HelpCenterBrandingColors.secondaryColor`,
    // mapped to `branding.colors.accent` at the bootstrap boundary). If the
    // BE returns nothing — pre-v2 hubs, non-help-center hosts, fresh tenants
    // — we fall through to `DEFAULT_ACCENT`. The panel persists changes via
    // the same Relay mutation path that primary uses, so the picker's
    // `value` prop and the provider's `accentColor` here stay in lockstep
    // via the next bootstrap re-render. No FE-side state needed.
    const accentColor = branding?.colors?.accent ?? (0, $c7da5ed97c2620f2$export$74ca527397fc1422);
    const palette = (0, $d6c8448a36deb3c2$export$52531ed83ceae9ec)({
        primary: primaryColor,
        accent: accentColor
    });
    const primaryTextColor = (0, $cozmU.useMemo)(()=>$08727b03dc7c3907$var$readableHubTextColor(primaryColor), [
        primaryColor
    ]);
    const primaryLinkColor = (0, $cozmU.useMemo)(()=>(0, $65d6b82e468775dc$export$c1410db1c88d6e0f)(primaryColor).color900, [
        primaryColor
    ]);
    // Typography source of truth is the BE-persisted value, surfaced on
    // `branding.typography` at the bootstrap boundary. This is what makes the
    // help-seeker VIEW pages (homepage, profile, login, request list/details)
    // render the admin's chosen font — they read the same branding the editor
    // does. `setHubTypography` layers an in-session override on top for instant
    // edit-mode preview; the override is persisted on Publish via the branding
    // mutation (see action-bar), after which a bootstrap re-read makes the base
    // value match. View mode never calls the setter, so it always shows the
    // persisted value. Undefined (no BE value, no override) → HubTypographyScope
    // no-ops → Atlassian Sans default.
    const brandingTypography = branding?.typography;
    const [typographyOverride, setTypographyOverride] = (0, $cozmU.useState)(undefined);
    const typography = typographyOverride ?? brandingTypography;
    const setHubTypography = (0, $cozmU.useCallback)((next)=>{
        setTypographyOverride(next);
    }, []);
    const brandingSpaceDensity = branding?.spaceDensity;
    const [spaceDensityOverride, setSpaceDensityOverride] = (0, $cozmU.useState)(undefined);
    const spaceDensity = spaceDensityOverride ?? brandingSpaceDensity;
    const setSpaceDensity = (0, $cozmU.useCallback)((next_0)=>{
        setSpaceDensityOverride(next_0);
    }, []);
    // Corner radius source of truth is the BE-persisted value, surfaced on
    // `branding.cornerRadius` at the bootstrap boundary. `setHubCornerRadius`
    // layers an in-session override on top for instant edit-mode preview; the
    // override is persisted on Publish via the branding mutation. View mode
    // never calls the setter. Undefined / invalid → resolves to 8px default.
    const brandingCornerRadius = branding?.cornerRadius;
    const [cornerRadiusOverride, setCornerRadiusOverride] = (0, $cozmU.useState)(undefined);
    const cornerRadius = (0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride ?? brandingCornerRadius);
    const setHubCornerRadius = (0, $cozmU.useCallback)((next_1)=>{
        setCornerRadiusOverride(next_1);
    }, []);
    // Adoption denominator: fire once per hub load (view or edit) with the
    // persisted theming state, but only when advanced theming is enabled. The
    // provider mounts on every hub load via HubBootstrap, so this captures the
    // full installed base; deduped downstream by helpCenterAri.
    const hasFiredRenderedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRenderedRef.current || !isEnabled) return;
        if (!env?.helpCenterAri) return;
        hasFiredRenderedRef.current = true;
        // Flat analytics-bridge envelope (top-level `analyticsType`): this is the shape
        // help-center's analytics listener chain extracts and forwards to GAS v3. A nested
        // `{ type, data }` envelope resolves `analyticsType: undefined` and is silently
        // dropped on this host, so we mirror hub-home's `help_hub published` pattern.
        createAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'helpHubTheme',
            analyticsType: (0, $jYwtP.TRACK_EVENT_TYPE),
            attributes: {
                source: 'hubThemingProvider',
                helpCenterAri: env.helpCenterAri,
                helpCenterId: env.helpCenterId,
                hubType: hubType,
                isInPreviewMode: !!isInPreviewMode,
                ...(0, $290430c0b7ae0136$export$8173e092749d2f38)({
                    primaryColor: primaryColor,
                    accentColor: accentColor,
                    typography: typography,
                    cornerRadius: cornerRadius,
                    spaceDensity: spaceDensity
                })
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        env,
        hubType,
        isInPreviewMode,
        isEnabled,
        primaryColor,
        accentColor,
        typography,
        cornerRadius,
        spaceDensity
    ]);
    // `defaultParameters` and `brandBackgroundColorMap` deliberately split on
    // `isEnabled` so consumers (CommonHubExtensionsDependenciesProvider, the
    // extension config panels) can keep reading from `useHubTheming()` without
    // branching themselves. When the gate is OFF we restore the pre-v2 shape
    // exactly: legacy CSS-var refs in default params (consumed by
    // setHubBrandingStyle's writes) and a single-knownColor swatch grid built
    // from `branding.colors.primary` so the picker still shows the brand swatch.
    //
    // When ON, the wrapper div below emits `--hub-color-*` vars, and
    // `defaultParameters.backgroundColor` is a `var(--hub-color-primary-200)`
    // reference rather than a hex literal. The renderer drops the var ref into
    // inline style; the cascade resolves it against the wrapper. This means
    // brand-color edits trigger a CSS-only repaint — no React re-render in the
    // consumer is needed for the new color to apply.
    const defaultParameters = (0, $cozmU.useMemo)(()=>isEnabled ? // Gate ON: delegate to the shared resolver, passing the palette so
        // it returns `var(--hub-color-primary-200)` + the WCAG-readable
        // text color computed against that shade.
        {
            ...(0, $4pfdN.getHubDefaultParameters)({
                palette: palette
            }),
            textColor: primaryTextColor
        } : // Gate OFF: same resolver with no palette → legacy `var(--hub-*)`
        // chain that resolves against setHubBrandingStyle's writes on <html>.
        (0, $4pfdN.getHubDefaultParameters)(), [
        isEnabled,
        palette,
        primaryTextColor
    ]);
    // When ON: feed every shade of both palette families into the picker plus
    // universal white/black so the swatch grid surfaces all 22 colors.
    // When OFF: original single-color shape — knownColors holds the legacy
    // CSS-var string (matches master so the picker's strict-equality check
    // highlights the swatch for pre-v2 ADFs that store the same string).
    const brandBackgroundColorMap = (0, $cozmU.useMemo)(()=>isEnabled ? (0, $5tPGk.createBuiltInColorMap)({
            knownColors: [
                ...Object.values(palette),
                '#FFFFFF',
                '#000000'
            ]
        }) : (0, $5tPGk.createBuiltInColorMap)({
            knownColors: [
                defaultParameters.backgroundColor
            ]
        }), [
        isEnabled,
        palette,
        defaultParameters
    ]);
    // Border picker swatches: same 20 brand palette + 4 neutrals
    // (white, color.border, color.border.bold, black). We pass the resolved
    // hex values for color.border / color.border.bold so the swatches paint
    // correctly; admin-side translation back to the token reference happens
    // at picker-onChange time in the consumer (see border field code).
    const brandBorderColorMap = (0, $cozmU.useMemo)(()=>isEnabled ? (0, $5tPGk.createBuiltInColorMap)({
            knownColors: [
                ...Object.values(palette),
                '#FFFFFF',
                $08727b03dc7c3907$export$a6017cadbc9d9217,
                $08727b03dc7c3907$export$29b411f689221690,
                '#000000'
            ]
        }) : (0, $5tPGk.createBuiltInColorMap)({
            knownColors: [
                defaultParameters.backgroundColor
            ]
        }), [
        isEnabled,
        palette,
        defaultParameters
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            isAdvancedThemingEnabled: isEnabled,
            primaryColor: primaryColor,
            accentColor: accentColor,
            primaryTextColor: primaryTextColor,
            primaryLinkColor: primaryLinkColor,
            palette: palette,
            defaultParameters: defaultParameters,
            brandBackgroundColorMap: brandBackgroundColorMap,
            brandBorderColorMap: brandBorderColorMap,
            cornerRadius: cornerRadius,
            setHubCornerRadius: setHubCornerRadius,
            setHubTypography: setHubTypography,
            typography: typography,
            setSpaceDensity: setSpaceDensity,
            spaceDensity: spaceDensity
        }), [
        isEnabled,
        primaryColor,
        accentColor,
        primaryTextColor,
        primaryLinkColor,
        palette,
        defaultParameters,
        brandBackgroundColorMap,
        brandBorderColorMap,
        cornerRadius,
        setHubCornerRadius,
        setHubTypography,
        typography,
        setSpaceDensity,
        spaceDensity
    ]);
    // Wrapper div emits the entire palette as inline `style` so the 20
    // `--hub-color-*` custom properties land in the SSR HTML and resolve on
    // first paint — no useEffect, no `document.documentElement.setProperty`,
    // no flash of unthemed content. Everything inside the wrapper inherits the
    // vars through the normal CSS cascade.
    //
    // `display: contents` tells the browser to render the wrapper's children
    // but skip generating a box for the wrapper itself, so it is invisible to
    // flex/grid/positioning. Without it, the wrapper would introduce a
    // `display: block` box that could break ancestor layouts (extra flex item,
    // extra grid cell, broken percentage heights, etc.). We get CSS-var
    // scoping + a DOM marker for devtools without any layout side-effect.
    // The cascade still works — `display: contents` does not stop custom
    // properties from being inherited by descendants.
    //
    // Wrapper always emits the full palette + legacy vars, regardless of the
    // gate state. This matters when an admin edits under v2 ON and then toggles
    // the FF off — their persisted ADFs reference `--hub-color-primary-*` and
    // would resolve to `unset` (white) without the wrapper providing the vars.
    // Always emitting keeps a flag flip non-destructive while the resolver and
    // picker still gate their *behavior* on `isAdvancedThemingEnabled`.
    //
    // Legacy compat vars (`--hub-primary-color` / `--hub-primary-text-color` /
    // `--hub-primary-link-color`) are also always emitted so pre-v2 ADFs that
    // reference them render with the exact same colors as before the v2 flip
    // (the input hex verbatim, WCAG-readable text, and
    // `generateThemeBranding(...).color900` link tint). Matches
    // `setHubBrandingStyle`'s semantics so admins with already-customised hubs
    // see no visual change post-flip.
    const wrapperStyle = (0, $cozmU.useMemo)(()=>({
            display: 'contents',
            ...$08727b03dc7c3907$var$buildPaletteStyle(palette),
            [(0, $5KWZf.HUB_PRIMARY_COLOR_CSS_VAR)]: primaryColor,
            [(0, $5KWZf.HUB_PRIMARY_TEXT_COLOR_CSS_VAR)]: primaryTextColor,
            [(0, $5KWZf.HUB_PRIMARY_LINK_COLOR_CSS_VAR)]: primaryLinkColor,
            [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${cornerRadius}px`
        }), [
        palette,
        primaryColor,
        primaryTextColor,
        primaryLinkColor,
        cornerRadius
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($08727b03dc7c3907$var$HubThemingContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-hub-theme-root": "",
        style: wrapperStyle
    }, children));
};
/**
 * Build the inline-style object emitted on the wrapper div from the palette.
 * Returns 20 entries of the form `{ '--hub-color-primary-200': '#B3D4FF' }`.
 *
 * Kept outside the provider so the entry-set construction is testable in
 * isolation and not entangled with React rendering.
 */ const $08727b03dc7c3907$var$buildPaletteStyle = (palette)=>{
    const out = {};
    for (const ref of Object.keys(palette))out[(0, $hITUV.HUB_COLOR_CSS_VARS)[ref]] = palette[ref];
    return out;
};
const $08727b03dc7c3907$export$33bfea475043649c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($08727b03dc7c3907$var$HubThemingContext) ?? undefined;
} : ()=>{
    return (0, $cozmU.useContext)($08727b03dc7c3907$var$HubThemingContext) ?? undefined;
};
module.exports["useHubTheming"] = $08727b03dc7c3907$export$33bfea475043649c;

});

parcelRegister("5tPGk", function(module, exports) {

var $4yUlE = parcelRequire("4yUlE");


var $6T5Dk = parcelRequire("6T5Dk");

const $44dd98470329af47$export$37744bda14f72c19 = new Map([
    // background colors
    [
        "var(--ds-surface-overlay, #FFFFFF)".toLowerCase(),
        (0, $6T5Dk.colorNames).defaultWhite
    ],
    [
        "var(--ds-background-accent-blue-subtlest, #E9F2FE)".toLowerCase(),
        (0, $6T5Dk.colorNames).lightBlue
    ],
    [
        "var(--ds-background-accent-purple-subtlest, #F8EEFE)".toLowerCase(),
        (0, $6T5Dk.colorNames).lightPurple
    ],
    [
        "var(--ds-background-accent-magenta-subtlest, #FFECF8)".toLowerCase(),
        (0, $6T5Dk.colorNames).lightMagenta
    ],
    [
        "var(--ds-background-accent-red-subtlest, #FFECEB)".toLowerCase(),
        (0, $6T5Dk.colorNames).lightRed
    ],
    [
        "var(--ds-background-accent-orange-subtlest, #FFF5DB)".toLowerCase(),
        (0, $6T5Dk.colorNames).lightOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtlest, #FEF7C8)".toLowerCase(),
        (0, $6T5Dk.colorNames).lightYellow
    ],
    [
        "var(--ds-background-accent-lime-subtlest, #EFFFD6)".toLowerCase(),
        (0, $6T5Dk.colorNames).lightLime
    ],
    [
        "var(--ds-background-accent-green-subtlest, #DCFFF1)".toLowerCase(),
        (0, $6T5Dk.colorNames).lightGreen
    ],
    [
        "var(--ds-background-accent-teal-subtlest, #E7F9FF)".toLowerCase(),
        (0, $6T5Dk.colorNames).lightTeal
    ],
    [
        "var(--ds-background-accent-gray-subtler, #DDDEE1)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtleGray
    ],
    [
        "var(--ds-background-accent-blue-subtler, #CFE1FD)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtleBlue
    ],
    [
        "var(--ds-background-accent-purple-subtler, #EED7FC)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtlePurple
    ],
    [
        "var(--ds-background-accent-magenta-subtler, #FDD0EC)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtleMagenta
    ],
    [
        "var(--ds-background-accent-red-subtler, #FFD5D2)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtleRed
    ],
    [
        "var(--ds-background-accent-orange-subtler, #FCE4A6)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtleOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtler, #F5E989)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtleYellow
    ],
    [
        "var(--ds-background-accent-lime-subtler, #D3F1A7)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtleLime
    ],
    [
        "var(--ds-background-accent-green-subtler, #BAF3DB)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtleGreen
    ],
    [
        "var(--ds-background-accent-teal-subtler, #C6EDFB)".toLowerCase(),
        (0, $6T5Dk.colorNames).subtleTeal
    ],
    [
        "var(--ds-background-accent-gray-subtle, #8C8F97)".toLowerCase(),
        (0, $6T5Dk.colorNames).gray
    ],
    [
        "var(--ds-background-accent-blue-subtle, #669DF1)".toLowerCase(),
        (0, $6T5Dk.colorNames).blue
    ],
    [
        "var(--ds-background-accent-purple-subtle, #C97CF4)".toLowerCase(),
        (0, $6T5Dk.colorNames).purple
    ],
    [
        "var(--ds-background-accent-magenta-subtle, #E774BB)".toLowerCase(),
        (0, $6T5Dk.colorNames).magenta
    ],
    [
        "var(--ds-background-accent-red-subtle, #F87168)".toLowerCase(),
        (0, $6T5Dk.colorNames).red
    ],
    [
        "var(--ds-background-accent-orange-subtle, #FCA700)".toLowerCase(),
        (0, $6T5Dk.colorNames).orange
    ],
    [
        "var(--ds-background-accent-yellow-subtle, #EED12B)".toLowerCase(),
        (0, $6T5Dk.colorNames).yellow
    ],
    [
        "var(--ds-background-accent-lime-subtle, #94C748)".toLowerCase(),
        (0, $6T5Dk.colorNames).lime
    ],
    [
        "var(--ds-background-accent-green-subtle, #4BCE97)".toLowerCase(),
        (0, $6T5Dk.colorNames).green
    ],
    [
        "var(--ds-background-accent-teal-subtle, #6CC3E0)".toLowerCase(),
        (0, $6T5Dk.colorNames).teal
    ],
    [
        "var(--ds-text-brand, #1868DB)".toLowerCase(),
        (0, $6T5Dk.colorNames).defaultBlue
    ],
    [
        "var(--ds-background-accent-gray-bolder, #6B6E76)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldGray
    ],
    [
        "var(--ds-background-accent-blue-bolder, #1868DB)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldBlue
    ],
    [
        "var(--ds-background-accent-purple-bolder, #964AC0)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldPurple
    ],
    [
        "var(--ds-background-accent-magenta-bolder, #AE4787)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldMagenta
    ],
    [
        "var(--ds-background-accent-red-bolder, #C9372C)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldRed
    ],
    [
        "var(--ds-background-accent-orange-bolder, #BD5B00)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldOrange
    ],
    [
        "var(--ds-background-accent-yellow-bolder, #946F00)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldYellow
    ],
    [
        "var(--ds-background-accent-lime-bolder, #5B7F24)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldLime
    ],
    [
        "var(--ds-background-accent-green-bolder, #1F845A)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldGreen
    ],
    [
        "var(--ds-background-accent-teal-bolder, #227D9B)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldTeal
    ],
    // text colors
    [
        "var(--ds-text, #292A2E)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldGray
    ],
    [
        "var(--ds-text-accent-blue-bolder, #123263)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldBlue
    ],
    [
        "var(--ds-text-accent-purple-bolder, #48245D)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldPurple
    ],
    [
        "var(--ds-text-accent-magenta-bolder, #50253F)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldMagenta
    ],
    [
        "var(--ds-text-accent-red-bolder, #5D1F1A)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldRed
    ],
    [
        "var(--ds-text-accent-orange-bolder, #693200)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldOrange
    ],
    [
        "var(--ds-text-accent-yellow-bolder, #533F04)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldYellow
    ],
    [
        "var(--ds-text-accent-lime-bolder, #37471F)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldLime
    ],
    [
        "var(--ds-text-accent-green-bolder, #164B35)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldGreen
    ],
    [
        "var(--ds-text-accent-teal-bolder, #164555)".toLowerCase(),
        (0, $6T5Dk.colorNames).boldTeal
    ],
    [
        "var(--ds-text-subtle, #505258)".toLowerCase(),
        (0, $6T5Dk.colorNames).gray
    ],
    [
        "var(--ds-text-accent-blue, #1558BC)".toLowerCase(),
        (0, $6T5Dk.colorNames).blue
    ],
    [
        "var(--ds-text-accent-purple, #803FA5)".toLowerCase(),
        (0, $6T5Dk.colorNames).purple
    ],
    [
        "var(--ds-text-accent-magenta, #943D73)".toLowerCase(),
        (0, $6T5Dk.colorNames).magenta
    ],
    [
        "var(--ds-text-accent-red, #AE2E24)".toLowerCase(),
        (0, $6T5Dk.colorNames).red
    ],
    [
        "var(--ds-text-accent-orange, #9E4C00)".toLowerCase(),
        (0, $6T5Dk.colorNames).orange
    ],
    [
        "var(--ds-text-accent-yellow, #7F5F01)".toLowerCase(),
        (0, $6T5Dk.colorNames).yellow
    ],
    [
        "var(--ds-text-accent-lime, #4C6B1F)".toLowerCase(),
        (0, $6T5Dk.colorNames).lime
    ],
    [
        "var(--ds-text-accent-green, #216E4E)".toLowerCase(),
        (0, $6T5Dk.colorNames).green
    ],
    [
        "var(--ds-text-accent-teal, #206A83)".toLowerCase(),
        (0, $6T5Dk.colorNames).teal
    ],
    [
        "var(--ds-text-inverse, #FFFFFF)".toLowerCase(),
        (0, $6T5Dk.colorNames).white
    ],
    // border colors
    [
        "var(--ds-border-accent-blue, #357DE8)".toLowerCase(),
        (0, $6T5Dk.colorNames).blue
    ],
    [
        "var(--ds-border-accent-purple, #AF59E1)".toLowerCase(),
        (0, $6T5Dk.colorNames).purple
    ],
    [
        "var(--ds-border-accent-magenta, #CD519D)".toLowerCase(),
        (0, $6T5Dk.colorNames).magenta
    ],
    [
        "var(--ds-border-accent-red, #E2483D)".toLowerCase(),
        (0, $6T5Dk.colorNames).red
    ],
    [
        "var(--ds-border-accent-orange, #E06C00)".toLowerCase(),
        (0, $6T5Dk.colorNames).orange
    ],
    [
        "var(--ds-border-accent-yellow, #B38600)".toLowerCase(),
        (0, $6T5Dk.colorNames).yellow
    ],
    [
        "var(--ds-border-accent-lime, #6A9A23)".toLowerCase(),
        (0, $6T5Dk.colorNames).lime
    ],
    [
        "var(--ds-border-accent-green, #22A06B)".toLowerCase(),
        (0, $6T5Dk.colorNames).green
    ],
    [
        "var(--ds-border-accent-teal, #2898BD)".toLowerCase(),
        (0, $6T5Dk.colorNames).teal
    ],
    [
        "var(--ds-border-inverse, #FFFFFF)".toLowerCase(),
        (0, $6T5Dk.colorNames).white
    ],
    [
        "var(--ds-border-accent-gray, #7D818A)".toLowerCase(),
        (0, $6T5Dk.colorNames).gray
    ]
]);


const $efb58e0aab77ee88$export$a4af15b2fa34f34e = ({ knownColors: knownColors, allColors: allColors, humanReadableColors: humanReadableColors, getResponsiveColor: getResponsiveColor })=>{
    knownColors = knownColors.map((color)=>color.toLowerCase());
    const knownTokens = knownColors.map((color)=>(0, $4yUlE.extractToken)(color));
    if (!allColors) allColors = knownColors;
    else allColors = allColors.map((color)=>color.toLowerCase());
    const allTokens = allColors.map((color)=>(0, $4yUlE.extractToken)(color));
    const humanReadableColorsMap = humanReadableColors ? new Map([
        ...(0, $44dd98470329af47$export$37744bda14f72c19).entries(),
        ...humanReadableColors.entries()
    ]) : (0, $44dd98470329af47$export$37744bda14f72c19);
    return {
        knownColors: knownColors,
        knownTokens: knownTokens,
        allColors: allColors,
        allTokens: allTokens,
        humanReadableColors: humanReadableColorsMap,
        getResponsiveColor: getResponsiveColor || ((color)=>color)
    };
};
module.exports["createBuiltInColorMap"] = $efb58e0aab77ee88$export$a4af15b2fa34f34e;

});

parcelRegister("4yUlE", function(module, exports) {

var $3McNX = parcelRequire("3McNX");

/* regular expressions obtained from CssColourValidator.java
 * CssColourValidator runs in legacy Color Scheme on updateSiteLookAndFeel mutation
 * instead of validating on Save, we are now validating as user enters custom input
 */ const $443b8215fbaa9c50$var$VAR_MATCH = new RegExp('^var\\((\\-\\-[a-zA-Z0-9\\-_]+)\\s*(,(.+))?\\)$');
const $443b8215fbaa9c50$var$SHORT_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){3}$');
const $443b8215fbaa9c50$var$LONG_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){6}$');
const $443b8215fbaa9c50$var$RGB_MATCH = new RegExp('^rgb\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*\\)$');
const $443b8215fbaa9c50$var$PERC_MATCH = new RegExp('^rgb\\((\\d+)%,\\s*(\\d+)%,\\s*(\\d+)%\\)$');
const $443b8215fbaa9c50$var$RGBA_MATCH = new RegExp('^rgba\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*((0.[0-9]*)|[01])\\s*\\)$');
const $443b8215fbaa9c50$var$HSL_MATCH = new RegExp('^hsl\\(\\s*(0|[1-9]\\d?|[12]\\d\\d|3[0-5]\\d)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*\\)$');
/* evaluates validity for any incoming colors from 1) siteConfiguration query 2) custom input field
 * until hsla and named color conversion errors are handled properly in app-navigation, we return the default Atlassian theme as in getSanitizedColor fn
 * it is an existing pattern under useNavigationTheme to return the theme as means of error handling
 * once resolved, this isValidColor can validate for HSLA_MATCH and NAMED_COLOR_MATCH
 */ function $443b8215fbaa9c50$var$isValidVarColor(color) {
    const matches = $443b8215fbaa9c50$var$VAR_MATCH.exec(color);
    if (matches) {
        const fallback = matches[3]?.trim();
        if (fallback) {
            // If fallback is another var() call, validate it recursively
            if (fallback.startsWith('var(')) return $443b8215fbaa9c50$var$isValidVarColor(fallback);
            // Otherwise validate as a regular color
            return $443b8215fbaa9c50$export$35fa9d266cdb6f09(fallback, false);
        }
        // If there's a comma but no fallback (like "var(--token, )"), it's invalid
        if (matches[2] && !fallback) return false;
        return true;
    }
    return false;
}
function $443b8215fbaa9c50$export$35fa9d266cdb6f09(color, isVarColorAllowed = true) {
    return isVarColorAllowed && $443b8215fbaa9c50$var$isValidVarColor(color) || $443b8215fbaa9c50$var$SHORT_NUMERIC_MATCH.test(color) || $443b8215fbaa9c50$var$LONG_NUMERIC_MATCH.test(color) || $443b8215fbaa9c50$var$RGB_MATCH.test(color) || $443b8215fbaa9c50$var$PERC_MATCH.test(color) || $443b8215fbaa9c50$var$RGBA_MATCH.test(color) || $443b8215fbaa9c50$var$HSL_MATCH.test(color);
}
function $443b8215fbaa9c50$export$b2b344a3caf230bf(color) {
    if (!$443b8215fbaa9c50$export$35fa9d266cdb6f09(color)) return (0, $3McNX.default)('invalid');
    const colorCode = $443b8215fbaa9c50$var$extractColorCode(color);
    return (0, $3McNX.default)(colorCode);
}
/* simply extracts the color code from given color string.
 * If color is tokenized, either computes or extracts fallback hex value
 * Else return color as is
 */ function $443b8215fbaa9c50$var$extractColorCode(color) {
    const matches = $443b8215fbaa9c50$var$VAR_MATCH.exec(color);
    if (matches) {
        const fallback = matches[3]?.trim();
        const token = matches[1].toLowerCase();
        // SSR guard
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            const compiledTokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
            // If we have a computed value, return it
            if (compiledTokenValue) return compiledTokenValue;
        }
        // If there's a fallback, process it recursively
        if (fallback) {
            // If fallback is another var() call, extract from it recursively
            if (fallback.startsWith('var(')) return $443b8215fbaa9c50$var$extractColorCode(fallback);
            // Otherwise return the fallback as is
            return fallback;
        }
        // No computed value and no fallback
        return '';
    }
    return color;
}
function $443b8215fbaa9c50$export$5039139b891079e8(color = '') {
    const matches = $443b8215fbaa9c50$var$VAR_MATCH.exec(color);
    return matches?.[1].toLowerCase() ?? color;
}
function $443b8215fbaa9c50$export$d16dc80c78f978b3({ allColors: allColors, allTokens: allTokens, knownColors: knownColors }, color = '') {
    const index = allTokens.indexOf($443b8215fbaa9c50$export$5039139b891079e8(color));
    if (index !== -1) return allColors[index];
    if (!$443b8215fbaa9c50$export$35fa9d266cdb6f09(color)) return knownColors[0];
    return color;
}
function $443b8215fbaa9c50$export$342249704b28d862(color) {
    const converted = $443b8215fbaa9c50$export$b2b344a3caf230bf(color);
    if (converted.isValid()) return converted.toHexString();
    return color;
}
function $443b8215fbaa9c50$export$3fe5b5ca1e6a6a28(backgroundColor, highlightColor) {
    const backgroundCode = $443b8215fbaa9c50$var$extractColorCode(backgroundColor);
    const highlightCode = $443b8215fbaa9c50$var$extractColorCode(highlightColor);
    return (0, $3McNX.default).isReadable(backgroundCode, highlightCode);
}
function $443b8215fbaa9c50$export$21e0b327e0d86beb(color) {
    color = $443b8215fbaa9c50$var$extractColorCode(color);
    return (0, $3McNX.default).mostReadable(color, [
        '#000000',
        '#ffffff'
    ]).toHexString();
}
function $443b8215fbaa9c50$export$bf60f520e1f9cbf8(color1, color2) {
    return $443b8215fbaa9c50$var$extractColorCode(color1) === $443b8215fbaa9c50$var$extractColorCode(color2);
}
module.exports["isValidColor"] = $443b8215fbaa9c50$export$35fa9d266cdb6f09;
module.exports["convertLegacyColor"] = $443b8215fbaa9c50$export$b2b344a3caf230bf;
module.exports["extractToken"] = $443b8215fbaa9c50$export$5039139b891079e8;
module.exports["getSanitizedColor"] = $443b8215fbaa9c50$export$d16dc80c78f978b3;
module.exports["toHexColor"] = $443b8215fbaa9c50$export$342249704b28d862;
module.exports["isReadable"] = $443b8215fbaa9c50$export$3fe5b5ca1e6a6a28;
module.exports["getMostReadableColor"] = $443b8215fbaa9c50$export$21e0b327e0d86beb;

});

parcelRegister("6T5Dk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $558b766401440a55$export$88bbe6beac980300 = (0, $kSwu1.defineMessages)({
    defaultWhite: {
        id: "company-hub.color-picker.default-white",
        defaultMessage: "Default white"
    },
    white: {
        id: "company-hub.color-picker.white",
        defaultMessage: "White"
    },
    lightGray: {
        id: "company-hub.color-picker.light-gray",
        defaultMessage: "Light gray"
    },
    lightBlue: {
        id: "company-hub.color-picker.light-blue",
        defaultMessage: "Light blue"
    },
    lightPurple: {
        id: "company-hub.color-picker.light-purple",
        defaultMessage: "Light purple"
    },
    lightMagenta: {
        id: "company-hub.color-picker.light-magenta",
        defaultMessage: "Light magenta"
    },
    lightRed: {
        id: "company-hub.color-picker.light-red",
        defaultMessage: "Light red"
    },
    lightOrange: {
        id: "company-hub.color-picker.light-orange",
        defaultMessage: "Light orange"
    },
    lightYellow: {
        id: "company-hub.color-picker.light-yellow",
        defaultMessage: "Light yellow"
    },
    lightLime: {
        id: "company-hub.color-picker.light-lime",
        defaultMessage: "Light lime"
    },
    lightGreen: {
        id: "company-hub.color-picker.light-green",
        defaultMessage: "Light green"
    },
    lightTeal: {
        id: "company-hub.color-picker.light-teal",
        defaultMessage: "Light teal"
    },
    subtleGray: {
        id: "company-hub.color-picker.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    subtleBlue: {
        id: "company-hub.color-picker.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    subtlePurple: {
        id: "company-hub.color-picker.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    subtleMagenta: {
        id: "company-hub.color-picker.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    subtleRed: {
        id: "company-hub.color-picker.subtle-red",
        defaultMessage: "Subtle red"
    },
    subtleOrange: {
        id: "company-hub.color-picker.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    subtleYellow: {
        id: "company-hub.color-picker.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    subtleLime: {
        id: "company-hub.color-picker.subtle-lime",
        defaultMessage: "Subtle lime"
    },
    subtleGreen: {
        id: "company-hub.color-picker.subtle-green",
        defaultMessage: "Subtle green"
    },
    subtleTeal: {
        id: "company-hub.color-picker.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    gray: {
        id: "company-hub.color-picker.gray",
        defaultMessage: "Gray"
    },
    blue: {
        id: "company-hub.color-picker.blue",
        defaultMessage: "Blue"
    },
    purple: {
        id: "company-hub.color-picker.purple",
        defaultMessage: "Purple"
    },
    magenta: {
        id: "company-hub.color-picker.magenta",
        defaultMessage: "Magenta"
    },
    red: {
        id: "company-hub.color-picker.red",
        defaultMessage: "Red"
    },
    orange: {
        id: "company-hub.color-picker.orange",
        defaultMessage: "Orange"
    },
    yellow: {
        id: "company-hub.color-picker.yellow",
        defaultMessage: "Yellow"
    },
    lime: {
        id: "company-hub.color-picker.lime",
        defaultMessage: "Lime"
    },
    green: {
        id: "company-hub.color-picker.green",
        defaultMessage: "Green"
    },
    teal: {
        id: "company-hub.color-picker.teal",
        defaultMessage: "Teal"
    },
    boldGray: {
        id: "company-hub.color-picker.bold-gray",
        defaultMessage: "Bold gray"
    },
    boldBlue: {
        id: "company-hub.color-picker.bold-blue",
        defaultMessage: "Bold blue"
    },
    boldPurple: {
        id: "company-hub.color-picker.bold-purple",
        defaultMessage: "Bold purple"
    },
    boldMagenta: {
        id: "company-hub.color-picker.bold-magenta",
        defaultMessage: "Bold magenta"
    },
    boldRed: {
        id: "company-hub.color-picker.bold-red",
        defaultMessage: "Bold red"
    },
    boldOrange: {
        id: "company-hub.color-picker.bold-orange",
        defaultMessage: "Bold orange"
    },
    boldYellow: {
        id: "company-hub.color-picker.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    boldLime: {
        id: "company-hub.color-picker.bold-lime",
        defaultMessage: "Bold lime"
    },
    boldGreen: {
        id: "company-hub.color-picker.bold-green",
        defaultMessage: "Bold green"
    },
    boldTeal: {
        id: "company-hub.color-picker.bold-teal",
        defaultMessage: "Bold teal"
    },
    defaultBlue: {
        id: "company-hub.color-picker.default-blue",
        defaultMessage: "Default blue"
    }
});
module.exports["colorNames"] = $558b766401440a55$export$88bbe6beac980300;

});

parcelRegister("h2czO", function(module, exports) {
//      
// @private
function $287fe1c65d5eed0f$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
//      
var $287fe1c65d5eed0f$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $287fe1c65d5eed0f$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return '' + acc + $287fe1c65d5eed0f$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
    return property === joinedProperty ? '' + property + position : joinedProperty;
}
function $287fe1c65d5eed0f$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$287fe1c65d5eed0f$var$generateProperty(property, $287fe1c65d5eed0f$var$positionMap[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $287fe1c65d5eed0f$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === undefined ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === undefined ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === undefined ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $287fe1c65d5eed0f$var$generateStyles(property, valuesWithDefaults);
}
//      
function $287fe1c65d5eed0f$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
//      
/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $287fe1c65d5eed0f$export$ef04e38dc423904(value) {
    var unitlessValue = parseFloat(value);
    if (isNaN(unitlessValue)) return value;
    return unitlessValue;
}
//      
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $287fe1c65d5eed0f$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$287fe1c65d5eed0f$var$endsWith(pxval, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
            newPxval = $287fe1c65d5eed0f$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$287fe1c65d5eed0f$var$endsWith(base, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
            newBase = $287fe1c65d5eed0f$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
        if (typeof newBase === 'string') throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
        return '' + newPxval / newBase + to;
    };
};
//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $287fe1c65d5eed0f$export$c63c6f932822f543 = /*#__PURE__*/ $287fe1c65d5eed0f$var$pxtoFactory('em');
//      
var $287fe1c65d5eed0f$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $287fe1c65d5eed0f$export$c82a8a23c9e8bdb6(steps) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';
    if (typeof steps !== 'number') throw new Error('Please provide a number of steps to the modularScale helper.');
    if (typeof ratio === 'string' && !$287fe1c65d5eed0f$var$ratioNames[ratio]) throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
    var realBase = typeof base === 'string' ? $287fe1c65d5eed0f$export$ef04e38dc423904(base) : base;
    var realRatio = typeof ratio === 'string' ? $287fe1c65d5eed0f$var$ratioNames[ratio] : ratio;
    if (typeof realBase === 'string') throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
    return realBase * Math.pow(realRatio, steps) + 'em';
}
//      
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $287fe1c65d5eed0f$export$fb1897a40d146f7f = /*#__PURE__*/ $287fe1c65d5eed0f$var$pxtoFactory('rem');
//      
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $287fe1c65d5eed0f$export$8c467e8859fdef13() {
    var _ref;
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';
    var pseudoSelector = parent + '::after';
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
//      
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $287fe1c65d5eed0f$export$a5b94313d6908893() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
    return {
        display: 'inline-block',
        maxWidth: width,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
}
//      
/** */ function $287fe1c65d5eed0f$var$generateFileReferences(fontFilePath, fileFormats) {
    var fileFontReferences = fileFormats.map(function(format) {
        return 'url("' + fontFilePath + '.' + format + '")';
    });
    return fileFontReferences.join(', ');
}
function $287fe1c65d5eed0f$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return 'local("' + font + '")';
    });
    return localFontReferences.join(', ');
}
function $287fe1c65d5eed0f$var$generateSources(fontFilePath, localFonts, fileFormats) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($287fe1c65d5eed0f$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($287fe1c65d5eed0f$var$generateFileReferences(fontFilePath, fileFormats));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $287fe1c65d5eed0f$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === undefined ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, localFonts = _ref.localFonts, unicodeRange = _ref.unicodeRange;
    // Error Handling
    if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
    if (!fontFilePath && !localFonts) throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
    if (localFonts && !Array.isArray(localFonts)) throw new Error('fontFace expects localFonts to be an array.');
    if (!Array.isArray(fileFormats)) throw new Error('fontFace expects fileFormats to be an array.');
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $287fe1c65d5eed0f$var$generateSources(fontFilePath, localFonts, fileFormats),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight
        }
    };
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
//      
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $287fe1c65d5eed0f$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
//      
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $287fe1c65d5eed0f$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
//      
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $287fe1c65d5eed0f$export$e79006618d7c6cc3() {
    var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
var $287fe1c65d5eed0f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $287fe1c65d5eed0f$var$taggedTemplateLiteralLoose = function(strings, raw) {
    strings.raw = raw;
    return strings;
};
var $287fe1c65d5eed0f$var$_opinionatedRules;
var $287fe1c65d5eed0f$var$_abbrTitle;
var $287fe1c65d5eed0f$var$_unopinionatedRules;
//      
var $287fe1c65d5eed0f$var$opinionatedRules = ($287fe1c65d5eed0f$var$_opinionatedRules = {
    html: {
        fontFamily: 'sans-serif'
    },
    body: {
        margin: '0'
    }
}, $287fe1c65d5eed0f$var$_opinionatedRules['a:active,\n  a:hover'] = {
    outlineWidth: '0'
}, $287fe1c65d5eed0f$var$_opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    fontFamily: 'sans-serif',
    fontSize: '100%',
    lineHeight: '1.15'
}, $287fe1c65d5eed0f$var$_opinionatedRules);
var $287fe1c65d5eed0f$var$unopinionatedRules = ($287fe1c65d5eed0f$var$_unopinionatedRules = {
    html: {
        lineHeight: '1.15',
        textSizeAdjust: '100%'
    }
}, $287fe1c65d5eed0f$var$_unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
    display: 'block'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.h1 = {
    fontSize: '2em',
    margin: '0.67em 0'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['figcaption,\n  figure,\n  main'] = {
    display: 'block'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.figure = {
    margin: '1em 40px'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.hr = {
    boxSizing: 'content-box',
    height: '0',
    overflow: 'visible'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.pre = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.a = {
    'background-color': 'transparent',
    '-webkit-text-decoration-skip': 'objects'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['abbr[title]'] = ($287fe1c65d5eed0f$var$_abbrTitle = {
    borderBottom: 'none',
    textDecoration: 'underline'
}, $287fe1c65d5eed0f$var$_abbrTitle['textDecoration'] = 'underline dotted', $287fe1c65d5eed0f$var$_abbrTitle), $287fe1c65d5eed0f$var$_unopinionatedRules['b,\n  strong'] = {
    fontWeight: 'inherit'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['code,\n  kbd,\n  samp'] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.dfn = {
    fontStyle: 'italic'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.mark = {
    backgroundColor: '#ff0',
    color: '#000'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.small = {
    fontSize: '80%'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['sub,\n  sup'] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.sub = {
    bottom: '-0.25em'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.sup = {
    top: '-0.5em'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['audio,\n  video'] = {
    display: 'inline-block'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['audio:not([controls])'] = {
    display: 'none',
    height: '0'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.img = {
    borderStyle: 'none'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['svg:not(:root)'] = {
    overflow: 'hidden'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    margin: '0'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['button,\n  input'] = {
    overflow: 'visible'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['button,\n  select'] = {
    textTransform: 'none'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
    '-webkit-appearance': 'button'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
    borderStyle: 'none',
    padding: '0'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
    outline: '1px dotted ButtonText'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.fieldset = {
    border: '1px solid #c0c0c0',
    margin: '0 2px',
    padding: '0.35em 0.625em 0.75em'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.progress = {
    display: 'inline-block',
    verticalAlign: 'baseline'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.textarea = {
    overflow: 'auto'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
    boxSizing: 'border-box',
    padding: '0'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
    height: 'auto'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['[type="search"]'] = {
    '-webkit-appearance': 'textfield',
    outlineOffset: '-2px'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
    '-webkit-appearance': 'none'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['::-webkit-file-upload-button'] = {
    '-webkit-appearance': 'button',
    font: 'inherit'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['details,\n  menu'] = {
    display: 'block'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.summary = {
    display: 'list-item'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.canvas = {
    display: 'inline-block'
}, $287fe1c65d5eed0f$var$_unopinionatedRules.template = {
    display: 'none'
}, $287fe1c65d5eed0f$var$_unopinionatedRules['[hidden]'] = {
    display: 'none'
}, $287fe1c65d5eed0f$var$_unopinionatedRules);
function $287fe1c65d5eed0f$var$mergeRules(baseRules, additionalRules) {
    var mergedRules = $287fe1c65d5eed0f$var$_extends({}, baseRules);
    Object.keys(additionalRules).forEach(function(key) {
        if (mergedRules[key]) mergedRules[key] = $287fe1c65d5eed0f$var$_extends({}, mergedRules[key], additionalRules[key]);
        else mergedRules[key] = $287fe1c65d5eed0f$var$_extends({}, additionalRules[key]);
    });
    return mergedRules;
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $287fe1c65d5eed0f$export$a3295358bff77e(excludeOpinionated) {
    if (excludeOpinionated) return $287fe1c65d5eed0f$var$unopinionatedRules;
    return $287fe1c65d5eed0f$var$mergeRules($287fe1c65d5eed0f$var$unopinionatedRules, $287fe1c65d5eed0f$var$opinionatedRules);
}
//      
/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */ function $287fe1c65d5eed0f$export$c7187bbd1a7a9244(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
    return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = $287fe1c65d5eed0f$var$_extends({}, styles), _ref[parent + ':-moz-placeholder'] = $287fe1c65d5eed0f$var$_extends({}, styles), _ref[parent + '::-moz-placeholder'] = $287fe1c65d5eed0f$var$_extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = $287fe1c65d5eed0f$var$_extends({}, styles), _ref;
}
var $287fe1c65d5eed0f$var$_templateObject = /*#__PURE__*/ $287fe1c65d5eed0f$var$taggedTemplateLiteralLoose([
    'radial-gradient(',
    '',
    '',
    '',
    ')'
], [
    'radial-gradient(',
    '',
    '',
    '',
    ')'
]);
//      
/** */ function $287fe1c65d5eed0f$var$parseFallback(colorStops) {
    return colorStops[0].split(' ')[0];
}
function $287fe1c65d5eed0f$var$constructGradientValue(literals) {
    var template = '';
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        // Adds leading coma if properties preceed color-stops
        if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
            template = template.slice(0, -1);
            template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        // No trailing space if color-stops is the only param provided
        } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
    return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $287fe1c65d5eed0f$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, extent = _ref.extent, fallback = _ref.fallback, position = _ref.position, shape = _ref.shape;
    if (!colorStops || colorStops.length < 2) throw new Error('radialGradient requries at least 2 color-stops to properly render.');
    return {
        backgroundColor: fallback || $287fe1c65d5eed0f$var$parseFallback(colorStops),
        backgroundImage: $287fe1c65d5eed0f$var$constructGradientValue($287fe1c65d5eed0f$var$_templateObject, position, shape, extent, colorStops.join(', '))
    };
}
//      
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $287fe1c65d5eed0f$export$19389033401d366a(filename, backgroundSize) {
    var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';
    var _ref;
    var retinaFilename = arguments[3];
    var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';
    if (!filename) throw new Error('Please supply a filename to retinaImage() as the first argument.');
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;
    return _ref = {
        backgroundImage: 'url(' + filename + '.' + ext + ')'
    }, _ref[$287fe1c65d5eed0f$export$e79006618d7c6cc3()] = {
        backgroundImage: 'url(' + rFilename + ')',
        backgroundSize: backgroundSize
    }, _ref;
}
//      
/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */ function $287fe1c65d5eed0f$export$7c69810f7b8835c9(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return _ref = {}, _ref[parent + '::-moz-selection'] = $287fe1c65d5eed0f$var$_extends({}, styles), _ref[parent + '::selection'] = $287fe1c65d5eed0f$var$_extends({}, styles), _ref;
}
//      
/* eslint-disable key-spacing */ var $287fe1c65d5eed0f$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
function $287fe1c65d5eed0f$export$61210fa83792a81(timingFunction) {
    return $287fe1c65d5eed0f$var$functionsMap[timingFunction];
}
//      
/** */ var $287fe1c65d5eed0f$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    switch(pointingDirection){
        case 'top':
            return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
        case 'left':
            return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
        case 'bottom':
            return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
        case 'right':
            return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';
        default:
            throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
    }
};
// needed for border-color
var $287fe1c65d5eed0f$var$reverseDirection = {
    left: 'Right',
    right: 'Left',
    top: 'Bottom',
    bottom: 'Top'
};
function $287fe1c65d5eed0f$export$9eed783d03e0135c(_ref) {
    var _ref2;
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;
    var unitlessHeight = parseFloat(height);
    var unitlessWidth = parseFloat(width);
    if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
    return _ref2 = {
        borderColor: backgroundColor,
        width: '0',
        height: '0',
        borderWidth: $287fe1c65d5eed0f$var$getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
        borderStyle: 'solid'
    }, _ref2['border' + $287fe1c65d5eed0f$var$reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}
//      
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $287fe1c65d5eed0f$export$dca3d8ad656c34d2() {
    var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
//      
function $287fe1c65d5eed0f$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $287fe1c65d5eed0f$var$convertToInt(red, green, blue) {
    return $287fe1c65d5eed0f$var$colorToInt(red) + "," + $287fe1c65d5eed0f$var$colorToInt(green) + "," + $287fe1c65d5eed0f$var$colorToInt(blue);
}
function $287fe1c65d5eed0f$var$hslToRgb(hue, saturation, lightness) {
    var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $287fe1c65d5eed0f$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = hue % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
//      
var $287fe1c65d5eed0f$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
function $287fe1c65d5eed0f$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $287fe1c65d5eed0f$var$namedColorMap[normalizedColorName] ? '#' + $287fe1c65d5eed0f$var$namedColorMap[normalizedColorName] : color;
}
//      
var $287fe1c65d5eed0f$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $287fe1c65d5eed0f$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $287fe1c65d5eed0f$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $287fe1c65d5eed0f$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var $287fe1c65d5eed0f$var$hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var $287fe1c65d5eed0f$var$hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $287fe1c65d5eed0f$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    var normalizedColor = $287fe1c65d5eed0f$var$nameToHex(color);
    if (normalizedColor.match($287fe1c65d5eed0f$var$hexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($287fe1c65d5eed0f$var$reducedHexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
    var rgbMatched = $287fe1c65d5eed0f$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt('' + rgbMatched[1], 10),
        green: parseInt('' + rgbMatched[2], 10),
        blue: parseInt('' + rgbMatched[3], 10)
    };
    var rgbaMatched = $287fe1c65d5eed0f$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatched) return {
        red: parseInt('' + rgbaMatched[1], 10),
        green: parseInt('' + rgbaMatched[2], 10),
        blue: parseInt('' + rgbaMatched[3], 10),
        alpha: parseFloat('' + rgbaMatched[4])
    };
    var hslMatched = $287fe1c65d5eed0f$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt('' + hslMatched[1], 10);
        var saturation = parseInt('' + hslMatched[2], 10) / 100;
        var lightness = parseInt('' + hslMatched[3], 10) / 100;
        var rgbColorString = 'rgb(' + $287fe1c65d5eed0f$var$hslToRgb(hue, saturation, lightness) + ')';
        var hslRgbMatched = $287fe1c65d5eed0f$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
        return {
            red: parseInt('' + hslRgbMatched[1], 10),
            green: parseInt('' + hslRgbMatched[2], 10),
            blue: parseInt('' + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $287fe1c65d5eed0f$var$hslaRegex.exec(normalizedColor);
    if (hslaMatched) {
        var _hue = parseInt('' + hslaMatched[1], 10);
        var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
        var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
        var _rgbColorString = 'rgb(' + $287fe1c65d5eed0f$var$hslToRgb(_hue, _saturation, _lightness) + ')';
        var _hslRgbMatched = $287fe1c65d5eed0f$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
        return {
            red: parseInt('' + _hslRgbMatched[1], 10),
            green: parseInt('' + _hslRgbMatched[2], 10),
            blue: parseInt('' + _hslRgbMatched[3], 10),
            alpha: parseFloat('' + hslaMatched[4])
        };
    }
    throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
//      
function $287fe1c65d5eed0f$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue = void 0;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
//      
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $287fe1c65d5eed0f$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $287fe1c65d5eed0f$var$rgbToHsl($287fe1c65d5eed0f$export$2f48baff6995707a(color));
}
//      
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $287fe1c65d5eed0f$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
//      
function $287fe1c65d5eed0f$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $287fe1c65d5eed0f$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $287fe1c65d5eed0f$var$reduceHexValue('#' + $287fe1c65d5eed0f$var$numberToHex(value) + $287fe1c65d5eed0f$var$numberToHex(green) + $287fe1c65d5eed0f$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $287fe1c65d5eed0f$var$reduceHexValue('#' + $287fe1c65d5eed0f$var$numberToHex(value.red) + $287fe1c65d5eed0f$var$numberToHex(value.green) + $287fe1c65d5eed0f$var$numberToHex(value.blue));
    throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $287fe1c65d5eed0f$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $287fe1c65d5eed0f$export$2f48baff6995707a(firstValue);
        return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $287fe1c65d5eed0f$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $287fe1c65d5eed0f$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
    throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}
//      
function $287fe1c65d5eed0f$var$colorToHex(color) {
    return $287fe1c65d5eed0f$var$numberToHex(Math.round(color * 255));
}
function $287fe1c65d5eed0f$var$convertToHex(red, green, blue) {
    return $287fe1c65d5eed0f$var$reduceHexValue('#' + $287fe1c65d5eed0f$var$colorToHex(red) + $287fe1c65d5eed0f$var$colorToHex(green) + $287fe1c65d5eed0f$var$colorToHex(blue));
}
function $287fe1c65d5eed0f$var$hslToHex(hue, saturation, lightness) {
    return $287fe1c65d5eed0f$var$hslToRgb(hue, saturation, lightness, $287fe1c65d5eed0f$var$convertToHex);
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $287fe1c65d5eed0f$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $287fe1c65d5eed0f$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $287fe1c65d5eed0f$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $287fe1c65d5eed0f$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $287fe1c65d5eed0f$var$hslToHex(value, saturation, lightness) : 'rgba(' + $287fe1c65d5eed0f$var$hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $287fe1c65d5eed0f$var$hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + $287fe1c65d5eed0f$var$hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
    throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}
//      
var $287fe1c65d5eed0f$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $287fe1c65d5eed0f$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $287fe1c65d5eed0f$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $287fe1c65d5eed0f$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
var $287fe1c65d5eed0f$var$errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $287fe1c65d5eed0f$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new Error($287fe1c65d5eed0f$var$errMsg);
    if ($287fe1c65d5eed0f$var$isRgba(color)) return $287fe1c65d5eed0f$export$4e46ac54fc82cf3b(color);
    if ($287fe1c65d5eed0f$var$isRgb(color)) return $287fe1c65d5eed0f$export$8972dc0e6ad9238f(color);
    if ($287fe1c65d5eed0f$var$isHsla(color)) return $287fe1c65d5eed0f$export$810b04175080204c(color);
    if ($287fe1c65d5eed0f$var$isHsl(color)) return $287fe1c65d5eed0f$export$8f4a7c0bb78e6ea8(color);
    throw new Error($287fe1c65d5eed0f$var$errMsg);
}
//      
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $287fe1c65d5eed0f$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $287fe1c65d5eed0f$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $287fe1c65d5eed0f$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $287fe1c65d5eed0f$var$curried(f, f.length, []);
}
//      
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $287fe1c65d5eed0f$var$adjustHue(degree, color) {
    var hslColor = $287fe1c65d5eed0f$export$1286688e1b3fde9c(color);
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, hslColor, {
        hue: (hslColor.hue + degree) % 360
    }));
}
var $287fe1c65d5eed0f$export$2b372a09365374d6 = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$adjustHue);
//      
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $287fe1c65d5eed0f$export$bd4f6f7e1823bc9e(color) {
    var hslColor = $287fe1c65d5eed0f$export$1286688e1b3fde9c(color);
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
//      
function $287fe1c65d5eed0f$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
//      
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $287fe1c65d5eed0f$var$darken(amount, color) {
    var hslColor = $287fe1c65d5eed0f$export$1286688e1b3fde9c(color);
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, hslColor, {
        lightness: $287fe1c65d5eed0f$var$guard(0, 1, hslColor.lightness - amount)
    }));
}
var $287fe1c65d5eed0f$export$4b073707ff63303 = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$darken);
//      
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $287fe1c65d5eed0f$var$desaturate(amount, color) {
    var hslColor = $287fe1c65d5eed0f$export$1286688e1b3fde9c(color);
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, hslColor, {
        saturation: $287fe1c65d5eed0f$var$guard(0, 1, hslColor.saturation - amount)
    }));
}
var $287fe1c65d5eed0f$export$fb75607d98509d9 = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$desaturate);
//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $287fe1c65d5eed0f$export$c852d90bf7403b62(color) {
    var rgbColor = $287fe1c65d5eed0f$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
//      
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $287fe1c65d5eed0f$export$6f416a6db2dfcd5c(color) {
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, $287fe1c65d5eed0f$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
//      
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $287fe1c65d5eed0f$export$6897c284b6f9f4dc(color) {
    // parse color string to rgb
    var value = $287fe1c65d5eed0f$export$2f48baff6995707a(color);
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
//      
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $287fe1c65d5eed0f$var$lighten(amount, color) {
    var hslColor = $287fe1c65d5eed0f$export$1286688e1b3fde9c(color);
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, hslColor, {
        lightness: $287fe1c65d5eed0f$var$guard(0, 1, hslColor.lightness + amount)
    }));
}
var $287fe1c65d5eed0f$export$c0816ed86df316af = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$lighten);
//      
/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $287fe1c65d5eed0f$var$mix() {
    var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
    var color = arguments[1];
    var otherColor = arguments[2];
    var parsedColor1 = $287fe1c65d5eed0f$export$2f48baff6995707a(color);
    var color1 = $287fe1c65d5eed0f$var$_extends({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $287fe1c65d5eed0f$export$2f48baff6995707a(otherColor);
    var color2 = $287fe1c65d5eed0f$var$_extends({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    var alphaDelta = color1.alpha - color2.alpha;
    var x = weight * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
    };
    return $287fe1c65d5eed0f$export$4e46ac54fc82cf3b(mixedColor);
}
var $287fe1c65d5eed0f$export$2c9e8a9632a706b2 = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$mix);
//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $287fe1c65d5eed0f$var$opacify(amount, color) {
    var parsedColor = $287fe1c65d5eed0f$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $287fe1c65d5eed0f$var$_extends({}, parsedColor, {
        alpha: $287fe1c65d5eed0f$var$guard(0, 1, (alpha * 100 + amount * 100) / 100)
    });
    return $287fe1c65d5eed0f$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $287fe1c65d5eed0f$export$f4f50e3877dd0530 = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$opacify);
//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */ function $287fe1c65d5eed0f$var$readableColor(color) {
    return $287fe1c65d5eed0f$export$c852d90bf7403b62(color) > 0.179 ? '#000' : '#fff';
}
var $287fe1c65d5eed0f$export$61654c1796c44811 = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$readableColor);
//      
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $287fe1c65d5eed0f$var$saturate(amount, color) {
    var hslColor = $287fe1c65d5eed0f$export$1286688e1b3fde9c(color);
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, hslColor, {
        saturation: $287fe1c65d5eed0f$var$guard(0, 1, hslColor.saturation + amount)
    }));
}
var $287fe1c65d5eed0f$export$5fcac96f5a87e3db = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$saturate);
//      
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $287fe1c65d5eed0f$var$setHue(hue, color) {
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, $287fe1c65d5eed0f$export$1286688e1b3fde9c(color), {
        hue: hue
    }));
}
var $287fe1c65d5eed0f$export$3bf58ce3e497a846 = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$setHue);
//      
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $287fe1c65d5eed0f$var$setLightness(lightness, color) {
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, $287fe1c65d5eed0f$export$1286688e1b3fde9c(color), {
        lightness: lightness
    }));
}
var $287fe1c65d5eed0f$export$7ef5d725337b805d = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$setLightness);
//      
/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $287fe1c65d5eed0f$var$setSaturation(saturation, color) {
    return $287fe1c65d5eed0f$export$42fe740cdf79b2df($287fe1c65d5eed0f$var$_extends({}, $287fe1c65d5eed0f$export$1286688e1b3fde9c(color), {
        saturation: saturation
    }));
}
var $287fe1c65d5eed0f$export$b40fe421ea7a4f7e = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$setSaturation);
//      
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $287fe1c65d5eed0f$var$shade(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $287fe1c65d5eed0f$export$2c9e8a9632a706b2(percentage, color, 'rgb(0, 0, 0)');
}
var $287fe1c65d5eed0f$export$3e32adda0df4ef5d = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$shade);
//      
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $287fe1c65d5eed0f$var$tint(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $287fe1c65d5eed0f$export$2c9e8a9632a706b2(percentage, color, 'rgb(255, 255, 255)');
}
var $287fe1c65d5eed0f$export$fc176dd65a27d98b = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$tint);
//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $287fe1c65d5eed0f$var$transparentize(amount, color) {
    var parsedColor = $287fe1c65d5eed0f$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $287fe1c65d5eed0f$var$_extends({}, parsedColor, {
        alpha: $287fe1c65d5eed0f$var$guard(0, 1, (alpha * 100 - amount * 100) / 100)
    });
    return $287fe1c65d5eed0f$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $287fe1c65d5eed0f$export$d11da87e55cc498f = /*#__PURE__*/ $287fe1c65d5eed0f$var$curry($287fe1c65d5eed0f$var$transparentize);
//      
/** */ /**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $287fe1c65d5eed0f$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
        if (Array.isArray(arg) && arg.length > 8) throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
//      
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $287fe1c65d5eed0f$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $287fe1c65d5eed0f$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $287fe1c65d5eed0f$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $287fe1c65d5eed0f$export$4fc00c04dd60af95.apply(undefined, [
        'borderColor'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $287fe1c65d5eed0f$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $287fe1c65d5eed0f$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
    }
    throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $287fe1c65d5eed0f$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $287fe1c65d5eed0f$export$4fc00c04dd60af95.apply(undefined, [
        'borderStyle'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $287fe1c65d5eed0f$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $287fe1c65d5eed0f$export$4fc00c04dd60af95.apply(undefined, [
        'borderWidth'
    ].concat(values));
}
//      
function $287fe1c65d5eed0f$var$generateSelectors(template, state) {
    var stateSuffix = state ? ':' + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $287fe1c65d5eed0f$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new Error('You must provide a template to this method.');
    if (states.length === 0) return $287fe1c65d5eed0f$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new Error('You passed an unsupported selector state to this method.');
        selectors.push($287fe1c65d5eed0f$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
//      
var $287fe1c65d5eed0f$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $287fe1c65d5eed0f$var$template(state) {
    return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $287fe1c65d5eed0f$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $287fe1c65d5eed0f$var$statefulSelectors(states, $287fe1c65d5eed0f$var$template, $287fe1c65d5eed0f$var$stateMap);
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $287fe1c65d5eed0f$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $287fe1c65d5eed0f$export$4fc00c04dd60af95.apply(undefined, [
        'margin'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $287fe1c65d5eed0f$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $287fe1c65d5eed0f$export$4fc00c04dd60af95.apply(undefined, [
        'padding'
    ].concat(values));
}
//      
var $287fe1c65d5eed0f$var$positionMap$1 = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $287fe1c65d5eed0f$export$5880b8b5730aff45(positionKeyword) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($287fe1c65d5eed0f$var$positionMap$1.indexOf(positionKeyword) >= 0) return $287fe1c65d5eed0f$var$_extends({
        position: positionKeyword
    }, $287fe1c65d5eed0f$export$4fc00c04dd60af95.apply(undefined, [
        ''
    ].concat(values)));
    else {
        var firstValue = positionKeyword; // in this case position is actually the first value
        return $287fe1c65d5eed0f$export$4fc00c04dd60af95.apply(undefined, [
            '',
            firstValue
        ].concat(values));
    }
}
//      
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $287fe1c65d5eed0f$export$346677f925de839c(height) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
    return {
        height: height,
        width: width
    };
}
//      
var $287fe1c65d5eed0f$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $287fe1c65d5eed0f$var$template$1(state) {
    return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $287fe1c65d5eed0f$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $287fe1c65d5eed0f$var$statefulSelectors(states, $287fe1c65d5eed0f$var$template$1, $287fe1c65d5eed0f$var$stateMap$1);
}
//      
/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */ function $287fe1c65d5eed0f$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        transition: properties.join(', ')
    };
}



var $h9r4d = parcelRequire("h9r4d");


var $4yUlE = parcelRequire("4yUlE");

const $15f951566676b4b7$export$3d31854eb05903e0 = (color, packageName)=>{
    try {
        // Convert to HEX as polished's getLuminance only accepts HEX colors
        const hexColor = (0, $4yUlE.toHexColor)(color);
        return (0, $287fe1c65d5eed0f$export$c852d90bf7403b62)(hexColor) > 0.5 ? "var(--ds-text, #292A2E)" : "var(--ds-text-inverse, #FFFFFF)";
    } catch (error) {
        (0, $h9r4d.fireErrorAnalytics)({
            error: error instanceof Error ? error : new Error(`Color luminance calculation failed for color: ${color}`),
            meta: {
                id: 'readableTextColor',
                packageName: packageName
            }
        });
        // Fallback to text color
        return "var(--ds-text, #292A2E)";
    }
};
module.exports["readableTextColor"] = $15f951566676b4b7$export$3d31854eb05903e0;

});

parcelRegister("r8hvx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $2Ecck = parcelRequire("2Ecck");

var $geKL9 = parcelRequire("geKL9");

const $4cf16431deccd0b9$export$9a47313ad5d1f7c3 = (asapIssuer, mediaToken, mediaUrl)=>async ()=>{
        return {
            asapIssuer: asapIssuer,
            token: mediaToken,
            baseUrl: mediaUrl
        };
    };
const $4cf16431deccd0b9$export$98e696b66f6bbf2b = (mediaCollectionName, asapIssuer, mediaToken, mediaUrl, isUploadMediaConfigRequired)=>{
    const authProvider = $4cf16431deccd0b9$export$9a47313ad5d1f7c3(asapIssuer, mediaToken, mediaUrl);
    return {
        uploadParams: {
            collection: mediaCollectionName
        },
        viewMediaClientConfig: {
            authProvider: authProvider,
            useSha256ForUploads: true
        },
        ...isUploadMediaConfigRequired && {
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        }
    };
};
const $4cf16431deccd0b9$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null') {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $2Ecck.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $4cf16431deccd0b9$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $4cf16431deccd0b9$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    return (0, $geKL9.HelpPageAri).create({
        activationId: activationId,
        pageId: pageId || helpCenterId
    }).toString() || '';
};
const $4cf16431deccd0b9$export$6a5aa704056d141b = (0, $cozmU.createContext)(null);
const $4cf16431deccd0b9$export$ac8576a9912be18c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($4cf16431deccd0b9$export$6a5aa704056d141b);
    if (!context) throw new Error("useHubContext must be used within a HubContextProvider");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($4cf16431deccd0b9$export$6a5aa704056d141b);
    if (!context) throw new Error('useHubContext must be used within a HubContextProvider');
    return context;
};
module.exports["getMediaProvider"] = $4cf16431deccd0b9$export$98e696b66f6bbf2b;
module.exports["HubContext"] = $4cf16431deccd0b9$export$6a5aa704056d141b;
module.exports["useHubContext"] = $4cf16431deccd0b9$export$ac8576a9912be18c;

});

parcelRegister("2Ecck", function(module, exports) {
// src/help/help-center/types.ts
var $c9e4fa34ad2a6b7c$export$a4af98a27b4568ee = "help", $c9e4fa34ad2a6b7c$export$f6271ed6947e9084 = "help-center";



var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/help/help-center/manifest.ts
var $1ed8c76950c192d5$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $c9e4fa34ad2a6b7c$export$a4af98a27b4568ee),
    resourceType: (0, $c9e4fa34ad2a6b7c$export$f6271ed6947e9084),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/help-center/index.ts
var $1ed8c76950c192d5$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $1gKSA.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1ed8c76950c192d5$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $1ed8c76950c192d5$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1ed8c76950c192d5$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $1ed8c76950c192d5$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $1ed8c76950c192d5$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $1ed8c76950c192d5$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
};
module.exports["HelpHelpCenterAri"] = $1ed8c76950c192d5$export$a75f3c98d930b258;

});

parcelRegister("geKL9", function(module, exports) {
// src/help/page/types.ts
var $67f869d565f71cc8$export$b6fe1f05324d51ea = "help", $67f869d565f71cc8$export$e6c9af890e88f3eb = "page";



var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/help/page/manifest.ts
var $bd2239a2502a9f42$var$helpPageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $67f869d565f71cc8$export$b6fe1f05324d51ea),
    resourceType: (0, $67f869d565f71cc8$export$e6c9af890e88f3eb),
    resourceIdSlug: "{activationId}/{pageId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        pageId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/page/index.ts
var $bd2239a2502a9f42$export$7855a3c68b5a0b04 = class _HelpPageAri extends (0, $1gKSA.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bd2239a2502a9f42$var$helpPageAriStaticOpts.qualifier,
            platformQualifier: $bd2239a2502a9f42$var$helpPageAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $bd2239a2502a9f42$var$helpPageAriStaticOpts.resourceOwner,
            resourceType: $bd2239a2502a9f42$var$helpPageAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.pageId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                pageId: opts.pageId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $bd2239a2502a9f42$var$helpPageAriStaticOpts);
        return new _HelpPageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $bd2239a2502a9f42$var$helpPageAriStaticOpts);
        return new _HelpPageAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["HelpPageAri"] = $bd2239a2502a9f42$export$7855a3c68b5a0b04;

});

parcelRegister("hITUV", function(module, exports) {
/**
 * Centralised registry of `--hub-*` CSS custom-property names emitted by
 * `<HubThemingProvider>`'s wrapper `<div>`. These are the **only** v2 CSS-var
 * names extension code references — never hand-write `--hub-*` strings at the
 * call site.
 *
 * Why centralised:
 *   • Single rename point — change a name here, every consumer follows.
 *   • Type-safe lookup via `PaletteRef` — typo "primary.150" fails the build.
 *   • `resolveAdfColor` derives its `var(--hub-color-...)` output from this
 *     registry, so the renderer never sees raw var-name strings.
 *
 * Naming convention:
 *   --hub-color-{family}-{shade}    → e.g. --hub-color-primary-200
 *   --hub-color-{semantic}          → e.g. --hub-color-text-on-primary
 *   --hub-radius-{slot}             → reserved for future radius work
 *   --hub-space-{slot}              → reserved for future density work
 *
 * The wrapper div emits the registry as inline `style` so the values are
 * present in the SSR HTML on first paint — no useEffect, no setProperty.
 */ const $a9e075c7e54aa38f$var$SHADES = [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    '1000'
];
const $a9e075c7e54aa38f$var$FAMILIES = [
    'primary',
    'accent'
];
const $a9e075c7e54aa38f$var$buildColorVarMap = ()=>{
    const out = {};
    for (const family of $a9e075c7e54aa38f$var$FAMILIES)for (const shade of $a9e075c7e54aa38f$var$SHADES){
        const ref = `${family}.${shade}`;
        out[ref] = `--hub-color-${family}-${shade}`;
    }
    return out;
};
const $a9e075c7e54aa38f$export$6e4a1de0ca7c3086 = Object.freeze($a9e075c7e54aa38f$var$buildColorVarMap());
const $a9e075c7e54aa38f$export$83d6614a5062fafa = Object.freeze({
    color: $a9e075c7e54aa38f$export$6e4a1de0ca7c3086
});
module.exports["HUB_COLOR_CSS_VARS"] = $a9e075c7e54aa38f$export$6e4a1de0ca7c3086;

});

parcelRegister("4WDWC", function(module, exports) {

var $hjUDQ = parcelRequire("hjUDQ");

const $6fcee6e7d693a28e$export$ca8289818e8a00b3 = 0;
const $6fcee6e7d693a28e$export$fd5c0c061b90ed51 = 32;
const $6fcee6e7d693a28e$export$39e466a7b7ce22ff = 8;
const $6fcee6e7d693a28e$export$80508b5197dbe846 = 8;
const $6fcee6e7d693a28e$export$e3711566ecaf02ae = '--hub-corner-radius';
const $6fcee6e7d693a28e$var$VALID = new Set([
    0,
    8,
    16,
    24,
    32
]);
const $6fcee6e7d693a28e$export$122ea29a9b10732a = (value)=>typeof value === 'number' && $6fcee6e7d693a28e$var$VALID.has(value) ? value : $6fcee6e7d693a28e$export$80508b5197dbe846;
const $6fcee6e7d693a28e$export$3795d91173f540a = (style)=>style === (0, $hjUDQ.CornerStyle).SQUARED ? 0 : undefined;
const $6fcee6e7d693a28e$export$db3cd30e3eed0965 = (cornerRadius, cornerStyle)=>cornerRadius ?? $6fcee6e7d693a28e$export$3795d91173f540a(cornerStyle);
module.exports["HUB_CORNER_RADIUS_MIN"] = $6fcee6e7d693a28e$export$ca8289818e8a00b3;
module.exports["HUB_CORNER_RADIUS_MAX"] = $6fcee6e7d693a28e$export$fd5c0c061b90ed51;
module.exports["HUB_CORNER_RADIUS_STEP"] = $6fcee6e7d693a28e$export$39e466a7b7ce22ff;
module.exports["HUB_CORNER_RADIUS_DEFAULT"] = $6fcee6e7d693a28e$export$80508b5197dbe846;
module.exports["HUB_CORNER_RADIUS_CSS_VAR"] = $6fcee6e7d693a28e$export$e3711566ecaf02ae;
module.exports["resolveHubCornerRadius"] = $6fcee6e7d693a28e$export$122ea29a9b10732a;
module.exports["resolveCornerRadiusOverride"] = $6fcee6e7d693a28e$export$db3cd30e3eed0965;

});

parcelRegister("lCJ1A", function(module, exports) {
/**
 * Public type for the Hub space density (spacing) customization.
 *
 * Values mirror the backend `HelpCenterSpaceDensity` GraphQL enum exactly
 * (uppercase), so there is no case-mapping at the read/write boundaries.
 *
 * The chosen density will control the vertical rhythm
 * between every element on the hub page and, eventually, the spacing inside
 * elements.
 */ const $755de27231b6e471$export$7525d7f8474e6b81 = [
    'DEFAULT',
    'COMFORTABLE',
    'BREEZY'
];
const $755de27231b6e471$export$61fa4fc6e277c51f = 'DEFAULT';
const $755de27231b6e471$export$cf3820686f87514a = '--ak-editor-extension-block-spacing';
const $755de27231b6e471$export$6ca1261611fbc46e = {
    DEFAULT: '0',
    COMFORTABLE: '16px',
    BREEZY: '24px'
};
const $755de27231b6e471$export$a652a2b31fb9818 = (density)=>$755de27231b6e471$export$6ca1261611fbc46e[density];
const $755de27231b6e471$export$cc1134cace54c337 = {
    DEFAULT: 16,
    COMFORTABLE: 16,
    BREEZY: 24
};
const $755de27231b6e471$export$4cd8ab356af25889 = (density)=>$755de27231b6e471$export$cc1134cace54c337[density];
module.exports["DEFAULT_SPACE_DENSITY"] = $755de27231b6e471$export$61fa4fc6e277c51f;
module.exports["getCardGapForDensity"] = $755de27231b6e471$export$4cd8ab356af25889;

});

parcelRegister("4pfdN", function(module, exports) {

var $h2czO = parcelRequire("h2czO");


var $5KWZf = parcelRequire("5KWZf");


var $65u5c = parcelRequire("65u5c");

var $hITUV = parcelRequire("hITUV");

/**
 * Day-0 default shade that bespoke extensions inherit through
 * `CommonHubExtensionsDependenciesProvider` when an extension hasn't pinned a
 * background of its own. Kept local to this resolver — it is intentionally
 * decoupled from `ELEMENT_DEFAULTS` because the per-element map is the
 * source-of-truth for *named* element slots (e.g. `callout.bg`), whereas this
 * is the resolver's own generic fallback shared across every extension.
 */ const $dd3d9fb772801e57$var$DEFAULT_HUB_BACKGROUND_SHADE = 'primary.200';
/**
 * Optional inputs that opt the default-parameters resolution into the
 * advanced-theming palette path. When `palette` is supplied, the bespoke-
 * element background defaults to the brand `primary.200` shade resolved from
 * that palette (per §4.2 of the Advanced Theming v2 design). When `palette`
 * is absent, behaviour is identical to the legacy single-brand-color path.
 */ /**
 * Per-element bg shade overrides. When an extension wants a different default
 * shade than the resolver's generic `primary.200`, it's mapped here. Keys
 * match the `ELEMENT_DEFAULTS` map; values are the slot suffix to look up.
 */ const $dd3d9fb772801e57$var$ELEMENT_BG_SHADE = {
    section: (0, $65u5c.ELEMENT_DEFAULTS)['section.bg']
};
/**
 * Per-element icon-color shade overrides. Currently only JSM Help renders an
 * icon; values are looked up in `ELEMENT_DEFAULTS`.
 */ const $dd3d9fb772801e57$var$ELEMENT_ICON_SHADE = {
    'jsm-help': (0, $65u5c.ELEMENT_DEFAULTS)['jsm-help.icon']
};
const $dd3d9fb772801e57$export$25a6d2da841ddb1d = (options = {})=>{
    if (options.palette) {
        const bgShade = options.element && $dd3d9fb772801e57$var$ELEMENT_BG_SHADE[options.element] || $dd3d9fb772801e57$var$DEFAULT_HUB_BACKGROUND_SHADE;
        const iconShade = options.element && $dd3d9fb772801e57$var$ELEMENT_ICON_SHADE[options.element];
        // Gate ON:
        //   - bg = CSS-var ref so the cascade tracks brand-color edits via the
        //     <HubThemingProvider> wrapper's inline `style`.
        //   - text = WCAG-readable black/white computed against the resolved
        //     bg hex. Stored as a literal so it remains correct even when
        //     admin overrides bg per-element (the auto-transition hook in
        //     the panel handles per-element flips at edit time).
        //   - icon = CSS-var ref (only when element opts in via ELEMENT_ICON_SHADE).
        return {
            backgroundColor: `var(${(0, $hITUV.HUB_COLOR_CSS_VARS)[bgShade]})`,
            textColor: (0, $h2czO.readableTextColor)(options.palette[bgShade], '@atlassian/company-hub-common'),
            isAdvancedThemingEnabled: true,
            ...iconShade ? {
                iconColor: `var(${(0, $hITUV.HUB_COLOR_CSS_VARS)[iconShade]}, ${options.palette[iconShade]})`
            } : {}
        };
    }
    return {
        backgroundColor: `var(${0, $5KWZf.HUB_PRIMARY_COLOR_CSS_VAR}, ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"})`,
        textColor: `var(${0, $5KWZf.HUB_PRIMARY_TEXT_COLOR_CSS_VAR}, ${"var(--ds-text, #292A2E)"})`,
        isAdvancedThemingEnabled: false
    };
};
module.exports["getHubDefaultParameters"] = $dd3d9fb772801e57$export$25a6d2da841ddb1d;

});

parcelRegister("65u5c", function(module, exports) {
/**
 * Element-default contract — see §4.2 of the Advanced Theming v2 design.
 *
 * Maps an element-color-slot key to a palette token reference. Day 0 only
 * defines bespoke-extension *background* slots, all pointing at `primary.200`,
 * which gives every bespoke element a coherent themed default while the rest
 * of the override / picker UX is built out.
 */ const $e74d5ec8f8f291b8$export$6d3cb81378fd614a = {
    // Bespoke extensions — backgrounds (day 0).
    'callout.bg': 'primary.200',
    'cards.bg': 'primary.200',
    'carousel.bg': 'primary.200',
    'spotlight.bg': 'primary.200',
    'jsm-help.bg': 'primary.200',
    // JSM Help icon — bold brand tone for visibility against the light bg.
    'jsm-help.icon': 'primary.800',
    // Sections use a lighter accent tint to differentiate from bespoke extension cards.
    'section.bg': 'accent.100'
};
module.exports["ELEMENT_DEFAULTS"] = $e74d5ec8f8f291b8$export$6d3cb81378fd614a;

});

parcelRegister("j0Q3v", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $r8hvx = parcelRequire("r8hvx");

const $a0de554e52ac72d7$export$13ab96420d94e773 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const ctx = (0, $cozmU.useContext)((0, $r8hvx.HubContext));
    if (!ctx) return false;
    const productFlag = ctx.featureFlags?.["advanced-theming-in-hub"] === true;
    let t0;
    if ($[0] !== productFlag) {
        t0 = productFlag && (0, $iDrrr.fg)("hub-advanced-theming");
        $[0] = productFlag;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const ctx = (0, $cozmU.useContext)((0, $r8hvx.HubContext));
    if (!ctx) // No HubContextProvider in tree (e.g. Confluence Company Hub). Theming
    // is help-center-only — return false without throwing.
    return false;
    const productFlag = ctx.featureFlags?.['advanced-theming-in-hub'] === true;
    return productFlag && (0, $iDrrr.fg)('hub-advanced-theming');
};
module.exports["useIsAdvancedThemingEnabled"] = $a0de554e52ac72d7$export$13ab96420d94e773;

});

parcelRegister("4sYZY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4yUlE = parcelRequire("4yUlE");


var $5tPGk = parcelRequire("5tPGk");


var $jIDse = parcelRequire("jIDse");

/** This is a map of commonly used ADS colors, a well-balanced spread of the color palette
 * There are 3 unique sets of tokens for background, text, and border.
 * Highlight colors, otherwise known as foreground colors, are the same as text colors
 * because text colors are handpicked to complement background colors at the appropriate AA contrast ratio
 * contrast standards should be met between foreground/background as text/background does
 */ const $fdd8a69ea7e4a57f$var$ELEVATION_SURFACE_TOKEN = "var(--ds-surface, #FFFFFF)";
const $fdd8a69ea7e4a57f$var$ELEVATION_SURFACE_OVERLAY_TOKEN = "var(--ds-surface-overlay, #FFFFFF)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLEST_TOKEN = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLEST_TOKEN = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLEST_TOKEN = "var(--ds-background-accent-magenta-subtlest, #FFECF8)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLEST_TOKEN = "var(--ds-background-accent-red-subtlest, #FFECEB)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLEST_TOKEN = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLEST_TOKEN = "var(--ds-background-accent-yellow-subtlest, #FEF7C8)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLEST_TOKEN = "var(--ds-background-accent-lime-subtlest, #EFFFD6)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLEST_TOKEN = "var(--ds-background-accent-green-subtlest, #DCFFF1)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLEST_TOKEN = "var(--ds-background-accent-teal-subtlest, #E7F9FF)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLER_TOKEN = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLER_TOKEN = "var(--ds-background-accent-blue-subtler, #CFE1FD)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLER_TOKEN = "var(--ds-background-accent-purple-subtler, #EED7FC)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLER_TOKEN = "var(--ds-background-accent-magenta-subtler, #FDD0EC)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLER_TOKEN = "var(--ds-background-accent-red-subtler, #FFD5D2)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLER_TOKEN = "var(--ds-background-accent-orange-subtler, #FCE4A6)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLER_TOKEN = "var(--ds-background-accent-yellow-subtler, #F5E989)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLER_TOKEN = "var(--ds-background-accent-lime-subtler, #D3F1A7)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLER_TOKEN = "var(--ds-background-accent-green-subtler, #BAF3DB)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLER_TOKEN = "var(--ds-background-accent-teal-subtler, #C6EDFB)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLE_TOKEN = "var(--ds-background-accent-gray-subtle, #8C8F97)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLE_TOKEN = "var(--ds-background-accent-blue-subtle, #669DF1)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLE_TOKEN = "var(--ds-background-accent-purple-subtle, #C97CF4)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLE_TOKEN = "var(--ds-background-accent-magenta-subtle, #E774BB)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLE_TOKEN = "var(--ds-background-accent-red-subtle, #F87168)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLE_TOKEN = "var(--ds-background-accent-orange-subtle, #FCA700)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLE_TOKEN = "var(--ds-background-accent-yellow-subtle, #EED12B)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLE_TOKEN = "var(--ds-background-accent-lime-subtle, #94C748)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLE_TOKEN = "var(--ds-background-accent-green-subtle, #4BCE97)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLE_TOKEN = "var(--ds-background-accent-teal-subtle, #6CC3E0)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GRAY_BOLDER_TOKEN = "var(--ds-background-accent-gray-bolder, #6B6E76)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_BOLDER_TOKEN = "var(--ds-background-accent-blue-bolder, #1868DB)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_BOLDER_TOKEN = "var(--ds-background-accent-purple-bolder, #964AC0)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_BOLDER_TOKEN = "var(--ds-background-accent-magenta-bolder, #AE4787)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_BOLDER_TOKEN = "var(--ds-background-accent-red-bolder, #C9372C)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_BOLDER_TOKEN = "var(--ds-background-accent-orange-bolder, #BD5B00)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_BOLDER_TOKEN = "var(--ds-background-accent-yellow-bolder, #946F00)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_BOLDER_TOKEN = "var(--ds-background-accent-lime-bolder, #5B7F24)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_BOLDER_TOKEN = "var(--ds-background-accent-green-bolder, #1F845A)";
const $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_BOLDER_TOKEN = "var(--ds-background-accent-teal-bolder, #227D9B)";
const $fdd8a69ea7e4a57f$export$1ca6214429b36a67 = [
    $fdd8a69ea7e4a57f$var$ELEVATION_SURFACE_OVERLAY_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLEST_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLEST_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLEST_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLEST_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLEST_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLEST_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLEST_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLEST_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLEST_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLE_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GRAY_BOLDER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_BOLDER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_BOLDER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_BOLDER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_BOLDER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_BOLDER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_BOLDER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_BOLDER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_BOLDER_TOKEN,
    $fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_BOLDER_TOKEN
];
const $fdd8a69ea7e4a57f$export$596441732422b61d = {
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$ELEVATION_SURFACE_TOKEN)]: "var(--ds-surface-hovered, #F0F1F2)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$ELEVATION_SURFACE_OVERLAY_TOKEN)]: "var(--ds-surface-overlay-hovered, #F0F1F2)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLEST_TOKEN)]: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLEST_TOKEN)]: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLEST_TOKEN)]: "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLEST_TOKEN)]: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLEST_TOKEN)]: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLEST_TOKEN)]: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLEST_TOKEN)]: "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLEST_TOKEN)]: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLEST_TOKEN)]: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLER_TOKEN)]: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLER_TOKEN)]: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLER_TOKEN)]: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLER_TOKEN)]: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLER_TOKEN)]: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLER_TOKEN)]: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLER_TOKEN)]: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLER_TOKEN)]: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLER_TOKEN)]: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLER_TOKEN)]: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLE_TOKEN)]: "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLE_TOKEN)]: "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLE_TOKEN)]: "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLE_TOKEN)]: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLE_TOKEN)]: "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLE_TOKEN)]: "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLE_TOKEN)]: "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLE_TOKEN)]: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLE_TOKEN)]: "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLE_TOKEN)]: "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GRAY_BOLDER_TOKEN)]: "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_BLUE_BOLDER_TOKEN)]: "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_PURPLE_BOLDER_TOKEN)]: "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_MAGENTA_BOLDER_TOKEN)]: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_RED_BOLDER_TOKEN)]: "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_ORANGE_BOLDER_TOKEN)]: "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_YELLOW_BOLDER_TOKEN)]: "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_LIME_BOLDER_TOKEN)]: "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_GREEN_BOLDER_TOKEN)]: "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    [(0, $4yUlE.extractToken)($fdd8a69ea7e4a57f$var$COLOR_BACKGROUND_ACCENT_TEAL_BOLDER_TOKEN)]: "var(--ds-background-accent-teal-bolder-hovered, #206A83)"
};
const $fdd8a69ea7e4a57f$export$4b7f6299a52ab6c0 = (color)=>{
    return $fdd8a69ea7e4a57f$export$596441732422b61d[(0, $4yUlE.extractToken)(color)];
};
// New row of background colors are not semantically correct,
// and will be replaced by actual background colors from ADS
// when available.
// For now, we use these to solve a customer problem by helping
// them select a correctly theme-responsive token value instead
// of having to resort to custom hex codes to get a dark background
// color. Custom hex color codes don't always work well when used alongside
// tokenized text colors because the ADS color tokens will switch
// to a contrasting value in the opposite theme mode, but the custom
// hex background color will stay the same (we only change custom hex
// code values by darkening them if it is a light value selected in light mode).
const $fdd8a69ea7e4a57f$var$additionalBackgroundColors = [
    "var(--ds-text-accent-gray-bolder, #1E1F21)",
    "var(--ds-text-accent-blue-bolder, #123263)",
    "var(--ds-text-accent-purple-bolder, #48245D)",
    "var(--ds-text-accent-magenta-bolder, #50253F)",
    "var(--ds-text-accent-red-bolder, #5D1F1A)",
    "var(--ds-text-accent-orange-bolder, #693200)",
    "var(--ds-text-accent-yellow-bolder, #533F04)",
    "var(--ds-text-accent-lime-bolder, #37471F)",
    "var(--ds-text-accent-green-bolder, #164B35)",
    "var(--ds-text-accent-teal-bolder, #164555)"
];
const $fdd8a69ea7e4a57f$var$knownTextColors = [
    "var(--ds-text, #292A2E)",
    "var(--ds-text-accent-blue-bolder, #123263)",
    "var(--ds-text-accent-purple-bolder, #48245D)",
    "var(--ds-text-accent-magenta-bolder, #50253F)",
    "var(--ds-text-accent-red-bolder, #5D1F1A)",
    "var(--ds-text-accent-orange-bolder, #693200)",
    "var(--ds-text-accent-yellow-bolder, #533F04)",
    "var(--ds-text-accent-lime-bolder, #37471F)",
    "var(--ds-text-accent-green-bolder, #164B35)",
    "var(--ds-text-accent-teal-bolder, #164555)",
    "var(--ds-text-subtle, #505258)",
    "var(--ds-text-accent-blue, #1558BC)",
    "var(--ds-text-accent-purple, #803FA5)",
    "var(--ds-text-accent-magenta, #943D73)",
    "var(--ds-text-accent-red, #AE2E24)",
    "var(--ds-text-accent-orange, #9E4C00)",
    "var(--ds-text-accent-yellow, #7F5F01)",
    "var(--ds-text-accent-lime, #4C6B1F)",
    "var(--ds-text-accent-green, #216E4E)",
    "var(--ds-text-accent-teal, #206A83)",
    "var(--ds-text-inverse, #FFFFFF)",
    "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    "var(--ds-background-accent-purple-subtler, #EED7FC)",
    "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "var(--ds-background-accent-red-subtler, #FFD5D2)",
    "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    "var(--ds-background-accent-yellow-subtler, #F5E989)",
    "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "var(--ds-background-accent-green-subtler, #BAF3DB)",
    "var(--ds-background-accent-teal-subtler, #C6EDFB)"
];
const $fdd8a69ea7e4a57f$var$knownBorderColors = [
    "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    "var(--ds-border-accent-blue, #357DE8)",
    "var(--ds-border-accent-purple, #AF59E1)",
    "var(--ds-border-accent-magenta, #CD519D)",
    "var(--ds-border-accent-red, #E2483D)",
    "var(--ds-border-accent-orange, #E06C00)",
    "var(--ds-border-accent-yellow, #B38600)",
    "var(--ds-border-accent-lime, #6A9A23)",
    "var(--ds-border-accent-green, #22A06B)",
    "var(--ds-border-accent-teal, #2898BD)",
    "var(--ds-border-inverse, #FFFFFF)",
    "var(--ds-border-accent-gray, #7D818A)"
];
const $fdd8a69ea7e4a57f$var$knownHighlightColors = $fdd8a69ea7e4a57f$var$knownTextColors;
const $fdd8a69ea7e4a57f$export$16ac295f28be8745 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isSSRProductInDarkMode)=>{
    const $ = (0, $bDgLe.c)(8);
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    let t0;
    if ($[0] !== getDarkModeCompatibleBackgroundColor) {
        t0 = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: [
                ...$fdd8a69ea7e4a57f$export$1ca6214429b36a67,
                ...$fdd8a69ea7e4a57f$var$additionalBackgroundColors
            ],
            getResponsiveColor: (color)=>getDarkModeCompatibleBackgroundColor(color)
        });
        $[0] = getDarkModeCompatibleBackgroundColor;
        $[1] = t0;
    } else t0 = $[1];
    const backgroundColorMap = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: $fdd8a69ea7e4a57f$var$knownBorderColors
        });
        $[2] = t1;
    } else t1 = $[2];
    const borderColorMap = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: $fdd8a69ea7e4a57f$var$knownTextColors
        });
        $[3] = t2;
    } else t2 = $[3];
    const textColorMap = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: $fdd8a69ea7e4a57f$var$knownHighlightColors
        });
        $[4] = t3;
    } else t3 = $[4];
    const highlightColorMap = t3;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: []
        });
        $[5] = t4;
    } else t4 = $[5];
    const emptyColorMap = t4;
    let t5;
    if ($[6] !== backgroundColorMap) {
        t5 = {
            backgroundColorMap: backgroundColorMap,
            borderColorMap: borderColorMap,
            textColorMap: textColorMap,
            highlightColorMap: highlightColorMap,
            emptyColorMap: emptyColorMap
        };
        $[6] = backgroundColorMap;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : (isSSRProductInDarkMode)=>{
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    return (0, $cozmU.useMemo)(()=>{
        const backgroundColorMap = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: [
                ...$fdd8a69ea7e4a57f$export$1ca6214429b36a67,
                ...$fdd8a69ea7e4a57f$var$additionalBackgroundColors
            ],
            getResponsiveColor: (color)=>{
                return getDarkModeCompatibleBackgroundColor(color);
            }
        });
        const borderColorMap = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: $fdd8a69ea7e4a57f$var$knownBorderColors
        });
        const textColorMap = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: $fdd8a69ea7e4a57f$var$knownTextColors
        });
        const highlightColorMap = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: $fdd8a69ea7e4a57f$var$knownHighlightColors
        });
        const emptyColorMap = (0, $5tPGk.createBuiltInColorMap)({
            knownColors: []
        });
        return {
            backgroundColorMap: backgroundColorMap,
            borderColorMap: borderColorMap,
            textColorMap: textColorMap,
            highlightColorMap: highlightColorMap,
            emptyColorMap: emptyColorMap
        };
    }, [
        getDarkModeCompatibleBackgroundColor
    ]);
};
module.exports["knownBackgroundColors"] = $fdd8a69ea7e4a57f$export$1ca6214429b36a67;
module.exports["getBackgroundHoveredColor"] = $fdd8a69ea7e4a57f$export$4b7f6299a52ab6c0;
module.exports["useBuiltInColorMap"] = $fdd8a69ea7e4a57f$export$16ac295f28be8745;

});

parcelRegister("jIDse", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $89bON = parcelRequire("89bON");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $iRKv3 = parcelRequire("iRKv3");

const $cbf4e122dd89063e$var$BACKGROUND_LIGHTNESS_MAX = 35;
const $cbf4e122dd89063e$var$TEXT_LIGHTNESS_MIN = 90;
const $cbf4e122dd89063e$export$f11b6ab43332cfcf = (lightModeColor)=>{
    if (lightModeColor === '#FFFFFF') return (0, $89bON.default)('elevation.surface.overlay', '#1D2125');
    else {
        const lightnessPercentage = (0, $iRKv3.getLightnessPercentage)(lightModeColor);
        if (lightnessPercentage === undefined) return lightModeColor;
        return lightnessPercentage > $cbf4e122dd89063e$var$BACKGROUND_LIGHTNESS_MAX ? (0, $iRKv3.reduceLightness)(lightModeColor, $cbf4e122dd89063e$var$BACKGROUND_LIGHTNESS_MAX) : lightModeColor;
    }
};
const $cbf4e122dd89063e$export$c17d6b0d1b5d5ab6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isSSRProductInDarkMode)=>{
    const $ = (0, $bDgLe.c)(8);
    const isSpaAkThemeInDarkMode = (0, $IQ4Dz.default)().colorMode === "dark";
    const shouldEvaluateLightness = isSpaAkThemeInDarkMode;
    let t0;
    if ($[0] !== shouldEvaluateLightness) {
        t0 = (backgroundColor)=>shouldEvaluateLightness ? $cbf4e122dd89063e$export$f11b6ab43332cfcf(backgroundColor) : backgroundColor;
        $[0] = shouldEvaluateLightness;
        $[1] = t0;
    } else t0 = $[1];
    const getDarkModeCompatibleBackgroundColor = t0;
    let t1;
    if ($[2] !== shouldEvaluateLightness) {
        t1 = (textColor)=>shouldEvaluateLightness ? (0, $iRKv3.increaseLightness)(textColor, $cbf4e122dd89063e$var$TEXT_LIGHTNESS_MIN) : textColor;
        $[2] = shouldEvaluateLightness;
        $[3] = t1;
    } else t1 = $[3];
    const getDarkModeCompatibleTextColor = t1;
    let t2;
    if ($[4] !== getDarkModeCompatibleBackgroundColor || $[5] !== getDarkModeCompatibleTextColor || $[6] !== shouldEvaluateLightness) {
        t2 = {
            shouldEvaluateBackgroundLightness: shouldEvaluateLightness,
            getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor,
            getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor
        };
        $[4] = getDarkModeCompatibleBackgroundColor;
        $[5] = getDarkModeCompatibleTextColor;
        $[6] = shouldEvaluateLightness;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (isSSRProductInDarkMode)=>{
    const isSpaAkThemeInDarkMode = (0, $IQ4Dz.default)().colorMode === 'dark';
    const shouldEvaluateLightness = isSpaAkThemeInDarkMode;
    const getDarkModeCompatibleBackgroundColor = (0, $cozmU.useCallback)((backgroundColor)=>{
        return shouldEvaluateLightness ? $cbf4e122dd89063e$export$f11b6ab43332cfcf(backgroundColor) : backgroundColor;
    }, [
        shouldEvaluateLightness
    ]);
    const getDarkModeCompatibleTextColor = (0, $cozmU.useCallback)((textColor)=>{
        return shouldEvaluateLightness ? (0, $iRKv3.increaseLightness)(textColor, $cbf4e122dd89063e$var$TEXT_LIGHTNESS_MIN) : textColor;
    }, [
        shouldEvaluateLightness
    ]);
    return {
        shouldEvaluateBackgroundLightness: shouldEvaluateLightness,
        getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor,
        getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor
    };
};
module.exports["useDarkModeColors"] = $cbf4e122dd89063e$export$c17d6b0d1b5d5ab6;

});

parcelRegister("iRKv3", function(module, exports) {
const $8fc3f1a6584fae2a$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $8fc3f1a6584fae2a$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_m, r, g, b)=>r + r + g + g + b + b);
const $8fc3f1a6584fae2a$var$rgbFromHex = (input)=>{
    const fullHex = $8fc3f1a6584fae2a$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $8fc3f1a6584fae2a$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $8fc3f1a6584fae2a$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $8fc3f1a6584fae2a$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $8fc3f1a6584fae2a$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $8fc3f1a6584fae2a$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $8fc3f1a6584fae2a$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $8fc3f1a6584fae2a$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $8fc3f1a6584fae2a$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $8fc3f1a6584fae2a$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $8fc3f1a6584fae2a$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $8fc3f1a6584fae2a$var$rgbToLch = (rgb)=>$8fc3f1a6584fae2a$var$labToLch($8fc3f1a6584fae2a$var$xyzToLab($8fc3f1a6584fae2a$var$rgbToXyz(rgb)));
const $8fc3f1a6584fae2a$var$lchToRgb = (lch)=>$8fc3f1a6584fae2a$var$xyzToRgb($8fc3f1a6584fae2a$var$labToXyz($8fc3f1a6584fae2a$var$lchToLab(lch)));
const $8fc3f1a6584fae2a$export$f38e45b0889fb431 = (hexColor)=>{
    const rgb = $8fc3f1a6584fae2a$var$rgbFromHex(hexColor);
    if (rgb === null) return undefined;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $8fc3f1a6584fae2a$var$rgbToLch(rgb);
    return lch.l;
};
const $8fc3f1a6584fae2a$var$modifyLightness = (hexColor, percent, getShouldModifyLightness)=>{
    const rgb = $8fc3f1a6584fae2a$var$rgbFromHex(hexColor);
    if (rgb === null) return hexColor;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $8fc3f1a6584fae2a$var$rgbToLch(rgb);
    if (getShouldModifyLightness(lch.l)) lch.l = $8fc3f1a6584fae2a$var$clamp(percent, 0, 100);
    return $8fc3f1a6584fae2a$var$rgbToHex($8fc3f1a6584fae2a$var$lchToRgb(lch));
};
const $8fc3f1a6584fae2a$export$5ec9a60e757390f1 = (hexColor, capPercent)=>{
    return $8fc3f1a6584fae2a$var$modifyLightness(hexColor, capPercent, (lightnessValue)=>lightnessValue > capPercent);
};
const $8fc3f1a6584fae2a$export$16d9f224c1d58542 = (hexColor, minPercent)=>{
    return $8fc3f1a6584fae2a$var$modifyLightness(hexColor, minPercent, (lightnessValue)=>lightnessValue < minPercent);
};
module.exports["getLightnessPercentage"] = $8fc3f1a6584fae2a$export$f38e45b0889fb431;
module.exports["reduceLightness"] = $8fc3f1a6584fae2a$export$5ec9a60e757390f1;
module.exports["increaseLightness"] = $8fc3f1a6584fae2a$export$16d9f224c1d58542;

});

parcelRegister("hiHdh", function(module, exports) {
const $b0eebcea05486c9f$export$9860c2f1456a166d = (editorActions, updatedParameters)=>{
    const selectedNodeJSON = editorActions.getSelectedNode()?.toJSON();
    const updatedNodeSelection = {
        ...selectedNodeJSON,
        attrs: {
            ...selectedNodeJSON?.attrs,
            parameters: {
                ...updatedParameters
            }
        }
    };
    return editorActions.replaceSelection(updatedNodeSelection, true);
};
const $b0eebcea05486c9f$export$39874bca494f9ba3 = (editorActions, nodeAdf)=>{
    return editorActions.replaceSelection(nodeAdf, true);
};
module.exports["updateNodeParameters"] = $b0eebcea05486c9f$export$9860c2f1456a166d;
module.exports["replaceSelectedNode"] = $b0eebcea05486c9f$export$39874bca494f9ba3;

});

parcelRegister("eafQX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $iDrrr = parcelRequire("iDrrr");


var $j0Q3v = parcelRequire("j0Q3v");

const $14392eb285344a6f$export$186c72664a5e904e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const isAdvancedThemingEnabled = (0, $j0Q3v.useIsAdvancedThemingEnabled)();
    let t0;
    if ($[0] !== isAdvancedThemingEnabled) {
        t0 = isAdvancedThemingEnabled && (0, $iDrrr.fg)("hub-corner-radius");
        $[0] = isAdvancedThemingEnabled;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const isAdvancedThemingEnabled = (0, $j0Q3v.useIsAdvancedThemingEnabled)();
    return isAdvancedThemingEnabled && (0, $iDrrr.fg)('hub-corner-radius');
};
module.exports["useIsHubCornerRadiusEnabled"] = $14392eb285344a6f$export$186c72664a5e904e;

});

parcelRegister("bktnv", function(module, exports) {
const $cc9ed25d5fd49b91$export$573ee875a39e7e73 = ({ key: key, icons: icons, parameters: parameters, update: update, render: render, title: title, type: type, description: description, source: source, nodeType: nodeType = 'extension', quickInsertAction: quickInsertAction, setUpsellModalSource: setUpsellModalSource, additionalModuleNodeProps: additionalModuleNodeProps })=>{
    return {
        title: title,
        type: type,
        key: key,
        description: description,
        icons: icons,
        modules: {
            quickInsert: setUpsellModalSource ? [
                {
                    key: 'quick-insert',
                    action: async ()=>setUpsellModalSource(source)
                }
            ] : [
                {
                    key: 'quick-insert',
                    action: quickInsertAction || {
                        type: 'node',
                        key: 'default',
                        parameters: parameters
                    }
                }
            ],
            nodes: {
                default: {
                    type: nodeType,
                    render: render,
                    update: update,
                    ...additionalModuleNodeProps
                }
            }
        }
    };
};
module.exports["getExtensionManifest"] = $cc9ed25d5fd49b91$export$573ee875a39e7e73;

});

parcelRegister("5dDC4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $f3HCt = parcelRequire("f3HCt");


var $kA6Zo = parcelRequire("kA6Zo");

var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $cfM7x = parcelRequire("cfM7x");




const $d9cf7ece72c90013$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    shareFeedbackButtonTextExtension: {
        id: "company-hub.company-hub-common.config-panel.feedback-section.share-feedback-button.text-extension",
        defaultMessage: "{type, select, Cards {Give feedback on Cards} Carousel {Give feedback on Carousel} Linksmenu {Give feedback on Links menu} Spotlight {Give feedback on Spotlight} Section {Give feedback on Section} Customsearch {Give feedback on Custom Search} Companyhub {Give feedback on Company hub} other {Share your thoughts}}"
    },
    feedbackCollectorModalPreambleFirstLine: {
        id: "company-hub.company-hub-common.config-panel.feedback-collector.preamble.first-line",
        defaultMessage: "Your input is valuable and allows us to better meet your needs. What could be improved?"
    },
    feedbackCollectorModalSummaryPlaceholder: {
        id: "company-hub.company-hub-common.config-panel.feedback-collector.summary-placeholder",
        defaultMessage: "What works well? What could be improved?"
    },
    feedbackCollectorButtonPreamble: {
        id: "company-hub.company-hub-common.config-panel.feedback-section.preamble",
        defaultMessage: "Your feedback helps us improve."
    }
});


const $f077bcb10a81bd8a$var$buttonContentWrapperStyles = (0, $buxP3.xcss)({
    height: '20px'
});
const $f077bcb10a81bd8a$var$buttonStyles = (0, $buxP3.xcss)({
    width: '100%',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    color: 'color.text',
    paddingInline: 'space.200',
    paddingBlock: 'space.050',
    alignItems: 'center',
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.accent.gray.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.gray.subtlest.pressed'
    }
});
const $f077bcb10a81bd8a$export$266666366970ab01 = ({ source: source, type: type })=>{
    const { useFeedbackCollector: useFeedbackCollector } = (0, $cfM7x.useProductDependencies)();
    const openFeedbackCollector = useFeedbackCollector?.({
        source: source,
        type: type
    });
    // Feedback button won't render if it isn't provided in the product dependencies
    if (!useFeedbackCollector) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        xcss: $f077bcb10a81bd8a$var$buttonStyles,
        onClick: openFeedbackCollector,
        testId: "feedback-collector-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.100",
        xcss: $f077bcb10a81bd8a$var$buttonContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f3HCt))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $d9cf7ece72c90013$export$defe85febe8b728c).shareFeedbackButtonTextExtension,
        values: {
            type: type.replace(/\s/g, '')
        }
    })));
};
module.exports["ConfigPanelFeedbackCollector"] = $f077bcb10a81bd8a$export$266666366970ab01;

});

parcelRegister("a96iv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $7akNQ = parcelRequire("7akNQ");


var $l3wuH = parcelRequire("l3wuH");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $kA6Zo = parcelRequire("kA6Zo");

var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");




const $dc8fac1b2005d111$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    close: {
        id: "company-hub-common.config-panel.panel-close-button.close-label",
        defaultMessage: "Close configuration panel"
    }
});


const $d195f0cbae3c8684$var$titleWrapperStyles = (0, $buxP3.xcss)({
    minWidth: '270px',
    paddingBlock: 'space.100'
});
const $d195f0cbae3c8684$var$closeIconWrapperStyles = (0, $buxP3.xcss)({
    marginLeft: 'auto'
});
const $d195f0cbae3c8684$var$containerStyles = (0, $buxP3.xcss)({
    height: '100%'
});
const $d195f0cbae3c8684$export$e1b80720de5d513e = ({ title: title, children: children, footerComponent: FooterComponent, buttonIcon: buttonIcon = null, closeConfigPanel: closeConfigPanel })=>{
    // Opt out of React Compiler: when `pcs-3808077-links-menu-react-compiler-fixes` is off,
    // `FooterComponent` is invoked as a plain function (`FooterComponent({})`), which auto-memoization
    // turns into a hook-count mismatch (React #300). See HOT-304566 / PIR-302437.
    // Remove once that fix flag is fully rolled out.
    'use no memo';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        columnGap: "space.300",
        justifyContent: "space-between",
        direction: "column",
        xcss: $d195f0cbae3c8684$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "start",
        alignItems: "center",
        gap: "space.100",
        xcss: $d195f0cbae3c8684$var$titleWrapperStyles
    }, buttonIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "large",
        weight: "medium"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $d195f0cbae3c8684$var$closeIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnClick: true,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dc8fac1b2005d111$export$defe85febe8b728c).close)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        onClick: closeConfigPanel,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dc8fac1b2005d111$export$defe85febe8b728c).close),
        testId: "panel-close-button",
        isTooltipDisabled: false
    })))), children), FooterComponent && ((0, $iDrrr.fg)('pcs-3808077-links-menu-react-compiler-fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FooterComponent, null) : FooterComponent({}))));
};
module.exports["ExtensionsConfigWrapper"] = $d195f0cbae3c8684$export$e1b80720de5d513e;

});

parcelRegister("4cGll", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cfM7x = parcelRequire("cfM7x");

const $72e62c2cf43c3d17$export$104752126b2ea779 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { feature: feature, children: children } = t0;
    const { ConfigUpsellScreen: ConfigUpsellScreen } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== ConfigUpsellScreen || $[1] !== children || $[2] !== feature) {
        t1 = ConfigUpsellScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ConfigUpsellScreen, {
            feature: feature
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = ConfigUpsellScreen;
        $[1] = children;
        $[2] = feature;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ feature: feature, children: children })=>{
    const { ConfigUpsellScreen: ConfigUpsellScreen } = (0, $cfM7x.useProductDependencies)();
    return ConfigUpsellScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ConfigUpsellScreen, {
        feature: feature
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["PremiumGateForExtensionConfigPanel"] = $72e62c2cf43c3d17$export$104752126b2ea779;

});

parcelRegister("cXCJB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $5wHqn = parcelRequire("5wHqn");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $xYZ24 = parcelRequire("xYZ24");











var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");




var $kz1Yj = parcelRequire("kz1Yj");

var $kh0hi = parcelRequire("kh0hi");




var $jxm4A = parcelRequire("jxm4A");




const $e6f525bf11c12b13$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    triggerPrefixLabel: {
        id: "company-hub.color-picker.trigger.prefix.label",
        defaultMessage: "color"
    },
    triggerPostfixLabel: {
        id: "company-hub.color-picker.trigger.postfix.label",
        defaultMessage: "trigger"
    }
});












var $9FyRG = parcelRequire("9FyRG");






const $f5498af440ff4a89$var$barStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    left: 'space.0',
    right: 'space.0',
    top: '18px',
    margin: 'auto',
    width: "var(--ds-space-200, 16px)",
    height: '3px'
});
const $f5498af440ff4a89$var$textColorIconWrapper = (0, $buxP3.xcss)({
    position: 'relative'
});
const $f5498af440ff4a89$export$36ed63fbff8ebdac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { selectedColor: selectedColor, isSelected: t1, testId: testId, isDisabled: isDisabled } = t0;
    const isSelected = t1 === undefined ? false : t1;
    let textColor = isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtle, #505258)";
    if (isDisabled) textColor = "var(--ds-text-disabled, #080F214A)";
    let t2;
    if ($[0] !== textColor) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
            label: "",
            spacing: "spacious",
            color: textColor
        });
        $[0] = textColor;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = isDisabled ? "var(--ds-background-disabled, #0515240F)" : selectedColor;
    let t4;
    if ($[2] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            style: {
                background: t3
            },
            xcss: $f5498af440ff4a89$var$barStyles
        });
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t2 || $[5] !== t4 || $[6] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: testId,
            xcss: $f5498af440ff4a89$var$textColorIconWrapper
        }, t2, t4);
        $[4] = t2;
        $[5] = t4;
        $[6] = testId;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ selectedColor: selectedColor, isSelected: isSelected = false, testId: testId, isDisabled: isDisabled })=>{
    let textColor = isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtle, #505258)";
    if (isDisabled) textColor = "var(--ds-text-disabled, #080F214A)";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        testId: testId,
        xcss: $f5498af440ff4a89$var$textColorIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
        label: "",
        spacing: "spacious",
        color: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        style: {
            background: isDisabled ? "var(--ds-background-disabled, #0515240F)" : selectedColor
        },
        xcss: $f5498af440ff4a89$var$barStyles
    }));
};


const $5c1dd2d6ab5167a8$var$triggerStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-input, #FFFFFF)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    transition: 'background 0.1s ease-out',
    borderRadius: 'radius.small',
    padding: 'space.100',
    backgroundColor: 'elevation.surface.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.overlay.pressed'
    }
});
const $5c1dd2d6ab5167a8$var$selectedButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected',
    borderColor: 'color.border.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $5c1dd2d6ab5167a8$var$borderLessStyle = (0, $buxP3.xcss)({
    border: 'none'
});
const $5c1dd2d6ab5167a8$var$fullWidthStyle = (0, $buxP3.xcss)({
    width: '240px'
});
const $5c1dd2d6ab5167a8$var$iconOnlyStyle = (0, $buxP3.xcss)({
    paddingBlock: 'space.050'
});
const $5c1dd2d6ab5167a8$var$triggerContentStyles = (0, $buxP3.xcss)({
    alignItems: 'center'
});
const $5c1dd2d6ab5167a8$var$iconOnlyContentStyles = (0, $buxP3.xcss)({
    gap: 'space.100'
});
const $5c1dd2d6ab5167a8$var$fullWidthContentStyles = (0, $buxP3.xcss)({
    gap: 'space.075'
});
const $5c1dd2d6ab5167a8$var$colorLabelStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    display: 'inline-block',
    flex: '1 0 0',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $5c1dd2d6ab5167a8$export$b76ce78c787fa4d2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(72);
    let builtInColorMap;
    let pickerTitle;
    let props;
    let t1;
    let t2;
    let t3;
    let t4;
    let value;
    if ($[0] !== t0) {
        const { builtInColorMap: t5, value: t6, analyticsSource: analyticsSource, pickerTitle: t7, isFullWidth: t8, showTextIcon: t9, enableBorderLessStyle: t10, isDisabled: t11, ...t12 } = t0;
        builtInColorMap = t5;
        value = t6;
        pickerTitle = t7;
        t1 = t8;
        t2 = t9;
        t3 = t10;
        t4 = t11;
        props = t12;
        $[0] = t0;
        $[1] = builtInColorMap;
        $[2] = pickerTitle;
        $[3] = props;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
        $[8] = value;
    } else {
        builtInColorMap = $[1];
        pickerTitle = $[2];
        props = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
        t4 = $[7];
        value = $[8];
    }
    const isFullWidth = t1 === undefined ? false : t1;
    const showTextIcon = t2 === undefined ? false : t2;
    const enableBorderLessStyle = t3 === undefined ? false : t3;
    const isDisabled = t4 === undefined ? false : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let T0;
    let T1;
    let isOpen;
    let spacing;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[9] !== builtInColorMap || $[10] !== enableBorderLessStyle || $[11] !== formatMessage || $[12] !== isDisabled || $[13] !== isFullWidth || $[14] !== pickerTitle || $[15] !== props || $[16] !== ref || $[17] !== showTextIcon || $[18] !== value) {
        const colorName = builtInColorMap.humanReadableColors.get(value);
        const size = !isFullWidth ? "16" : "24";
        spacing = !isFullWidth ? "none" : "spacious";
        const padding = size === "16" ? "space.050" : "space.0";
        isOpen = props["aria-expanded"];
        const t15 = pickerTitle || (0, $e6f525bf11c12b13$export$defe85febe8b728c).triggerPrefixLabel;
        let t16;
        if ($[33] !== formatMessage || $[34] !== t15) {
            t16 = formatMessage(t15);
            $[33] = formatMessage;
            $[34] = t15;
            $[35] = t16;
        } else t16 = $[35];
        let t17;
        if ($[36] !== formatMessage) {
            t17 = formatMessage((0, $e6f525bf11c12b13$export$defe85febe8b728c).triggerPostfixLabel);
            $[36] = formatMessage;
            $[37] = t17;
        } else t17 = $[37];
        const label = `${t16} ${t17}`;
        T1 = (0, $kh0hi.default);
        t8 = props;
        t9 = label;
        t10 = label;
        t11 = isDisabled;
        t12 = isDisabled;
        t13 = ref;
        const t18 = isFullWidth ? $5c1dd2d6ab5167a8$var$fullWidthStyle : $5c1dd2d6ab5167a8$var$iconOnlyStyle;
        const t19 = isOpen && $5c1dd2d6ab5167a8$var$selectedButtonStyles;
        const t20 = enableBorderLessStyle && $5c1dd2d6ab5167a8$var$borderLessStyle;
        if ($[38] !== t18 || $[39] !== t19 || $[40] !== t20) {
            t14 = [
                $5c1dd2d6ab5167a8$var$triggerStyles,
                t18,
                t19,
                t20
            ];
            $[38] = t18;
            $[39] = t19;
            $[40] = t20;
            $[41] = t14;
        } else t14 = $[41];
        T0 = (0, $kz1Yj.default);
        const t21 = isFullWidth ? $5c1dd2d6ab5167a8$var$fullWidthContentStyles : $5c1dd2d6ab5167a8$var$iconOnlyContentStyles;
        if ($[42] !== t21) {
            t5 = [
                $5c1dd2d6ab5167a8$var$triggerContentStyles,
                t21
            ];
            $[42] = t21;
            $[43] = t5;
        } else t5 = $[43];
        if ($[44] !== builtInColorMap || $[45] !== isDisabled || $[46] !== isOpen || $[47] !== padding || $[48] !== showTextIcon || $[49] !== size || $[50] !== value) {
            t6 = showTextIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5498af440ff4a89$export$36ed63fbff8ebdac), {
                testId: "color-picker-trigger-text-icon",
                selectedColor: value,
                isSelected: isOpen,
                isDisabled: isDisabled
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                padding: padding
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxm4A.ColorTile), {
                testId: "color-picker-trigger-color-tile",
                size: size,
                builtInColorMap: builtInColorMap,
                value: value
            }));
            $[44] = builtInColorMap;
            $[45] = isDisabled;
            $[46] = isOpen;
            $[47] = padding;
            $[48] = showTextIcon;
            $[49] = size;
            $[50] = value;
            $[51] = t6;
        } else t6 = $[51];
        t7 = isFullWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: $5c1dd2d6ab5167a8$var$colorLabelStyles
        }, colorName ? formatMessage(colorName) : value.toUpperCase());
        $[9] = builtInColorMap;
        $[10] = enableBorderLessStyle;
        $[11] = formatMessage;
        $[12] = isDisabled;
        $[13] = isFullWidth;
        $[14] = pickerTitle;
        $[15] = props;
        $[16] = ref;
        $[17] = showTextIcon;
        $[18] = value;
        $[19] = T0;
        $[20] = T1;
        $[21] = isOpen;
        $[22] = spacing;
        $[23] = t10;
        $[24] = t11;
        $[25] = t12;
        $[26] = t13;
        $[27] = t14;
        $[28] = t5;
        $[29] = t6;
        $[30] = t7;
        $[31] = t8;
        $[32] = t9;
    } else {
        T0 = $[19];
        T1 = $[20];
        isOpen = $[21];
        spacing = $[22];
        t10 = $[23];
        t11 = $[24];
        t12 = $[25];
        t13 = $[26];
        t14 = $[27];
        t5 = $[28];
        t6 = $[29];
        t7 = $[30];
        t8 = $[31];
        t9 = $[32];
    }
    let t15;
    if ($[52] !== isDisabled || $[53] !== isOpen || $[54] !== spacing) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5c1dd2d6ab5167a8$var$ExpandCollapseIcon, {
            spacing: spacing,
            isExpanded: isOpen,
            isDisabled: isDisabled
        });
        $[52] = isDisabled;
        $[53] = isOpen;
        $[54] = spacing;
        $[55] = t15;
    } else t15 = $[55];
    let t16;
    if ($[56] !== T0 || $[57] !== t15 || $[58] !== t5 || $[59] !== t6 || $[60] !== t7) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t5
        }, t6, t7, t15);
        $[56] = T0;
        $[57] = t15;
        $[58] = t5;
        $[59] = t6;
        $[60] = t7;
        $[61] = t16;
    } else t16 = $[61];
    let t17;
    if ($[62] !== T1 || $[63] !== t10 || $[64] !== t11 || $[65] !== t12 || $[66] !== t13 || $[67] !== t14 || $[68] !== t16 || $[69] !== t8 || $[70] !== t9) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            ...t8,
            "aria-label": t9,
            title: t10,
            isDisabled: t11,
            "aria-disabled": t12,
            ref: t13,
            xcss: t14
        }, t16);
        $[62] = T1;
        $[63] = t10;
        $[64] = t11;
        $[65] = t12;
        $[66] = t13;
        $[67] = t14;
        $[68] = t16;
        $[69] = t8;
        $[70] = t9;
        $[71] = t17;
    } else t17 = $[71];
    return t17;
} : ({ builtInColorMap: builtInColorMap, value: value, analyticsSource: analyticsSource, pickerTitle: pickerTitle, isFullWidth: isFullWidth = false, showTextIcon: showTextIcon = false, enableBorderLessStyle: enableBorderLessStyle = false, isDisabled: isDisabled = false, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const colorName = builtInColorMap.humanReadableColors.get(value);
    const size = !isFullWidth ? '16' : '24';
    const spacing = !isFullWidth ? 'none' : 'spacious';
    const padding = size === '16' ? 'space.050' : 'space.0';
    const isOpen = props['aria-expanded'];
    const label = `${formatMessage(pickerTitle || (0, $e6f525bf11c12b13$export$defe85febe8b728c).triggerPrefixLabel)} ${formatMessage((0, $e6f525bf11c12b13$export$defe85febe8b728c).triggerPostfixLabel)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        ...props,
        "aria-label": label,
        title: label,
        isDisabled: isDisabled,
        "aria-disabled": isDisabled,
        ref: ref,
        xcss: [
            $5c1dd2d6ab5167a8$var$triggerStyles,
            isFullWidth ? $5c1dd2d6ab5167a8$var$fullWidthStyle : $5c1dd2d6ab5167a8$var$iconOnlyStyle,
            isOpen && $5c1dd2d6ab5167a8$var$selectedButtonStyles,
            enableBorderLessStyle && $5c1dd2d6ab5167a8$var$borderLessStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: [
            $5c1dd2d6ab5167a8$var$triggerContentStyles,
            isFullWidth ? $5c1dd2d6ab5167a8$var$fullWidthContentStyles : $5c1dd2d6ab5167a8$var$iconOnlyContentStyles
        ]
    }, showTextIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5498af440ff4a89$export$36ed63fbff8ebdac), {
        testId: "color-picker-trigger-text-icon",
        selectedColor: value,
        isSelected: isOpen,
        isDisabled: isDisabled
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        padding: padding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxm4A.ColorTile), {
        testId: "color-picker-trigger-color-tile",
        size: size,
        builtInColorMap: builtInColorMap,
        value: value
    })), isFullWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $5c1dd2d6ab5167a8$var$colorLabelStyles
    }, colorName ? formatMessage(colorName) : value.toUpperCase()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5c1dd2d6ab5167a8$var$ExpandCollapseIcon, {
        spacing: spacing,
        isExpanded: isOpen,
        isDisabled: isDisabled
    })));
});
const $5c1dd2d6ab5167a8$var$iconContainerStyles = (0, $buxP3.xcss)({
    flexShrink: 0
});
const $5c1dd2d6ab5167a8$var$chevronPaddingStyles = (0, $buxP3.xcss)({
    paddingRight: 'space.050'
});
const $5c1dd2d6ab5167a8$var$ExpandCollapseIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { isExpanded: t1, spacing: spacing, isDisabled: isDisabled } = t0;
    const isExpanded = t1 === undefined ? false : t1;
    let textColor = isExpanded ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtle, #505258)";
    if (isDisabled) textColor = "var(--ds-text-disabled, #080F214A)";
    const t2 = spacing === "none" && $5c1dd2d6ab5167a8$var$chevronPaddingStyles;
    let t3;
    if ($[0] !== t2) {
        t3 = [
            $5c1dd2d6ab5167a8$var$iconContainerStyles,
            t2
        ];
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== spacing || $[3] !== textColor) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            spacing: spacing,
            label: "",
            color: textColor,
            size: "small"
        });
        $[2] = spacing;
        $[3] = textColor;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t3
        }, t4);
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ isExpanded: isExpanded = false, spacing: spacing, isDisabled: isDisabled })=>{
    let textColor = isExpanded ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtle, #505258)";
    if (isDisabled) textColor = "var(--ds-text-disabled, #080F214A)";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            $5c1dd2d6ab5167a8$var$iconContainerStyles,
            spacing === 'none' && $5c1dd2d6ab5167a8$var$chevronPaddingStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        spacing: spacing,
        label: "",
        color: textColor,
        size: "small"
    }));
};


const $4a009ce0ab74939d$var$popupComponentStyles = (0, $buxP3.xcss)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    padding: 'space.150'
});
const $4a009ce0ab74939d$var$PopupComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(7);
    let props;
    let testId;
    if ($[0] !== t0) {
        ({ "data-testid": testId, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = testId;
    } else {
        props = $[1];
        testId = $[2];
    }
    let t1;
    if ($[3] !== props || $[4] !== ref || $[5] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: testId,
            ...props,
            ref: ref,
            xcss: $4a009ce0ab74939d$var$popupComponentStyles
        });
        $[3] = props;
        $[4] = ref;
        $[5] = testId;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ 'data-testid': testId, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        testId: testId,
        ...props,
        ref: ref,
        xcss: $4a009ce0ab74939d$var$popupComponentStyles
    }));
const $4a009ce0ab74939d$export$9feb1bc2e5f1ccb3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { builtInColorMap: builtInColorMap, isReadableColor: isReadableColor, onChange: onChange, value: value, isFullWidth: isFullWidth, pickerTitle: pickerTitle, showCustomPalette: showCustomPalette, showResetButton: showResetButton, showTextIcon: showTextIcon, validationSuccessMessage: validationSuccessMessage, validationFailMessage: validationFailMessage, analyticsSource: analyticsSource, isDisabled: t1, showCloseButton: t2, enableBorderLessStyle: t3, isOpen: t4 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const showCloseButton = t2 === undefined ? false : t2;
    const enableBorderLessStyle = t3 === undefined ? false : t3;
    const isOpen = t4 === undefined ? false : t4;
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(isOpen);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>setIsPopupOpen(false);
        $[0] = t5;
    } else t5 = $[0];
    const onPopupClose = t5;
    let t6;
    if ($[1] !== analyticsSource || $[2] !== createAnalyticsEvent || $[3] !== isPopupOpen) {
        t6 = ()=>{
            if (analyticsSource && !isPopupOpen) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "colorPickerOpened",
                    source: analyticsSource
                }
            }).fire();
            setIsPopupOpen($4a009ce0ab74939d$var$_temp);
        };
        $[1] = analyticsSource;
        $[2] = createAnalyticsEvent;
        $[3] = isPopupOpen;
        $[4] = t6;
    } else t6 = $[4];
    const onTriggerClick = t6;
    let t7;
    if ($[5] !== analyticsSource || $[6] !== builtInColorMap || $[7] !== isReadableColor || $[8] !== onChange || $[9] !== pickerTitle || $[10] !== showCloseButton || $[11] !== showCustomPalette || $[12] !== showResetButton || $[13] !== validationFailMessage || $[14] !== validationSuccessMessage || $[15] !== value) {
        t7 = (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $xYZ24.ColorPickerDropdown), {
                ...contentProps,
                analyticsSource: analyticsSource,
                builtInColorMap: builtInColorMap,
                isReadableColor: isReadableColor,
                onChange: onChange,
                value: value,
                pickerTitle: pickerTitle,
                showCustomPalette: showCustomPalette,
                showResetButton: showResetButton,
                validationSuccessMessage: validationSuccessMessage,
                validationFailMessage: validationFailMessage,
                showCloseButton: showCloseButton
            });
        $[5] = analyticsSource;
        $[6] = builtInColorMap;
        $[7] = isReadableColor;
        $[8] = onChange;
        $[9] = pickerTitle;
        $[10] = showCloseButton;
        $[11] = showCustomPalette;
        $[12] = showResetButton;
        $[13] = validationFailMessage;
        $[14] = validationSuccessMessage;
        $[15] = value;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== analyticsSource || $[18] !== builtInColorMap || $[19] !== enableBorderLessStyle || $[20] !== isDisabled || $[21] !== isFullWidth || $[22] !== onTriggerClick || $[23] !== pickerTitle || $[24] !== showTextIcon || $[25] !== value) {
        t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c1dd2d6ab5167a8$export$b76ce78c787fa4d2), {
                ...triggerProps,
                builtInColorMap: builtInColorMap,
                onClick: onTriggerClick,
                value: value,
                isDisabled: isDisabled,
                analyticsSource: analyticsSource,
                isFullWidth: isFullWidth,
                showTextIcon: showTextIcon,
                pickerTitle: pickerTitle,
                enableBorderLessStyle: enableBorderLessStyle
            });
        $[17] = analyticsSource;
        $[18] = builtInColorMap;
        $[19] = enableBorderLessStyle;
        $[20] = isDisabled;
        $[21] = isFullWidth;
        $[22] = onTriggerClick;
        $[23] = pickerTitle;
        $[24] = showTextIcon;
        $[25] = value;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== isPopupOpen || $[28] !== t7 || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
            autoFocus: false,
            content: t7,
            isOpen: isPopupOpen,
            onClose: onPopupClose,
            placement: "bottom-end",
            testId: "color-picker-popup",
            popupComponent: $4a009ce0ab74939d$var$PopupComponent,
            trigger: t8
        });
        $[27] = isPopupOpen;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    return t9;
} : ({ builtInColorMap: builtInColorMap, isReadableColor: isReadableColor, onChange: onChange, value: value, isFullWidth: isFullWidth, pickerTitle: pickerTitle, showCustomPalette: showCustomPalette, showResetButton: showResetButton, showTextIcon: showTextIcon, validationSuccessMessage: validationSuccessMessage, validationFailMessage: validationFailMessage, analyticsSource: analyticsSource, isDisabled: isDisabled = false, showCloseButton: showCloseButton = false, enableBorderLessStyle: enableBorderLessStyle = false, isOpen: isOpen = false })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(isOpen);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPopupClose = ()=>setIsPopupOpen(false);
    const onTriggerClick = (0, $cozmU.useCallback)(()=>{
        if (analyticsSource && !isPopupOpen) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'colorPickerOpened',
                source: analyticsSource
            }
        }).fire();
        setIsPopupOpen((prev)=>!prev);
    }, [
        analyticsSource,
        createAnalyticsEvent,
        isPopupOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        autoFocus: false,
        content: (contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $xYZ24.ColorPickerDropdown), {
                ...contentProps,
                analyticsSource: analyticsSource,
                builtInColorMap: builtInColorMap,
                isReadableColor: isReadableColor,
                onChange: onChange,
                value: value,
                pickerTitle: pickerTitle,
                showCustomPalette: showCustomPalette,
                showResetButton: showResetButton,
                validationSuccessMessage: validationSuccessMessage,
                validationFailMessage: validationFailMessage,
                showCloseButton: showCloseButton
            }),
        isOpen: isPopupOpen,
        onClose: onPopupClose,
        placement: "bottom-end",
        testId: "color-picker-popup",
        popupComponent: $4a009ce0ab74939d$var$PopupComponent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c1dd2d6ab5167a8$export$b76ce78c787fa4d2), {
                ...triggerProps,
                builtInColorMap: builtInColorMap,
                onClick: onTriggerClick,
                value: value,
                isDisabled: isDisabled,
                analyticsSource: analyticsSource,
                isFullWidth: isFullWidth,
                showTextIcon: showTextIcon,
                pickerTitle: pickerTitle,
                enableBorderLessStyle: enableBorderLessStyle
            })
    });
};
function $4a009ce0ab74939d$var$_temp(prev) {
    return !prev;
}
module.exports["ColorPicker"] = $4a009ce0ab74939d$export$9feb1bc2e5f1ccb3;

});

parcelRegister("xYZ24", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $kA6Zo = parcelRequire("kA6Zo");

var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $fLf0C = parcelRequire("fLf0C");








var $3McNX = parcelRequire("3McNX");





var $kB5K2 = parcelRequire("kB5K2");


var $3izAL = parcelRequire("3izAL");








var $6wGOF = parcelRequire("6wGOF");


var $4yUlE = parcelRequire("4yUlE");











var $gRlff = parcelRequire("gRlff");





var $9DHhW = parcelRequire("9DHhW");






const $69b2218e1ff1924f$var$saturationStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    height: '137px',
    position: 'relative',
    width: '100%'
});
const $69b2218e1ff1924f$var$hueStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    height: '8px',
    position: 'relative',
    width: '100%'
});
const $69b2218e1ff1924f$export$9fe2579179d7c943 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { analyticsSource: analyticsSource, value: value, onChange: onChange } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== value) {
        t1 = value.toHsl();
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    const hsl = t1;
    let t2;
    if ($[2] !== value) {
        t2 = value.toHsv();
        $[2] = value;
        $[3] = t2;
    } else t2 = $[3];
    const hsv = t2;
    let t3;
    if ($[4] !== analyticsSource || $[5] !== createAnalyticsEvent || $[6] !== onChange) {
        t3 = (color)=>{
            onChange((0, $3McNX.default)(color).toHexString());
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "CustomColor",
                    actionSubjectId: "customPalette",
                    source: analyticsSource
                }
            }).fire();
        };
        $[4] = analyticsSource;
        $[5] = createAnalyticsEvent;
        $[6] = onChange;
        $[7] = t3;
    } else t3 = $[7];
    const onHueOrSaturationChange = t3;
    let t4;
    if ($[8] !== hsl || $[9] !== hsv || $[10] !== onHueOrSaturationChange) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $69b2218e1ff1924f$var$saturationStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRlff.Saturation), {
            hsl: hsl,
            hsv: hsv,
            onChange: onHueOrSaturationChange,
            pointer: $69b2218e1ff1924f$var$EllipsePointer,
            radius: "4px"
        }));
        $[8] = hsl;
        $[9] = hsv;
        $[10] = onHueOrSaturationChange;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== hsl || $[13] !== onHueOrSaturationChange) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $69b2218e1ff1924f$var$hueStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRlff.Hue), {
            direction: "horizontal",
            hsl: hsl,
            onChange: onHueOrSaturationChange,
            pointer: $69b2218e1ff1924f$var$EllipsePointer,
            radius: "100px"
        }));
        $[12] = hsl;
        $[13] = onHueOrSaturationChange;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== t4 || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ analyticsSource: analyticsSource, value: value, onChange: onChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hsl = value.toHsl();
    const hsv = value.toHsv();
    const onHueOrSaturationChange = (color)=>{
        onChange((0, $3McNX.default)(color).toHexString());
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'CustomColor',
                actionSubjectId: 'customPalette',
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $69b2218e1ff1924f$var$saturationStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRlff.Saturation), {
        hsl: hsl,
        hsv: hsv,
        onChange: onHueOrSaturationChange,
        pointer: $69b2218e1ff1924f$var$EllipsePointer,
        radius: "4px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $69b2218e1ff1924f$var$hueStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRlff.Hue), {
        direction: "horizontal",
        hsl: hsl,
        onChange: onHueOrSaturationChange,
        pointer: $69b2218e1ff1924f$var$EllipsePointer,
        radius: "100px"
    })));
};
const $69b2218e1ff1924f$var$pointerStyles = (0, $buxP3.xcss)({
    border: `${"var(--ds-border-width-selected, 2px)"} solid white`,
    borderRadius: 'radius.full',
    cursor: 'pointer',
    height: '8px',
    width: '8px'
});
const $69b2218e1ff1924f$var$EllipsePointer = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $69b2218e1ff1924f$var$pointerStyles
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $69b2218e1ff1924f$var$pointerStyles
    });




















var $4yg9g = parcelRequire("4yg9g");


var $jxm4A = parcelRequire("jxm4A");

const $a11790b7b1207361$var$colorTileContainerStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    paddingLeft: 'space.100'
});
const $a11790b7b1207361$export$5a1d7ca0a925d9c2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    let { analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, children: children, id: id, name: name, onChange: onChange, value: value } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== value) {
        t1 = value.toLowerCase();
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    value = t1;
    let t2;
    if ($[2] !== onChange) {
        t2 = (event)=>{
            onChange(event.currentTarget.value.toLowerCase());
        };
        $[2] = onChange;
        $[3] = t2;
    } else t2 = $[3];
    const onTextFieldChange = t2;
    let t3;
    if ($[4] !== analyticsSource || $[5] !== createAnalyticsEvent) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "CustomColor",
                    actionSubjectId: "customPalette",
                    source: analyticsSource
                }
            }).fire();
        };
        $[4] = analyticsSource;
        $[5] = createAnalyticsEvent;
        $[6] = t3;
    } else t3 = $[6];
    const onTextFieldFocus = t3;
    const t4 = id;
    const t5 = name;
    const t6 = children;
    let t7;
    if ($[7] !== builtInColorMap || $[8] !== value) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $a11790b7b1207361$var$colorTileContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxm4A.ColorTile), {
            builtInColorMap: builtInColorMap,
            value: value
        }));
        $[7] = builtInColorMap;
        $[8] = value;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== value) {
        t8 = value.toUpperCase();
        $[10] = value;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== children || $[13] !== id || $[14] !== name || $[15] !== onTextFieldChange || $[16] !== onTextFieldFocus || $[17] !== t7 || $[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            id: t4,
            name: t5,
            elemAfterInput: t6,
            elemBeforeInput: t7,
            onChange: onTextFieldChange,
            onFocus: onTextFieldFocus,
            value: t8
        });
        $[12] = children;
        $[13] = id;
        $[14] = name;
        $[15] = onTextFieldChange;
        $[16] = onTextFieldFocus;
        $[17] = t7;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, children: children, id: id, name: name, onChange: onChange, value: value })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    value = value.toLowerCase();
    const onTextFieldChange = (0, $cozmU.useCallback)((event)=>{
        onChange(event.currentTarget.value.toLowerCase());
    }, [
        onChange
    ]);
    const onTextFieldFocus = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'CustomColor',
                actionSubjectId: 'customPalette',
                source: analyticsSource
            }
        }).fire();
    }, [
        analyticsSource,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        id: id,
        name: name,
        elemAfterInput: children,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $a11790b7b1207361$var$colorTileContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxm4A.ColorTile), {
            builtInColorMap: builtInColorMap,
            value: value
        })),
        onChange: onTextFieldChange,
        onFocus: onTextFieldFocus,
        value: value.toUpperCase()
    });
};





const $54f5638b16c943a3$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    addButtonText: {
        id: "company-hub.color-picker.custom-palette.add-button-text",
        defaultMessage: "Add"
    },
    colorCodeSelectorLabel: {
        id: "company-hub.color-picker.custom-palette.color-code-selector-label",
        defaultMessage: "Color format"
    },
    colorInputLabel: {
        id: "company-hub.color-picker.custom-palette.color-input-label",
        defaultMessage: "Color value"
    }
});


const $56cfe3d3ccc3898a$var$containerStyles = (0, $buxP3.xcss)({
    flexDirection: 'column',
    gap: 'space.100',
    width: '292px'
});
const $56cfe3d3ccc3898a$var$addButtonContainerStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    paddingRight: 'space.100'
});
const $56cfe3d3ccc3898a$var$COLOR_CODE_OPTIONS = [
    {
        label: 'Hex',
        value: '#'
    },
    {
        label: 'RGB',
        value: 'rgb'
    },
    {
        label: 'HSL',
        value: 'hsl'
    }
];
const $56cfe3d3ccc3898a$export$cd12f2785bdbccdb = ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, customColorRef: customColorRef, onChange: onChange, onSelectColor: onSelectColor, value: value })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [colorToBeAdded, setColorToBeAdded] = (0, $cozmU.useState)(value);
    (0, $cozmU.useEffect)(()=>{
        setColorToBeAdded(value);
    }, [
        value
    ]);
    (0, $cozmU.useEffect)(()=>{
        onSelectColor?.(colorToBeAdded);
    }, [
        colorToBeAdded,
        onSelectColor
    ]);
    const convertedValue = (0, $4yUlE.convertLegacyColor)(value);
    const convertedColorToBeAdded = (0, $4yUlE.convertLegacyColor)(colorToBeAdded);
    const isColorToBeAddedValid = convertedColorToBeAdded.isValid();
    const colorForHueAndSaturation = isColorToBeAddedValid ? convertedColorToBeAdded : convertedValue;
    //
    // Add button
    //
    /* isColorStaged: either the color is already staged, saved, or of default Atlassian theme
   * isColorInCurated: custom color is already elevated as one of eight default tiles in Curated palette
   * isTokenizedColorInCurated: custom color is already elevated as first of nine default tiles in Curated palette. The first of nine is a placeholder for custom color.
   */ const isColorStaged = colorToBeAdded === value;
    const isColorInCurated = builtInColorMap.knownTokens.includes((0, $4yUlE.extractToken)(colorToBeAdded));
    const isTokenizedColorInCurated = (0, $4yUlE.extractToken)(customColorRef.current) === (0, $4yUlE.extractToken)(colorToBeAdded);
    const isAddButtonDisabled = !isColorToBeAddedValid || isColorStaged || isColorInCurated || isTokenizedColorInCurated;
    const onAddClick = ()=>{
        if (isColorToBeAddedValid) {
            const sanitizedColor = (0, $4yUlE.getSanitizedColor)(builtInColorMap, colorToBeAdded);
            onChange(sanitizedColor);
        }
    };
    const getColorCode = (color)=>{
        if (color.startsWith('rgb')) return $56cfe3d3ccc3898a$var$COLOR_CODE_OPTIONS[1];
        if (color.startsWith('hsl')) return $56cfe3d3ccc3898a$var$COLOR_CODE_OPTIONS[2];
        return $56cfe3d3ccc3898a$var$COLOR_CODE_OPTIONS[0];
    };
    const [selectedColorCode, setSelectedColorCode] = (0, $cozmU.useState)(getColorCode(value));
    (0, $cozmU.useEffect)(()=>{
        setSelectedColorCode(getColorCode(colorToBeAdded));
    }, [
        colorToBeAdded
    ]);
    const onHueAndSaturationChange = (0, $cozmU.useCallback)((color_0)=>{
        if (selectedColorCode?.value === 'rgb') setColorToBeAdded((0, $3McNX.default)(color_0).toRgbString());
        else if (selectedColorCode?.value === 'hsl') setColorToBeAdded((0, $3McNX.default)(color_0).toHslString());
        else setColorToBeAdded(color_0);
    }, [
        selectedColorCode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $56cfe3d3ccc3898a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69b2218e1ff1924f$export$9fe2579179d7c943), {
        analyticsSource: analyticsSource,
        onChange: onHueAndSaturationChange,
        value: colorForHueAndSaturation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        label: formatMessage((0, $54f5638b16c943a3$export$defe85febe8b728c).colorCodeSelectorLabel),
        classNamePrefix: "AkSelect",
        id: "color-code-selector",
        inputId: "color-code-selector-input",
        options: $56cfe3d3ccc3898a$var$COLOR_CODE_OPTIONS,
        value: selectedColorCode,
        onChange: setSelectedColorCode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "color-input"
    }, formatMessage((0, $54f5638b16c943a3$export$defe85febe8b728c).colorInputLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a11790b7b1207361$export$5a1d7ca0a925d9c2), {
        id: "color-input",
        name: "color-input",
        analyticsSource: analyticsSource,
        builtInColorMap: builtInColorMap,
        onChange: (color_1 = '')=>setColorToBeAdded(color_1),
        value: colorToBeAdded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $56cfe3d3ccc3898a$var$addButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isDisabled: isAddButtonDisabled,
        onClick: onAddClick,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $54f5638b16c943a3$export$defe85febe8b728c).addButtonText)))))));
};





const $f578f579823aac64$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    closeButtonLabel: {
        id: "company-hub.color-picker.color-picker-dropdown.close-button-label",
        defaultMessage: "Close"
    },
    headerText: {
        id: "company-hub.color-picker.color-picker-dropdown.header-text",
        defaultMessage: "Select a color"
    },
    resetButtonText: {
        id: "company-hub.color-picker.color-picker-dropdown.reset-button-text",
        defaultMessage: "Reset to default"
    }
});















var $7BfeF = parcelRequire("7BfeF");

var $5ZC7N = parcelRequire("5ZC7N");







const $bc8be314e87b69cd$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    confirmationMessage: {
        id: "company-hub.color-picker.color-validation-messages.confirmation-message",
        defaultMessage: "Color selection added"
    },
    errorMessage: {
        id: "company-hub.color-picker.color-validation-messages.error-message",
        defaultMessage: "Enter a valid color"
    },
    contrastRatioPassMessage: {
        id: "company-hub.color-picker.color-validation-messages.contrast-ratio-pass-message",
        defaultMessage: "Passes accessibility standards"
    },
    contrastRatioFailMessage: {
        id: "company-hub.color-picker.color-validation-messages.contrast-ratio-fail-message",
        defaultMessage: "Does not pass accessibility standards"
    }
});


const $4d6dd2681012f6af$export$66fe3ef300963542 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { selectedColor: selectedColor, isReadableColor: isReadableColor, showConfirmation: showConfirmation, preSelectedColor: preSelectedColor, validationFailMessage: validationFailMessage, validationSuccessMessage: validationSuccessMessage } = t0;
    const convertedColor = (0, $4yUlE.convertLegacyColor)(selectedColor);
    const isInvalid = !convertedColor.isValid();
    if (isInvalid || !preSelectedColor) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bc8be314e87b69cd$export$defe85febe8b728c).errorMessage));
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if (showConfirmation) {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZC7N.ValidMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bc8be314e87b69cd$export$defe85febe8b728c).confirmationMessage));
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (isReadableColor) {
        if (isReadableColor(selectedColor)) {
            let t1;
            if ($[2] !== validationSuccessMessage) {
                t1 = validationSuccessMessage || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bc8be314e87b69cd$export$defe85febe8b728c).contrastRatioPassMessage);
                $[2] = validationSuccessMessage;
                $[3] = t1;
            } else t1 = $[3];
            let t2;
            if ($[4] !== t1) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZC7N.ValidMessage), null, t1);
                $[4] = t1;
                $[5] = t2;
            } else t2 = $[5];
            return t2;
        }
        let t1;
        if ($[6] !== validationFailMessage) {
            t1 = validationFailMessage || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bc8be314e87b69cd$export$defe85febe8b728c).contrastRatioFailMessage);
            $[6] = validationFailMessage;
            $[7] = t1;
        } else t1 = $[7];
        let t2;
        if ($[8] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, t1);
            $[8] = t1;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    }
    return null;
} : ({ selectedColor: selectedColor, isReadableColor: isReadableColor, showConfirmation: showConfirmation, preSelectedColor: preSelectedColor, validationFailMessage: validationFailMessage, validationSuccessMessage: validationSuccessMessage })=>{
    const convertedColor = (0, $4yUlE.convertLegacyColor)(selectedColor);
    const isInvalid = !convertedColor.isValid();
    if (isInvalid || !preSelectedColor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bc8be314e87b69cd$export$defe85febe8b728c).errorMessage));
    if (showConfirmation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZC7N.ValidMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bc8be314e87b69cd$export$defe85febe8b728c).confirmationMessage));
    if (isReadableColor) {
        if (isReadableColor(selectedColor)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZC7N.ValidMessage), null, validationSuccessMessage || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bc8be314e87b69cd$export$defe85febe8b728c).contrastRatioPassMessage));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, validationFailMessage || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bc8be314e87b69cd$export$defe85febe8b728c).contrastRatioFailMessage));
    }
    return null;
};


const $8219a408f721b6e0$var$containerStyles = (0, $buxP3.xcss)({
    flexDirection: 'column',
    gap: 'space.200',
    width: '292px'
});
const $8219a408f721b6e0$var$headerStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    alignSelf: 'stretch',
    justifyContent: 'space-between'
});
const $8219a408f721b6e0$var$resetButtonStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.050'
});
const $8219a408f721b6e0$export$bce475685b0e6f7c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(61);
    let analyticsSource;
    let builtInColorMap;
    let isReadableColor;
    let onChange;
    let onClose;
    let pickerTitle;
    let props;
    let showCustomPalette;
    let t1;
    let t2;
    let t3;
    let validationFailMessage;
    let validationSuccessMessage;
    let value;
    if ($[0] !== t0) {
        ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, isReadableColor: isReadableColor, onChange: onChange, onClose: onClose, value: value, pickerTitle: pickerTitle, showCustomPalette: showCustomPalette, showResetButton: t1, showCloseButton: t2, validationSuccessMessage: validationSuccessMessage, validationFailMessage: validationFailMessage, enableBorderLessStyle: t3, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsSource;
        $[2] = builtInColorMap;
        $[3] = isReadableColor;
        $[4] = onChange;
        $[5] = onClose;
        $[6] = pickerTitle;
        $[7] = props;
        $[8] = showCustomPalette;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = validationFailMessage;
        $[13] = validationSuccessMessage;
        $[14] = value;
    } else {
        analyticsSource = $[1];
        builtInColorMap = $[2];
        isReadableColor = $[3];
        onChange = $[4];
        onClose = $[5];
        pickerTitle = $[6];
        props = $[7];
        showCustomPalette = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        validationFailMessage = $[12];
        validationSuccessMessage = $[13];
        value = $[14];
    }
    const showResetButton = t1 === undefined ? false : t1;
    const showCloseButton = t2 === undefined ? false : t2;
    t3 === undefined || t3;
    const [showConfirmation, setShowConfirmation] = (0, $cozmU.useState)(false);
    const [preSelectedColor, setPreSelectedColor] = (0, $cozmU.useState)(value);
    const customColorRef = (0, $cozmU.useRef)();
    let t4;
    if ($[15] !== onChange) {
        t4 = (color)=>{
            onChange(color);
            setPreSelectedColor(color);
        };
        $[15] = onChange;
        $[16] = t4;
    } else t4 = $[16];
    const onCuratedColorSelect = t4;
    let t5;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (color_0)=>{
            setPreSelectedColor(color_0);
            setShowConfirmation(false);
        };
        $[17] = t5;
    } else t5 = $[17];
    const onPreSelectCustomColor = t5;
    let t6;
    if ($[18] !== onChange) {
        t6 = (color_1)=>{
            onChange(color_1);
            setPreSelectedColor(color_1);
            setShowConfirmation(true);
        };
        $[18] = onChange;
        $[19] = t6;
    } else t6 = $[19];
    const onAddCustomColor = t6;
    let t7;
    if ($[20] !== onChange) {
        t7 = ()=>{
            onChange(undefined);
            setShowConfirmation(false);
        };
        $[20] = onChange;
        $[21] = t7;
    } else t7 = $[21];
    const onResetClick = t7;
    const t8 = pickerTitle || (0, $f578f579823aac64$export$defe85febe8b728c).headerText;
    let t9;
    if ($[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            color: "color.text",
            size: "small",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t8));
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== onClose || $[25] !== showCloseButton) {
        t10 = showCloseButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: $8219a408f721b6e0$var$_temp,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f578f579823aac64$export$defe85febe8b728c).closeButtonLabel),
            onClick: onClose,
            spacing: "compact"
        });
        $[24] = onClose;
        $[25] = showCloseButton;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== t10 || $[28] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $8219a408f721b6e0$var$headerStyles
        }, t9, t10);
        $[27] = t10;
        $[28] = t9;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== analyticsSource || $[31] !== builtInColorMap || $[32] !== onCuratedColorSelect || $[33] !== value) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fLf0C.CuratedPalette), {
            analyticsSource: analyticsSource,
            builtInColorMap: builtInColorMap,
            customColorRef: customColorRef,
            onChange: onCuratedColorSelect,
            value: value
        });
        $[30] = analyticsSource;
        $[31] = builtInColorMap;
        $[32] = onCuratedColorSelect;
        $[33] = value;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== analyticsSource || $[36] !== builtInColorMap || $[37] !== onAddCustomColor || $[38] !== showCustomPalette || $[39] !== value) {
        t13 = showCustomPalette && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56cfe3d3ccc3898a$export$cd12f2785bdbccdb), {
            analyticsSource: analyticsSource,
            builtInColorMap: builtInColorMap,
            customColorRef: customColorRef,
            onChange: onAddCustomColor,
            onSelectColor: onPreSelectCustomColor,
            value: value
        });
        $[35] = analyticsSource;
        $[36] = builtInColorMap;
        $[37] = onAddCustomColor;
        $[38] = showCustomPalette;
        $[39] = value;
        $[40] = t13;
    } else t13 = $[40];
    let t14;
    if ($[41] !== isReadableColor || $[42] !== preSelectedColor || $[43] !== showConfirmation || $[44] !== showCustomPalette || $[45] !== validationFailMessage || $[46] !== validationSuccessMessage || $[47] !== value) {
        t14 = (isReadableColor || showCustomPalette) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d6dd2681012f6af$export$66fe3ef300963542), {
            selectedColor: showCustomPalette ? preSelectedColor || value : value,
            preSelectedColor: preSelectedColor,
            showConfirmation: showConfirmation,
            isReadableColor: isReadableColor,
            validationSuccessMessage: validationSuccessMessage,
            validationFailMessage: validationFailMessage
        });
        $[41] = isReadableColor;
        $[42] = preSelectedColor;
        $[43] = showConfirmation;
        $[44] = showCustomPalette;
        $[45] = validationFailMessage;
        $[46] = validationSuccessMessage;
        $[47] = value;
        $[48] = t14;
    } else t14 = $[48];
    let t15;
    if ($[49] !== t11 || $[50] !== t12 || $[51] !== t13 || $[52] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.150"
        }, t11, t12, t13, t14);
        $[49] = t11;
        $[50] = t12;
        $[51] = t13;
        $[52] = t14;
        $[53] = t15;
    } else t15 = $[53];
    let t16;
    if ($[54] !== onResetClick || $[55] !== showResetButton) {
        t16 = showResetButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "end",
            xcss: $8219a408f721b6e0$var$resetButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: onResetClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f578f579823aac64$export$defe85febe8b728c).resetButtonText)));
        $[54] = onResetClick;
        $[55] = showResetButton;
        $[56] = t16;
    } else t16 = $[56];
    let t17;
    if ($[57] !== props || $[58] !== t15 || $[59] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            ...props,
            xcss: $8219a408f721b6e0$var$containerStyles
        }, t15, t16);
        $[57] = props;
        $[58] = t15;
        $[59] = t16;
        $[60] = t17;
    } else t17 = $[60];
    return t17;
} : ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, isReadableColor: isReadableColor, onChange: onChange, onClose: onClose, value: value, pickerTitle: pickerTitle, showCustomPalette: showCustomPalette, showResetButton: showResetButton = false, showCloseButton: showCloseButton = false, validationSuccessMessage: validationSuccessMessage, validationFailMessage: validationFailMessage, enableBorderLessStyle: enableBorderLessStyle = false, ...props })=>{
    const [showConfirmation, setShowConfirmation] = (0, $cozmU.useState)(false);
    const [preSelectedColor, setPreSelectedColor] = (0, $cozmU.useState)(value);
    const customColorRef = (0, $cozmU.useRef)();
    const onCuratedColorSelect = (0, $cozmU.useCallback)((color)=>{
        onChange(color);
        setPreSelectedColor(color);
    }, [
        onChange
    ]);
    const onPreSelectCustomColor = (0, $cozmU.useCallback)((color_0)=>{
        setPreSelectedColor(color_0);
        setShowConfirmation(false);
    }, [
        setPreSelectedColor,
        setShowConfirmation
    ]);
    const onAddCustomColor = (0, $cozmU.useCallback)((color_1)=>{
        onChange(color_1);
        setPreSelectedColor(color_1);
        setShowConfirmation(true);
    }, [
        onChange
    ]);
    const onResetClick = (0, $cozmU.useCallback)(()=>{
        onChange(undefined);
        setShowConfirmation(false);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        ...props,
        xcss: $8219a408f721b6e0$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $8219a408f721b6e0$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text",
        size: "small",
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), pickerTitle || (0, $f578f579823aac64$export$defe85febe8b728c).headerText)), showCloseButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f578f579823aac64$export$defe85febe8b728c).closeButtonLabel),
        onClick: onClose,
        spacing: "compact"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fLf0C.CuratedPalette), {
        analyticsSource: analyticsSource,
        builtInColorMap: builtInColorMap,
        customColorRef: customColorRef,
        onChange: onCuratedColorSelect,
        value: value
    }), showCustomPalette && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56cfe3d3ccc3898a$export$cd12f2785bdbccdb), {
        analyticsSource: analyticsSource,
        builtInColorMap: builtInColorMap,
        customColorRef: customColorRef,
        onChange: onAddCustomColor,
        onSelectColor: onPreSelectCustomColor,
        value: value
    }), (isReadableColor || showCustomPalette) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d6dd2681012f6af$export$66fe3ef300963542), {
        selectedColor: showCustomPalette ? preSelectedColor || value : value,
        preSelectedColor: preSelectedColor,
        showConfirmation: showConfirmation,
        isReadableColor: isReadableColor,
        validationSuccessMessage: validationSuccessMessage,
        validationFailMessage: validationFailMessage
    })), showResetButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "end",
        xcss: $8219a408f721b6e0$var$resetButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onResetClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f578f579823aac64$export$defe85febe8b728c).resetButtonText))));
};
function $8219a408f721b6e0$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps,
        color: "var(--ds-icon, #292A2E)"
    });
}
module.exports["ColorPickerDropdown"] = $8219a408f721b6e0$export$bce475685b0e6f7c;

});

parcelRegister("fLf0C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $eh6Ml = parcelRequire("eh6Ml");











var $bt5ds = parcelRequire("bt5ds");

/**
 * __ZoomIn__
 *
 * Will over zoom an element into position.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $3e21e98e08df85da$var$ZoomIn = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, duration: t1, isPaused: isPaused, onFinish: onFinish } = t0;
    const duration = t1 === undefined ? "small" : t1;
    let t2;
    if ($[0] !== children || $[1] !== duration || $[2] !== isPaused || $[3] !== onFinish) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bt5ds.default), {
            duration: duration,
            enteringAnimation: "zoom-in",
            exitingAnimation: "zoom-out",
            animationTimingFunction: "ease-in-out",
            isPaused: isPaused,
            onFinish: onFinish
        }, children);
        $[0] = children;
        $[1] = duration;
        $[2] = isPaused;
        $[3] = onFinish;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, duration: duration = 'small', isPaused: isPaused, onFinish: onFinish })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bt5ds.default), {
        duration: duration,
        enteringAnimation: "zoom-in",
        exitingAnimation: "zoom-out",
        animationTimingFunction: "ease-in-out",
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $3e21e98e08df85da$export$2e2bcd8739ae039 = $3e21e98e08df85da$var$ZoomIn;



var $3izAL = parcelRequire("3izAL");

var $kA6Zo = parcelRequire("kA6Zo");

var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $9GVkD = parcelRequire("9GVkD");


var $jxm4A = parcelRequire("jxm4A");


var $4yUlE = parcelRequire("4yUlE");




const $9be37e58104d740a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    checkIconLabel: {
        id: "company-hub.color-picker.pressable-color-tile.check-icon-label",
        defaultMessage: "Selected"
    }
});


const $d791d1ce1906c9ea$var$checkIconContainerStyles = (0, $buxP3.xcss)({
    position: 'absolute'
});
const $d791d1ce1906c9ea$var$pressableStyles = (0, $buxP3.xcss)({
    background: 'none',
    alignItems: 'center',
    display: 'flex',
    height: '24px',
    justifyContent: 'center',
    width: '24px'
});
const $d791d1ce1906c9ea$export$7efe82073e3977ee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, isSelected: isSelected, onChange: onChange, value: value } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== analyticsSource || $[1] !== createAnalyticsEvent || $[2] !== onChange || $[3] !== value) {
        t1 = ()=>{
            onChange(value);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "SelectItem",
                    actionSubjectId: "curatedPalette",
                    source: analyticsSource
                }
            }).fire();
        };
        $[0] = analyticsSource;
        $[1] = createAnalyticsEvent;
        $[2] = onChange;
        $[3] = value;
        $[4] = t1;
    } else t1 = $[4];
    const onPressableClick = t1;
    let T0;
    let T1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[5] !== builtInColorMap || $[6] !== formatMessage || $[7] !== isSelected || $[8] !== onPressableClick || $[9] !== value) {
        const colorName = builtInColorMap.humanReadableColors.get(value);
        T1 = (0, $kh0hi.default);
        t3 = isSelected;
        t4 = onPressableClick;
        t5 = $d791d1ce1906c9ea$var$pressableStyles;
        let t7;
        if ($[17] !== builtInColorMap || $[18] !== value) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxm4A.ColorTile), {
                builtInColorMap: builtInColorMap,
                value: value
            });
            $[17] = builtInColorMap;
            $[18] = value;
            $[19] = t7;
        } else t7 = $[19];
        let t8;
        if ($[20] !== formatMessage || $[21] !== isSelected || $[22] !== value) {
            t8 = isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3e21e98e08df85da$export$2e2bcd8739ae039), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                    ...props,
                    xcss: $d791d1ce1906c9ea$var$checkIconContainerStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                    label: formatMessage((0, $9be37e58104d740a$export$defe85febe8b728c).checkIconLabel),
                    color: (0, $4yUlE.getMostReadableColor)(value),
                    spacing: "spacious"
                })));
            $[20] = formatMessage;
            $[21] = isSelected;
            $[22] = value;
            $[23] = t8;
        } else t8 = $[23];
        if ($[24] !== t7 || $[25] !== t8) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), null, t7, t8);
            $[24] = t7;
            $[25] = t8;
            $[26] = t6;
        } else t6 = $[26];
        T0 = (0, $9GVkD.default);
        t2 = colorName ? formatMessage(colorName) : value;
        $[5] = builtInColorMap;
        $[6] = formatMessage;
        $[7] = isSelected;
        $[8] = onPressableClick;
        $[9] = value;
        $[10] = T0;
        $[11] = T1;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else {
        T0 = $[10];
        T1 = $[11];
        t2 = $[12];
        t3 = $[13];
        t4 = $[14];
        t5 = $[15];
        t6 = $[16];
    }
    let t7;
    if ($[27] !== T0 || $[28] !== t2) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, null, t2);
        $[27] = T0;
        $[28] = t2;
        $[29] = t7;
    } else t7 = $[29];
    let t8;
    if ($[30] !== T1 || $[31] !== t3 || $[32] !== t4 || $[33] !== t5 || $[34] !== t6 || $[35] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            "aria-pressed": t3,
            onClick: t4,
            xcss: t5
        }, t6, t7);
        $[30] = T1;
        $[31] = t3;
        $[32] = t4;
        $[33] = t5;
        $[34] = t6;
        $[35] = t7;
        $[36] = t8;
    } else t8 = $[36];
    return t8;
} : ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, isSelected: isSelected, onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPressableClick = ()=>{
        onChange(value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'SelectItem',
                actionSubjectId: 'curatedPalette',
                source: analyticsSource
            }
        }).fire();
    };
    const colorName = builtInColorMap.humanReadableColors.get(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        "aria-pressed": isSelected,
        onClick: onPressableClick,
        xcss: $d791d1ce1906c9ea$var$pressableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxm4A.ColorTile), {
        builtInColorMap: builtInColorMap,
        value: value
    }), isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3e21e98e08df85da$export$2e2bcd8739ae039), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            ...props,
            xcss: $d791d1ce1906c9ea$var$checkIconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: formatMessage((0, $9be37e58104d740a$export$defe85febe8b728c).checkIconLabel),
            color: (0, $4yUlE.getMostReadableColor)(value),
            spacing: "spacious"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, colorName ? formatMessage(colorName) : value));
};


const $3ad74c7e03417311$export$2d5c37fc2a13c79c = 10;
function $3ad74c7e03417311$var$getColorsPerRowFromPalette(colors) {
    return colors.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / $3ad74c7e03417311$export$2d5c37fc2a13c79c);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
const $3ad74c7e03417311$export$7076a6e7211abb82 = ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, customColorRef: customColorRef, onChange: onChange, value: value })=>{
    const { knownColors: knownColors } = builtInColorMap;
    // lowercasing value here since all knownColors are lowercased to support legacy colors
    value = value.toLowerCase();
    if (!knownColors.includes(value)) customColorRef.current = value;
    const customColor = customColorRef.current;
    let colors = knownColors;
    if (customColor && !colors.includes(customColor)) {
        if (colors.length >= $3ad74c7e03417311$export$2d5c37fc2a13c79c) colors = [
            ...knownColors,
            customColor
        ];
        else colors = [
            customColor,
            ...knownColors
        ];
    }
    const colorTiles = colors.map((color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d791d1ce1906c9ea$export$7efe82073e3977ee), {
            analyticsSource: analyticsSource,
            builtInColorMap: builtInColorMap,
            isSelected: color === value,
            key: color,
            onChange: onChange,
            value: color
        }));
    const colorTilesMap = $3ad74c7e03417311$var$getColorsPerRowFromPalette(colorTiles);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, colorTilesMap.map((rowColors, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            key: `curated-palette-row-${index}-key`,
            testId: `curated-palette-row-${index}`
        }, rowColors)));
};
module.exports["CuratedPalette"] = $3ad74c7e03417311$export$7076a6e7211abb82;

});

parcelRegister("9GzMu", function(module, exports) {

var $aKMOV = parcelRequire("aKMOV");

var $8f1a7511aa181be5$exports = {};
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $8f1a7511aa181be5$var$stubFalse() {
    return false;
}
$8f1a7511aa181be5$exports = $8f1a7511aa181be5$var$stubFalse;


/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $aKMOV.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $8f1a7511aa181be5$exports;
module.exports = isBuffer;

});

parcelRegister("i0Qa5", function(module, exports) {

var $bgqhD = parcelRequire("bgqhD");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $bgqhD.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("fytgK", function(module, exports) {

var $aKMOV = parcelRequire("aKMOV");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $aKMOV.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("fbycD", function(module, exports) {

var $7ueoP = parcelRequire("7ueoP");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $7ueoP.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("joXc3", function(module, exports) {

var $7ueoP = parcelRequire("7ueoP");

var $7c589dbab8e29b7e$exports = {};
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $7c589dbab8e29b7e$var$stubFalse() {
    return false;
}
$7c589dbab8e29b7e$exports = $7c589dbab8e29b7e$var$stubFalse;


/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $7ueoP.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $7c589dbab8e29b7e$exports;
module.exports = isBuffer;

});

parcelRegister("6Z6Du", function(module, exports) {

var $6ykdO = parcelRequire("6ykdO");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $6ykdO.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("3lufT", function(module, exports) {
var $ef52d1ee164ad077$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ef52d1ee164ad077$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$ef52d1ee164ad077$exports = $ef52d1ee164ad077$var$arrayEach;


var $1be44d02409e7c79$exports = {};
var $77748816d8d54a4f$exports = {};

var $g6T55 = parcelRequire("g6T55");

var $a307ae95645aa5db$exports = {};

var $bwvzb = parcelRequire("bwvzb");

var $63590d3c30cd8c05$exports = {};

var $l6jnG = parcelRequire("l6jnG");

var $da2c2eee35b30722$exports = {};

var $lWO9h = parcelRequire("lWO9h");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $da2c2eee35b30722$var$nativeKeys = $lWO9h(Object.keys, Object);
$da2c2eee35b30722$exports = $da2c2eee35b30722$var$nativeKeys;


/** Used for built-in method references. */ var $63590d3c30cd8c05$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $63590d3c30cd8c05$var$hasOwnProperty = $63590d3c30cd8c05$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $63590d3c30cd8c05$var$baseKeys(object) {
    if (!$l6jnG(object)) return $da2c2eee35b30722$exports(object);
    var result = [];
    for(var key in Object(object))if ($63590d3c30cd8c05$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$63590d3c30cd8c05$exports = $63590d3c30cd8c05$var$baseKeys;



var $c0eyi = parcelRequire("c0eyi");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $a307ae95645aa5db$var$keys(object) {
    return $c0eyi(object) ? $bwvzb(object) : $63590d3c30cd8c05$exports(object);
}
$a307ae95645aa5db$exports = $a307ae95645aa5db$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $77748816d8d54a4f$var$baseForOwn(object, iteratee) {
    return object && $g6T55(object, iteratee, $a307ae95645aa5db$exports);
}
$77748816d8d54a4f$exports = $77748816d8d54a4f$var$baseForOwn;


var $33e97ecc0ca152e8$exports = {};



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $33e97ecc0ca152e8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$c0eyi(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$33e97ecc0ca152e8$exports = $33e97ecc0ca152e8$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $1be44d02409e7c79$var$baseEach = $33e97ecc0ca152e8$exports($77748816d8d54a4f$exports);
$1be44d02409e7c79$exports = $1be44d02409e7c79$var$baseEach;


var $9542d7459835cfc6$exports = {};

var $gMntP = parcelRequire("gMntP");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $9542d7459835cfc6$var$castFunction(value) {
    return typeof value == 'function' ? value : $gMntP;
}
$9542d7459835cfc6$exports = $9542d7459835cfc6$var$castFunction;



var $dEso5 = parcelRequire("dEso5");

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $26facd548c94246c$var$forEach(collection, iteratee) {
    var func = $dEso5(collection) ? $ef52d1ee164ad077$exports : $1be44d02409e7c79$exports;
    return func(collection, $9542d7459835cfc6$exports(iteratee));
}
module.exports = $26facd548c94246c$var$forEach;

});

parcelRegister("89qQa", function(module, exports) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleFocus = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cozmU = parcelRequire("cozmU");

var _react2 = _interopRequireDefault($cozmU);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable no-invalid-this */ 
var handleFocus = exports.handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, _react2.default.createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }(_react2.default.Component);
};

});

parcelRegister("iJCWb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $jLnA6 = parcelRequire("jLnA6");


var $iMnC5 = parcelRequire("iMnC5");


var $1nAzh = parcelRequire("1nAzh");


var $cfM7x = parcelRequire("cfM7x");

const $898b8ab3e0d99cc9$var$styles = {
    badgeContainer: "_19pkxmi2 _1bsb1ris",
    labelWrapper: "_ca0qutpp",
    rangeContainer: "_u5f3u2gc",
    wrapper: "_1e0c1txw _2lx2vrvc _1bah1yb4"
};
const $898b8ab3e0d99cc9$export$b322c47b2525bd34 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { analyticSource: analyticSource, label: label, maxValue: maxValue, minValue: minValue, prefix: prefix, step: t1, unit: unit, updateRangeValue: updateRangeValue, value: value } = t0;
    const step = t1 === undefined ? 1 : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    let t2;
    if ($[0] !== analyticSource || $[1] !== createAnalyticsEvent || $[2] !== prefix || $[3] !== updateRangeValue) {
        t2 = (newValue)=>{
            updateRangeValue(newValue);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "changed",
                    actionSubject: "range",
                    actionSubjectId: `${prefix}NumberRange`,
                    source: analyticSource,
                    attributes: {
                        value: newValue
                    }
                }
            }).fire();
        };
        $[0] = analyticSource;
        $[1] = createAnalyticsEvent;
        $[2] = prefix;
        $[3] = updateRangeValue;
        $[4] = t2;
    } else t2 = $[4];
    const handleRangeUpdate = t2;
    if (typeof value !== "number") {
        const error = new Error(`${prefix} range value should be a number but got: ${typeof value}`);
        submitError?.(error);
        return null;
    }
    const t3 = `${prefix}-range-input`;
    let t4;
    if ($[5] !== label) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label);
        $[5] = label;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $898b8ab3e0d99cc9$var$styles.labelWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
            htmlFor: t3
        }, t4));
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    const t6 = `${prefix}-range-input`;
    let t7;
    if ($[10] !== handleRangeUpdate || $[11] !== maxValue || $[12] !== minValue || $[13] !== step || $[14] !== t6 || $[15] !== value) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1nAzh.default), {
            id: t6,
            onChange: handleRangeUpdate,
            testId: "config-panel-range-field-range-input",
            value: value,
            step: step,
            min: minValue,
            max: maxValue
        });
        $[10] = handleRangeUpdate;
        $[11] = maxValue;
        $[12] = minValue;
        $[13] = step;
        $[14] = t6;
        $[15] = value;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `${Math.min(100 * Math.max(value - 1, 0) / maxValue, 90)}%`;
    let t9;
    if ($[17] !== t8) {
        t9 = {
            paddingLeft: t8
        };
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    const t10 = value + (unit ? unit : "");
    let t11;
    if ($[19] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), null, t10);
        $[19] = t10;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== t11 || $[22] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $898b8ab3e0d99cc9$var$styles.badgeContainer,
            style: t9
        }, t11);
        $[21] = t11;
        $[22] = t9;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t12 || $[25] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $898b8ab3e0d99cc9$var$styles.rangeContainer
        }, t7, t12);
        $[24] = t12;
        $[25] = t7;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== t13 || $[28] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "config-panel-range-field",
            xcss: $898b8ab3e0d99cc9$var$styles.wrapper
        }, t5, t13);
        $[27] = t13;
        $[28] = t5;
        $[29] = t14;
    } else t14 = $[29];
    return t14;
} : ({ analyticSource: analyticSource, label: label, maxValue: maxValue, minValue: minValue, prefix: prefix, step: step = 1, unit: unit, updateRangeValue: updateRangeValue, value: value })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const handleRangeUpdate = (0, $cozmU.useCallback)((newValue)=>{
        updateRangeValue(newValue);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'range',
                actionSubjectId: `${prefix}NumberRange`,
                source: analyticSource,
                attributes: {
                    value: newValue
                }
            }
        }).fire();
    }, [
        analyticSource,
        createAnalyticsEvent,
        prefix,
        updateRangeValue
    ]);
    if (typeof value !== 'number') {
        const error = new Error(`${prefix} range value should be a number but got: ${typeof value}`);
        submitError?.(error);
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "config-panel-range-field",
        xcss: $898b8ab3e0d99cc9$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $898b8ab3e0d99cc9$var$styles.labelWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: `${prefix}-range-input`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $898b8ab3e0d99cc9$var$styles.rangeContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1nAzh.default), {
        id: `${prefix}-range-input`,
        onChange: handleRangeUpdate,
        testId: "config-panel-range-field-range-input",
        value: value,
        step: step,
        min: minValue,
        max: maxValue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $898b8ab3e0d99cc9$var$styles.badgeContainer,
        style: {
            paddingLeft: `${Math.min(100 * Math.max(value - 1, 0) / maxValue, 90)}%`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), null, value + (unit ? unit : '')))));
};
module.exports["RangeField"] = $898b8ab3e0d99cc9$export$b322c47b2525bd34;

});

parcelRegister("9l2Y4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $3474ece804019253$var$svgStyles = null;
const $3474ece804019253$export$d094da8d87fa1043 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { color: color, label: label } = t0;
    const t1 = color ?? "var(--ds-text, #292A2E)";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            color: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = label || undefined;
    let t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]);
        t5 = /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.5714 0H6.8571C3.07 0 0 3.07 0 6.8571V8.5714H2.5714V6.8571C2.5714 4.4902 4.4902 2.5714 6.8571 2.5714H8.5714V0ZM8.5714 21.4286H6.8571C4.4902 21.4286 2.5714 19.5098 2.5714 17.1429V15.4286H0V17.1429C0 20.9299 3.07 24 6.8571 24H8.5714V21.4286ZM15.4286 24V21.4286H17.1429C19.5098 21.4286 21.4286 19.5098 21.4286 17.1429V15.4286H24V17.1429C24 20.9299 20.9299 24 17.1429 24H15.4286ZM15.4286 2.5714V0H17.1429C20.9299 0 24 3.07 24 6.8571V8.5714H21.4286V6.8571C21.4286 4.4902 19.5098 2.5714 17.1429 2.5714H15.4286Z",
            fill: "currentColor"
        });
        $[2] = t4;
        $[3] = t5;
    } else {
        t4 = $[2];
        t5 = $[3];
    }
    let t6;
    if ($[4] !== t2 || $[5] !== t3) {
        t6 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 24 24",
            height: "16px",
            width: "16px",
            style: t2,
            "aria-label": t3,
            className: t4
        }, t5);
        $[4] = t2;
        $[5] = t3;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ color: color, label: label })=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 24 24",
        height: "16px",
        width: "16px",
        style: {
            color: color ?? "var(--ds-text, #292A2E)"
        },
        "aria-label": label || undefined,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5714 0H6.8571C3.07 0 0 3.07 0 6.8571V8.5714H2.5714V6.8571C2.5714 4.4902 4.4902 2.5714 6.8571 2.5714H8.5714V0ZM8.5714 21.4286H6.8571C4.4902 21.4286 2.5714 19.5098 2.5714 17.1429V15.4286H0V17.1429C0 20.9299 3.07 24 6.8571 24H8.5714V21.4286ZM15.4286 24V21.4286H17.1429C19.5098 21.4286 21.4286 19.5098 21.4286 17.1429V15.4286H24V17.1429C24 20.9299 20.9299 24 17.1429 24H15.4286ZM15.4286 2.5714V0H17.1429C20.9299 0 24 3.07 24 6.8571V8.5714H21.4286V6.8571C21.4286 4.4902 19.5098 2.5714 17.1429 2.5714H15.4286Z",
        fill: "currentColor"
    }));
};
module.exports["RoundCornerIcon"] = $3474ece804019253$export$d094da8d87fa1043;

});

parcelRegister("2TDGa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f18dcdb3a38552af$var$svgStyles = null;
const $f18dcdb3a38552af$export$5853d29f01a5c20 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { color: color, label: label } = t0;
    const t1 = color ?? "var(--ds-text, #292A2E)";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            color: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = label || undefined;
    let t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]);
        t5 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.75 2H9V4.25H3.75V9.5H1.5V4.25 2H3.75ZM1.5 15.5V20.75 23H3.75 9V20.75H3.75V15.5H1.5ZM20.25 15.5V20.75H15V23H20.25 22.5V20.75 15.5H20.25ZM22.5 9.5V4.25 2H20.25 15V4.25H20.25V9.5H22.5Z"
        });
        $[2] = t4;
        $[3] = t5;
    } else {
        t4 = $[2];
        t5 = $[3];
    }
    let t6;
    if ($[4] !== t2 || $[5] !== t3) {
        t6 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 24 24",
            height: "16px",
            width: "16px",
            style: t2,
            "aria-label": t3,
            className: t4
        }, t5);
        $[4] = t2;
        $[5] = t3;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ color: color, label: label })=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 24 24",
        height: "16px",
        width: "16px",
        style: {
            color: color ?? "var(--ds-text, #292A2E)"
        },
        "aria-label": label || undefined,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 2H9V4.25H3.75V9.5H1.5V4.25 2H3.75ZM1.5 15.5V20.75 23H3.75 9V20.75H3.75V15.5H1.5ZM20.25 15.5V20.75H15V23H20.25 22.5V20.75 15.5H20.25ZM22.5 9.5V4.25 2H20.25 15V4.25H20.25V9.5H22.5Z"
    }));
};
module.exports["SharpCornerIcon"] = $f18dcdb3a38552af$export$5853d29f01a5c20;

});

parcelRegister("gKJso", function(module, exports) {
/**
 * Picker → ADF storage adapter.
 *
 * If the hex emitted by the color-picker matches a shade in the active brand
 * palette, persist the CSS-var reference for that shade (e.g.
 * `"var(--hub-color-primary-300)"`) so the value tracks future brand-color
 * edits via the browser's CSS cascade — no resolver call, no JS palette
 * lookup at render time. Otherwise persist the raw hex (frozen literal).
 *
 * Pure case-insensitive lookup, no normalisation — relies on the picker
 * emitting hex in the same casing the palette uses (`csm-colour-theme-generator`
 * outputs lowercase). Pure, synchronous, no side effects → SSR-safe.
 */ 
var $hITUV = parcelRequire("hITUV");

const $5cb282b7b5a6a3ce$export$3b6ce31dec9a22fc = (hex, palette)=>{
    const lower = hex.toLowerCase();
    for (const [ref, shadeHex] of Object.entries(palette)){
        if (shadeHex.toLowerCase() === lower) // Hex fallback after the CSS var name lets the value still resolve
        // to a usable color when the wrapper isn't in scope (e.g. shared
        // extensions rendered in Confluence Company Hub, or color helpers
        // like `extractColorCode` that look up the var on `documentElement`
        // rather than the wrapper). The browser uses the wrapper's live
        // value when the var is defined (so brand-color edits still track
        // inside the hub), and falls back to this snapshot hex otherwise.
        return `var(${(0, $hITUV.HUB_COLOR_CSS_VARS)[ref]}, ${shadeHex})`;
    }
    return hex;
};
module.exports["toAdfColor"] = $5cb282b7b5a6a3ce$export$3b6ce31dec9a22fc;

});

parcelRegister("3McNX", function(module, exports) {
// This file is autogenerated. It's used to publish ESM to npm.
function $2bffc98fd6f34db9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2bffc98fd6f34db9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2bffc98fd6f34db9$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $2bffc98fd6f34db9$var$trimLeft = /^\s+/;
var $2bffc98fd6f34db9$var$trimRight = /\s+$/;
function $2bffc98fd6f34db9$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $2bffc98fd6f34db9$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $2bffc98fd6f34db9$export$2e2bcd8739ae039)) return new $2bffc98fd6f34db9$export$2e2bcd8739ae039(color, opts);
    var rgb = $2bffc98fd6f34db9$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$2bffc98fd6f34db9$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $2bffc98fd6f34db9$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $2bffc98fd6f34db9$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $2bffc98fd6f34db9$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $2bffc98fd6f34db9$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $2bffc98fd6f34db9$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $2bffc98fd6f34db9$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $2bffc98fd6f34db9$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($2bffc98fd6f34db9$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($2bffc98fd6f34db9$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($2bffc98fd6f34db9$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($2bffc98fd6f34db9$var$bound01(this._r, 255) * 100) + "%, " + Math.round($2bffc98fd6f34db9$var$bound01(this._g, 255) * 100) + "%, " + Math.round($2bffc98fd6f34db9$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($2bffc98fd6f34db9$var$bound01(this._r, 255) * 100) + "%, " + Math.round($2bffc98fd6f34db9$var$bound01(this._g, 255) * 100) + "%, " + Math.round($2bffc98fd6f34db9$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $2bffc98fd6f34db9$var$hexNames[$2bffc98fd6f34db9$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $2bffc98fd6f34db9$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $2bffc98fd6f34db9$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $2bffc98fd6f34db9$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $2bffc98fd6f34db9$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($2bffc98fd6f34db9$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($2bffc98fd6f34db9$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($2bffc98fd6f34db9$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($2bffc98fd6f34db9$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($2bffc98fd6f34db9$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($2bffc98fd6f34db9$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($2bffc98fd6f34db9$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($2bffc98fd6f34db9$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($2bffc98fd6f34db9$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($2bffc98fd6f34db9$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($2bffc98fd6f34db9$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($2bffc98fd6f34db9$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($2bffc98fd6f34db9$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$2bffc98fd6f34db9$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($2bffc98fd6f34db9$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $2bffc98fd6f34db9$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $2bffc98fd6f34db9$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $2bffc98fd6f34db9$var$stringInputToObject(color);
    if ($2bffc98fd6f34db9$var$_typeof(color) == "object") {
        if ($2bffc98fd6f34db9$var$isValidCSSUnit(color.r) && $2bffc98fd6f34db9$var$isValidCSSUnit(color.g) && $2bffc98fd6f34db9$var$isValidCSSUnit(color.b)) {
            rgb = $2bffc98fd6f34db9$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($2bffc98fd6f34db9$var$isValidCSSUnit(color.h) && $2bffc98fd6f34db9$var$isValidCSSUnit(color.s) && $2bffc98fd6f34db9$var$isValidCSSUnit(color.v)) {
            s = $2bffc98fd6f34db9$var$convertToPercentage(color.s);
            v = $2bffc98fd6f34db9$var$convertToPercentage(color.v);
            rgb = $2bffc98fd6f34db9$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($2bffc98fd6f34db9$var$isValidCSSUnit(color.h) && $2bffc98fd6f34db9$var$isValidCSSUnit(color.s) && $2bffc98fd6f34db9$var$isValidCSSUnit(color.l)) {
            s = $2bffc98fd6f34db9$var$convertToPercentage(color.s);
            l = $2bffc98fd6f34db9$var$convertToPercentage(color.l);
            rgb = $2bffc98fd6f34db9$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $2bffc98fd6f34db9$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $2bffc98fd6f34db9$var$rgbToRgb(r, g, b) {
    return {
        r: $2bffc98fd6f34db9$var$bound01(r, 255) * 255,
        g: $2bffc98fd6f34db9$var$bound01(g, 255) * 255,
        b: $2bffc98fd6f34db9$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $2bffc98fd6f34db9$var$rgbToHsl(r, g, b) {
    r = $2bffc98fd6f34db9$var$bound01(r, 255);
    g = $2bffc98fd6f34db9$var$bound01(g, 255);
    b = $2bffc98fd6f34db9$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $2bffc98fd6f34db9$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $2bffc98fd6f34db9$var$bound01(h, 360);
    s = $2bffc98fd6f34db9$var$bound01(s, 100);
    l = $2bffc98fd6f34db9$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $2bffc98fd6f34db9$var$rgbToHsv(r, g, b) {
    r = $2bffc98fd6f34db9$var$bound01(r, 255);
    g = $2bffc98fd6f34db9$var$bound01(g, 255);
    b = $2bffc98fd6f34db9$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $2bffc98fd6f34db9$var$hsvToRgb(h, s, v) {
    h = $2bffc98fd6f34db9$var$bound01(h, 360) * 6;
    s = $2bffc98fd6f34db9$var$bound01(s, 100);
    v = $2bffc98fd6f34db9$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $2bffc98fd6f34db9$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $2bffc98fd6f34db9$var$pad2(Math.round(r).toString(16)),
        $2bffc98fd6f34db9$var$pad2(Math.round(g).toString(16)),
        $2bffc98fd6f34db9$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $2bffc98fd6f34db9$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $2bffc98fd6f34db9$var$pad2(Math.round(r).toString(16)),
        $2bffc98fd6f34db9$var$pad2(Math.round(g).toString(16)),
        $2bffc98fd6f34db9$var$pad2(Math.round(b).toString(16)),
        $2bffc98fd6f34db9$var$pad2($2bffc98fd6f34db9$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $2bffc98fd6f34db9$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $2bffc98fd6f34db9$var$pad2($2bffc98fd6f34db9$var$convertDecimalToHex(a)),
        $2bffc98fd6f34db9$var$pad2(Math.round(r).toString(16)),
        $2bffc98fd6f34db9$var$pad2(Math.round(g).toString(16)),
        $2bffc98fd6f34db9$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$2bffc98fd6f34db9$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(color1).toRgbString() == $2bffc98fd6f34db9$export$2e2bcd8739ae039(color2).toRgbString();
};
$2bffc98fd6f34db9$export$2e2bcd8739ae039.random = function() {
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $2bffc98fd6f34db9$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $2bffc98fd6f34db9$var$clamp01(hsl.s);
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(hsl);
}
function $2bffc98fd6f34db9$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $2bffc98fd6f34db9$var$clamp01(hsl.s);
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(hsl);
}
function $2bffc98fd6f34db9$var$_greyscale(color) {
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).desaturate(100);
}
function $2bffc98fd6f34db9$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $2bffc98fd6f34db9$var$clamp01(hsl.l);
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(hsl);
}
function $2bffc98fd6f34db9$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(rgb);
}
function $2bffc98fd6f34db9$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $2bffc98fd6f34db9$var$clamp01(hsl.l);
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $2bffc98fd6f34db9$var$_spin(color, amount) {
    var hsl = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $2bffc98fd6f34db9$var$_complement(color) {
    var hsl = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(hsl);
}
function $2bffc98fd6f34db9$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $2bffc98fd6f34db9$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($2bffc98fd6f34db9$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $2bffc98fd6f34db9$var$_splitcomplement(color) {
    var hsl = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $2bffc98fd6f34db9$export$2e2bcd8739ae039(color),
        $2bffc98fd6f34db9$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $2bffc98fd6f34db9$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $2bffc98fd6f34db9$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $2bffc98fd6f34db9$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($2bffc98fd6f34db9$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $2bffc98fd6f34db9$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($2bffc98fd6f34db9$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$2bffc98fd6f34db9$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $2bffc98fd6f34db9$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$2bffc98fd6f34db9$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color1);
    var c2 = $2bffc98fd6f34db9$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$2bffc98fd6f34db9$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $2bffc98fd6f34db9$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $2bffc98fd6f34db9$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$2bffc98fd6f34db9$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $2bffc98fd6f34db9$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $2bffc98fd6f34db9$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($2bffc98fd6f34db9$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $2bffc98fd6f34db9$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $2bffc98fd6f34db9$var$names = $2bffc98fd6f34db9$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $2bffc98fd6f34db9$var$hexNames = $2bffc98fd6f34db9$export$2e2bcd8739ae039.hexNames = $2bffc98fd6f34db9$var$flip($2bffc98fd6f34db9$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $2bffc98fd6f34db9$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $2bffc98fd6f34db9$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $2bffc98fd6f34db9$var$bound01(n, max) {
    if ($2bffc98fd6f34db9$var$isOnePointZero(n)) n = "100%";
    var processPercent = $2bffc98fd6f34db9$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $2bffc98fd6f34db9$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $2bffc98fd6f34db9$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $2bffc98fd6f34db9$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $2bffc98fd6f34db9$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $2bffc98fd6f34db9$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $2bffc98fd6f34db9$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $2bffc98fd6f34db9$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $2bffc98fd6f34db9$var$convertHexToDecimal(h) {
    return $2bffc98fd6f34db9$var$parseIntFromHex(h) / 255;
}
var $2bffc98fd6f34db9$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $2bffc98fd6f34db9$var$isValidCSSUnit(color) {
    return !!$2bffc98fd6f34db9$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $2bffc98fd6f34db9$var$stringInputToObject(color) {
    color = color.replace($2bffc98fd6f34db9$var$trimLeft, "").replace($2bffc98fd6f34db9$var$trimRight, "").toLowerCase();
    var named = false;
    if ($2bffc98fd6f34db9$var$names[color]) {
        color = $2bffc98fd6f34db9$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $2bffc98fd6f34db9$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $2bffc98fd6f34db9$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $2bffc98fd6f34db9$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $2bffc98fd6f34db9$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $2bffc98fd6f34db9$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $2bffc98fd6f34db9$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $2bffc98fd6f34db9$var$matchers.hex8.exec(color)) return {
        r: $2bffc98fd6f34db9$var$parseIntFromHex(match[1]),
        g: $2bffc98fd6f34db9$var$parseIntFromHex(match[2]),
        b: $2bffc98fd6f34db9$var$parseIntFromHex(match[3]),
        a: $2bffc98fd6f34db9$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $2bffc98fd6f34db9$var$matchers.hex6.exec(color)) return {
        r: $2bffc98fd6f34db9$var$parseIntFromHex(match[1]),
        g: $2bffc98fd6f34db9$var$parseIntFromHex(match[2]),
        b: $2bffc98fd6f34db9$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $2bffc98fd6f34db9$var$matchers.hex4.exec(color)) return {
        r: $2bffc98fd6f34db9$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $2bffc98fd6f34db9$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $2bffc98fd6f34db9$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $2bffc98fd6f34db9$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $2bffc98fd6f34db9$var$matchers.hex3.exec(color)) return {
        r: $2bffc98fd6f34db9$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $2bffc98fd6f34db9$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $2bffc98fd6f34db9$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $2bffc98fd6f34db9$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}
module.exports["default"] = $2bffc98fd6f34db9$export$2e2bcd8739ae039;

});

parcelRegister("gRlff", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gpbvI = parcelRequire("gpbvI");

Object.defineProperty(module.exports, 'Alpha', {
    enumerable: true,
    get: function get() {
        return $c4621362f5dff80b$var$_interopRequireDefault($gpbvI).default;
    }
});

var $7gujn = parcelRequire("7gujn");

Object.defineProperty(module.exports, 'Checkboard', {
    enumerable: true,
    get: function get() {
        return $c4621362f5dff80b$var$_interopRequireDefault($7gujn).default;
    }
});

var $2DMpZ = parcelRequire("2DMpZ");

Object.defineProperty(module.exports, 'EditableInput', {
    enumerable: true,
    get: function get() {
        return $c4621362f5dff80b$var$_interopRequireDefault($2DMpZ).default;
    }
});

var $kq1bz = parcelRequire("kq1bz");

Object.defineProperty(module.exports, 'Hue', {
    enumerable: true,
    get: function get() {
        return $c4621362f5dff80b$var$_interopRequireDefault($kq1bz).default;
    }
});

var $2bNIm = parcelRequire("2bNIm");

Object.defineProperty(module.exports, 'Raised', {
    enumerable: true,
    get: function get() {
        return $c4621362f5dff80b$var$_interopRequireDefault($2bNIm).default;
    }
});

var $Vanfc = parcelRequire("Vanfc");

Object.defineProperty(module.exports, 'Saturation', {
    enumerable: true,
    get: function get() {
        return $c4621362f5dff80b$var$_interopRequireDefault($Vanfc).default;
    }
});

var $gPE3Z = parcelRequire("gPE3Z");

Object.defineProperty(module.exports, 'ColorWrap', {
    enumerable: true,
    get: function get() {
        return $c4621362f5dff80b$var$_interopRequireDefault($gPE3Z).default;
    }
});

var $7R0kk = parcelRequire("7R0kk");

Object.defineProperty(module.exports, 'Swatch', {
    enumerable: true,
    get: function get() {
        return $c4621362f5dff80b$var$_interopRequireDefault($7R0kk).default;
    }
});
function $c4621362f5dff80b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});

parcelRegister("jxm4A", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $4yUlE = parcelRequire("4yUlE");

const $9e1a22f3697dadba$var$colorTileStyles = (0, $buxP3.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $9e1a22f3697dadba$export$2640496e4bfb3b8c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let { builtInColorMap: builtInColorMap, value: value, size: t1, testId: testId } = t0;
    let size = t1 === undefined ? "24" : t1;
    let t2;
    if ($[0] !== builtInColorMap || $[1] !== value) {
        t2 = (0, $4yUlE.isValidColor)(value) ? builtInColorMap.getResponsiveColor(value) : "var(--ds-surface-overlay, #FFFFFF)";
        $[0] = builtInColorMap;
        $[1] = value;
        $[2] = t2;
    } else t2 = $[2];
    value = t2;
    size = `${size}px`;
    const t3 = testId ?? "color-tile";
    let t4;
    if ($[3] !== size || $[4] !== value) {
        t4 = {
            backgroundColor: value,
            height: size,
            width: size
        };
        $[3] = size;
        $[4] = value;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: t3,
            xcss: $9e1a22f3697dadba$var$colorTileStyles,
            style: t4
        });
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ builtInColorMap: builtInColorMap, value: value, size: size = '24', testId: testId })=>{
    value = (0, $4yUlE.isValidColor)(value) ? builtInColorMap.getResponsiveColor(value) : "var(--ds-surface-overlay, #FFFFFF)";
    size = `${size}px`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        testId: testId ?? 'color-tile',
        xcss: $9e1a22f3697dadba$var$colorTileStyles,
        style: {
            backgroundColor: value,
            height: size,
            width: size
        }
    });
};
module.exports["ColorTile"] = $9e1a22f3697dadba$export$2640496e4bfb3b8c;

});

parcelRegister("bgqhD", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $833593ae9264a46e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $833593ae9264a46e$var$freeGlobal;

});

parcelRegister("aKMOV", function(module, exports) {

var $bgqhD = parcelRequire("bgqhD");

/** Detect free variable `self`. */ var $02053a189d54c842$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $02053a189d54c842$var$root = $bgqhD || $02053a189d54c842$var$freeSelf || Function('return this')();
module.exports = $02053a189d54c842$var$root;

});

parcelRegister("7ueoP", function(module, exports) {

var $6ykdO = parcelRequire("6ykdO");

/** Detect free variable `self`. */ var $5736812781afad52$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $5736812781afad52$var$root = $6ykdO || $5736812781afad52$var$freeSelf || Function('return this')();
module.exports = $5736812781afad52$var$root;

});

parcelRegister("6ykdO", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $4c559aac3d7c79df$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $4c559aac3d7c79df$var$freeGlobal;

});

parcelRegister("gpbvI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Alpha = undefined;
var $bf17e8e484f6d7ab$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $bf17e8e484f6d7ab$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cozmU = parcelRequire("cozmU");

var $bf17e8e484f6d7ab$var$_react2 = $bf17e8e484f6d7ab$var$_interopRequireDefault($cozmU);

var $3ILwF = parcelRequire("3ILwF");

var $bf17e8e484f6d7ab$var$_reactcss2 = $bf17e8e484f6d7ab$var$_interopRequireDefault($3ILwF);

var $gAn7v = parcelRequire("gAn7v");

var $bf17e8e484f6d7ab$var$alpha = $bf17e8e484f6d7ab$var$_interopRequireWildcard($gAn7v);

var $7gujn = parcelRequire("7gujn");

var $bf17e8e484f6d7ab$var$_Checkboard2 = $bf17e8e484f6d7ab$var$_interopRequireDefault($7gujn);
function $bf17e8e484f6d7ab$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $bf17e8e484f6d7ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bf17e8e484f6d7ab$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bf17e8e484f6d7ab$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bf17e8e484f6d7ab$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $bf17e8e484f6d7ab$var$Alpha = module.exports.Alpha = function(_ref) {
    $bf17e8e484f6d7ab$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $bf17e8e484f6d7ab$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $bf17e8e484f6d7ab$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $bf17e8e484f6d7ab$var$alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), $bf17e8e484f6d7ab$var$_possibleConstructorReturn(_this, _ret);
    }
    $bf17e8e484f6d7ab$var$_createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, $bf17e8e484f6d7ab$var$_reactcss2.default)({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': $bf17e8e484f6d7ab$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return $bf17e8e484f6d7ab$var$_react2.default.createElement('div', {
                    style: styles.alpha
                }, $bf17e8e484f6d7ab$var$_react2.default.createElement('div', {
                    style: styles.checkboard
                }, $bf17e8e484f6d7ab$var$_react2.default.createElement($bf17e8e484f6d7ab$var$_Checkboard2.default, {
                    renderers: this.props.renderers
                })), $bf17e8e484f6d7ab$var$_react2.default.createElement('div', {
                    style: styles.gradient
                }), $bf17e8e484f6d7ab$var$_react2.default.createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $bf17e8e484f6d7ab$var$_react2.default.createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? $bf17e8e484f6d7ab$var$_react2.default.createElement(this.props.pointer, this.props) : $bf17e8e484f6d7ab$var$_react2.default.createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}($cozmU.PureComponent || $cozmU.Component);
module.exports.default = $bf17e8e484f6d7ab$var$Alpha;

});

parcelRegister("7gujn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Checkboard = undefined;
var $54a18a442acaefe5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $cozmU = parcelRequire("cozmU");

var $54a18a442acaefe5$var$_react2 = $54a18a442acaefe5$var$_interopRequireDefault($cozmU);

var $3ILwF = parcelRequire("3ILwF");

var $54a18a442acaefe5$var$_reactcss2 = $54a18a442acaefe5$var$_interopRequireDefault($3ILwF);

var $27Wqk = parcelRequire("27Wqk");

var $54a18a442acaefe5$var$checkboard = $54a18a442acaefe5$var$_interopRequireWildcard($27Wqk);
function $54a18a442acaefe5$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $54a18a442acaefe5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $54a18a442acaefe5$var$Checkboard = module.exports.Checkboard = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, $54a18a442acaefe5$var$_reactcss2.default)({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + $54a18a442acaefe5$var$checkboard.get(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, $cozmU.isValidElement)(children) ? $54a18a442acaefe5$var$_react2.default.cloneElement(children, $54a18a442acaefe5$var$_extends({}, children.props, {
        style: $54a18a442acaefe5$var$_extends({}, children.props.style, styles.grid)
    })) : $54a18a442acaefe5$var$_react2.default.createElement('div', {
        style: styles.grid
    });
};
$54a18a442acaefe5$var$Checkboard.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
module.exports.default = $54a18a442acaefe5$var$Checkboard;

});

parcelRegister("2DMpZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditableInput = undefined;
var $1ec4c821b3131d58$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cozmU = parcelRequire("cozmU");

var $1ec4c821b3131d58$var$_react2 = $1ec4c821b3131d58$var$_interopRequireDefault($cozmU);

var $3ILwF = parcelRequire("3ILwF");

var $1ec4c821b3131d58$var$_reactcss2 = $1ec4c821b3131d58$var$_interopRequireDefault($3ILwF);
function $1ec4c821b3131d58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1ec4c821b3131d58$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1ec4c821b3131d58$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1ec4c821b3131d58$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1ec4c821b3131d58$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1ec4c821b3131d58$var$DEFAULT_ARROW_OFFSET = 1;
var $1ec4c821b3131d58$var$UP_KEY_CODE = 38;
var $1ec4c821b3131d58$var$DOWN_KEY_CODE = 40;
var $1ec4c821b3131d58$var$VALID_KEY_CODES = [
    $1ec4c821b3131d58$var$UP_KEY_CODE,
    $1ec4c821b3131d58$var$DOWN_KEY_CODE
];
var $1ec4c821b3131d58$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $1ec4c821b3131d58$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $1ec4c821b3131d58$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var $1ec4c821b3131d58$var$idCounter = 1;
var $1ec4c821b3131d58$var$EditableInput = module.exports.EditableInput = function(_ref) {
    $1ec4c821b3131d58$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $1ec4c821b3131d58$var$_classCallCheck(this, EditableInput);
        var _this = $1ec4c821b3131d58$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $1ec4c821b3131d58$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $1ec4c821b3131d58$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $1ec4c821b3131d58$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + $1ec4c821b3131d58$var$idCounter++;
        return _this;
    }
    $1ec4c821b3131d58$var$_createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return $1ec4c821b3131d58$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || $1ec4c821b3131d58$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, $1ec4c821b3131d58$var$_reactcss2.default)({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return $1ec4c821b3131d58$var$_react2.default.createElement('div', {
                    style: styles.wrap
                }, $1ec4c821b3131d58$var$_react2.default.createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? $1ec4c821b3131d58$var$_react2.default.createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}($cozmU.PureComponent || $cozmU.Component);
module.exports.default = $1ec4c821b3131d58$var$EditableInput;

});

parcelRegister("kq1bz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hue = undefined;
var $edd727cd9d268921$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cozmU = parcelRequire("cozmU");

var $edd727cd9d268921$var$_react2 = $edd727cd9d268921$var$_interopRequireDefault($cozmU);

var $3ILwF = parcelRequire("3ILwF");

var $edd727cd9d268921$var$_reactcss2 = $edd727cd9d268921$var$_interopRequireDefault($3ILwF);

var $6kSHQ = parcelRequire("6kSHQ");

var $edd727cd9d268921$var$hue = $edd727cd9d268921$var$_interopRequireWildcard($6kSHQ);
function $edd727cd9d268921$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $edd727cd9d268921$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $edd727cd9d268921$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $edd727cd9d268921$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $edd727cd9d268921$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $edd727cd9d268921$var$Hue = module.exports.Hue = function(_ref) {
    $edd727cd9d268921$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $edd727cd9d268921$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $edd727cd9d268921$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $edd727cd9d268921$var$hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $edd727cd9d268921$var$_possibleConstructorReturn(_this, _ret);
    }
    $edd727cd9d268921$var$_createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, $edd727cd9d268921$var$_reactcss2.default)({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return $edd727cd9d268921$var$_react2.default.createElement('div', {
                    style: styles.hue
                }, $edd727cd9d268921$var$_react2.default.createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $edd727cd9d268921$var$_react2.default.createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), $edd727cd9d268921$var$_react2.default.createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? $edd727cd9d268921$var$_react2.default.createElement(this.props.pointer, this.props) : $edd727cd9d268921$var$_react2.default.createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}($cozmU.PureComponent || $cozmU.Component);
module.exports.default = $edd727cd9d268921$var$Hue;

});

parcelRegister("2bNIm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Raised = undefined;

var $cozmU = parcelRequire("cozmU");

var $19832c17f9f582f1$var$_react2 = $19832c17f9f582f1$var$_interopRequireDefault($cozmU);

var $6b4nE = parcelRequire("6b4nE");

var $19832c17f9f582f1$var$_propTypes2 = $19832c17f9f582f1$var$_interopRequireDefault($6b4nE);

var $3ILwF = parcelRequire("3ILwF");

var $19832c17f9f582f1$var$_reactcss2 = $19832c17f9f582f1$var$_interopRequireDefault($3ILwF);
var $51456b061544123a$exports = {};
var $17e6d5b9816a6144$exports = {};
var $446f8f99167d5415$exports = {};
var $0be4910bbd3d85dc$exports = {};
var $045b76febb8590fc$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $045b76febb8590fc$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$045b76febb8590fc$exports = $045b76febb8590fc$var$listCacheClear;


var $6da4db14f1c2481c$exports = {};
var $fad50728ae393b48$exports = {};
var $483ab919d20f2085$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $483ab919d20f2085$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$483ab919d20f2085$exports = $483ab919d20f2085$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $fad50728ae393b48$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($483ab919d20f2085$exports(array[length][0], key)) return length;
    }
    return -1;
}
$fad50728ae393b48$exports = $fad50728ae393b48$var$assocIndexOf;


/** Used for built-in method references. */ var $6da4db14f1c2481c$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $6da4db14f1c2481c$var$splice = $6da4db14f1c2481c$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6da4db14f1c2481c$var$listCacheDelete(key) {
    var data = this.__data__, index = $fad50728ae393b48$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $6da4db14f1c2481c$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$6da4db14f1c2481c$exports = $6da4db14f1c2481c$var$listCacheDelete;


var $80d6d47ad464d70f$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d6d47ad464d70f$var$listCacheGet(key) {
    var data = this.__data__, index = $fad50728ae393b48$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$80d6d47ad464d70f$exports = $80d6d47ad464d70f$var$listCacheGet;


var $35f02b2ad4f671ac$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $35f02b2ad4f671ac$var$listCacheHas(key) {
    return $fad50728ae393b48$exports(this.__data__, key) > -1;
}
$35f02b2ad4f671ac$exports = $35f02b2ad4f671ac$var$listCacheHas;


var $655793f67006b4cb$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $655793f67006b4cb$var$listCacheSet(key, value) {
    var data = this.__data__, index = $fad50728ae393b48$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$655793f67006b4cb$exports = $655793f67006b4cb$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0be4910bbd3d85dc$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0be4910bbd3d85dc$var$ListCache.prototype.clear = $045b76febb8590fc$exports;
$0be4910bbd3d85dc$var$ListCache.prototype['delete'] = $6da4db14f1c2481c$exports;
$0be4910bbd3d85dc$var$ListCache.prototype.get = $80d6d47ad464d70f$exports;
$0be4910bbd3d85dc$var$ListCache.prototype.has = $35f02b2ad4f671ac$exports;
$0be4910bbd3d85dc$var$ListCache.prototype.set = $655793f67006b4cb$exports;
$0be4910bbd3d85dc$exports = $0be4910bbd3d85dc$var$ListCache;


var $1762a941de04689a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $1762a941de04689a$var$stackClear() {
    this.__data__ = new $0be4910bbd3d85dc$exports;
    this.size = 0;
}
$1762a941de04689a$exports = $1762a941de04689a$var$stackClear;


var $fb5181e65507f4f2$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fb5181e65507f4f2$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$fb5181e65507f4f2$exports = $fb5181e65507f4f2$var$stackDelete;


var $fd177afd096acc29$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fd177afd096acc29$var$stackGet(key) {
    return this.__data__.get(key);
}
$fd177afd096acc29$exports = $fd177afd096acc29$var$stackGet;


var $5215fa352eadbcab$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5215fa352eadbcab$var$stackHas(key) {
    return this.__data__.has(key);
}
$5215fa352eadbcab$exports = $5215fa352eadbcab$var$stackHas;


var $700f53b0554bb7bd$exports = {};

var $716235fa35943078$exports = {};
var $9319149f6bf7be4f$exports = {};
var $9b0e22da86fb1120$exports = {};

var $9CMr5 = parcelRequire("9CMr5");

var $dad0443ae89473e8$exports = {};
var $5876f1452d608fd8$exports = {};

var $7ueoP = parcelRequire("7ueoP");

/** Used to detect overreaching core-js shims. */ var $5876f1452d608fd8$var$coreJsData = $7ueoP["__core-js_shared__"];
$5876f1452d608fd8$exports = $5876f1452d608fd8$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $dad0443ae89473e8$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($5876f1452d608fd8$exports && $5876f1452d608fd8$exports.keys && $5876f1452d608fd8$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $dad0443ae89473e8$var$isMasked(func) {
    return !!$dad0443ae89473e8$var$maskSrcKey && $dad0443ae89473e8$var$maskSrcKey in func;
}
$dad0443ae89473e8$exports = $dad0443ae89473e8$var$isMasked;



var $b6Iwx = parcelRequire("b6Iwx");

var $c5797c03acaff2db$exports = {};
/** Used for built-in method references. */ var $c5797c03acaff2db$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $c5797c03acaff2db$var$funcToString = $c5797c03acaff2db$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $c5797c03acaff2db$var$toSource(func) {
    if (func != null) {
        try {
            return $c5797c03acaff2db$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$c5797c03acaff2db$exports = $c5797c03acaff2db$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $9b0e22da86fb1120$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $9b0e22da86fb1120$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $9b0e22da86fb1120$var$funcProto = Function.prototype, $9b0e22da86fb1120$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $9b0e22da86fb1120$var$funcToString = $9b0e22da86fb1120$var$funcProto.toString;
/** Used to check objects for own properties. */ var $9b0e22da86fb1120$var$hasOwnProperty = $9b0e22da86fb1120$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $9b0e22da86fb1120$var$reIsNative = RegExp('^' + $9b0e22da86fb1120$var$funcToString.call($9b0e22da86fb1120$var$hasOwnProperty).replace($9b0e22da86fb1120$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $9b0e22da86fb1120$var$baseIsNative(value) {
    if (!$b6Iwx(value) || $dad0443ae89473e8$exports(value)) return false;
    var pattern = $9CMr5(value) ? $9b0e22da86fb1120$var$reIsNative : $9b0e22da86fb1120$var$reIsHostCtor;
    return pattern.test($c5797c03acaff2db$exports(value));
}
$9b0e22da86fb1120$exports = $9b0e22da86fb1120$var$baseIsNative;


var $df92f90117289414$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $df92f90117289414$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$df92f90117289414$exports = $df92f90117289414$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $9319149f6bf7be4f$var$getNative(object, key) {
    var value = $df92f90117289414$exports(object, key);
    return $9b0e22da86fb1120$exports(value) ? value : undefined;
}
$9319149f6bf7be4f$exports = $9319149f6bf7be4f$var$getNative;





/* Built-in method references that are verified to be native. */ var $716235fa35943078$var$Map = $9319149f6bf7be4f$exports($7ueoP, 'Map');
$716235fa35943078$exports = $716235fa35943078$var$Map;


var $4951de29e62c604b$exports = {};
var $f3cafe240cc658ad$exports = {};
var $aa24264b2d7d872f$exports = {};
var $62cb0b71e75c5ca4$exports = {};
var $1a7081032dbc2577$exports = {};

/* Built-in method references that are verified to be native. */ var $1a7081032dbc2577$var$nativeCreate = $9319149f6bf7be4f$exports(Object, 'create');
$1a7081032dbc2577$exports = $1a7081032dbc2577$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $62cb0b71e75c5ca4$var$hashClear() {
    this.__data__ = $1a7081032dbc2577$exports ? $1a7081032dbc2577$exports(null) : {};
    this.size = 0;
}
$62cb0b71e75c5ca4$exports = $62cb0b71e75c5ca4$var$hashClear;


var $8e99668899c2fe77$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8e99668899c2fe77$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$8e99668899c2fe77$exports = $8e99668899c2fe77$var$hashDelete;


var $b8a06b761bbc2450$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $b8a06b761bbc2450$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $b8a06b761bbc2450$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b8a06b761bbc2450$var$hasOwnProperty = $b8a06b761bbc2450$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b8a06b761bbc2450$var$hashGet(key) {
    var data = this.__data__;
    if ($1a7081032dbc2577$exports) {
        var result = data[key];
        return result === $b8a06b761bbc2450$var$HASH_UNDEFINED ? undefined : result;
    }
    return $b8a06b761bbc2450$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$b8a06b761bbc2450$exports = $b8a06b761bbc2450$var$hashGet;


var $22bbab2cca8449f4$exports = {};

/** Used for built-in method references. */ var $22bbab2cca8449f4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $22bbab2cca8449f4$var$hasOwnProperty = $22bbab2cca8449f4$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $22bbab2cca8449f4$var$hashHas(key) {
    var data = this.__data__;
    return $1a7081032dbc2577$exports ? data[key] !== undefined : $22bbab2cca8449f4$var$hasOwnProperty.call(data, key);
}
$22bbab2cca8449f4$exports = $22bbab2cca8449f4$var$hashHas;


var $210bfe0b776ba07a$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $210bfe0b776ba07a$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $210bfe0b776ba07a$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $1a7081032dbc2577$exports && value === undefined ? $210bfe0b776ba07a$var$HASH_UNDEFINED : value;
    return this;
}
$210bfe0b776ba07a$exports = $210bfe0b776ba07a$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $aa24264b2d7d872f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$aa24264b2d7d872f$var$Hash.prototype.clear = $62cb0b71e75c5ca4$exports;
$aa24264b2d7d872f$var$Hash.prototype['delete'] = $8e99668899c2fe77$exports;
$aa24264b2d7d872f$var$Hash.prototype.get = $b8a06b761bbc2450$exports;
$aa24264b2d7d872f$var$Hash.prototype.has = $22bbab2cca8449f4$exports;
$aa24264b2d7d872f$var$Hash.prototype.set = $210bfe0b776ba07a$exports;
$aa24264b2d7d872f$exports = $aa24264b2d7d872f$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $f3cafe240cc658ad$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $aa24264b2d7d872f$exports,
        'map': new ($716235fa35943078$exports || $0be4910bbd3d85dc$exports),
        'string': new $aa24264b2d7d872f$exports
    };
}
$f3cafe240cc658ad$exports = $f3cafe240cc658ad$var$mapCacheClear;


var $dab6ba9912a135df$exports = {};
var $80a0319f8d4687c9$exports = {};
var $655853fec3928770$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $655853fec3928770$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$655853fec3928770$exports = $655853fec3928770$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $80a0319f8d4687c9$var$getMapData(map, key) {
    var data = map.__data__;
    return $655853fec3928770$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$80a0319f8d4687c9$exports = $80a0319f8d4687c9$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $dab6ba9912a135df$var$mapCacheDelete(key) {
    var result = $80a0319f8d4687c9$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$dab6ba9912a135df$exports = $dab6ba9912a135df$var$mapCacheDelete;


var $abb09bdea0db5d3a$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $abb09bdea0db5d3a$var$mapCacheGet(key) {
    return $80a0319f8d4687c9$exports(this, key).get(key);
}
$abb09bdea0db5d3a$exports = $abb09bdea0db5d3a$var$mapCacheGet;


var $fdaafd9842569c37$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdaafd9842569c37$var$mapCacheHas(key) {
    return $80a0319f8d4687c9$exports(this, key).has(key);
}
$fdaafd9842569c37$exports = $fdaafd9842569c37$var$mapCacheHas;


var $a6676a83d95255e6$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a6676a83d95255e6$var$mapCacheSet(key, value) {
    var data = $80a0319f8d4687c9$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$a6676a83d95255e6$exports = $a6676a83d95255e6$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4951de29e62c604b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4951de29e62c604b$var$MapCache.prototype.clear = $f3cafe240cc658ad$exports;
$4951de29e62c604b$var$MapCache.prototype['delete'] = $dab6ba9912a135df$exports;
$4951de29e62c604b$var$MapCache.prototype.get = $abb09bdea0db5d3a$exports;
$4951de29e62c604b$var$MapCache.prototype.has = $fdaafd9842569c37$exports;
$4951de29e62c604b$var$MapCache.prototype.set = $a6676a83d95255e6$exports;
$4951de29e62c604b$exports = $4951de29e62c604b$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $700f53b0554bb7bd$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $700f53b0554bb7bd$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $0be4910bbd3d85dc$exports) {
        var pairs = data.__data__;
        if (!$716235fa35943078$exports || pairs.length < $700f53b0554bb7bd$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4951de29e62c604b$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$700f53b0554bb7bd$exports = $700f53b0554bb7bd$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $446f8f99167d5415$var$Stack(entries) {
    var data = this.__data__ = new $0be4910bbd3d85dc$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$446f8f99167d5415$var$Stack.prototype.clear = $1762a941de04689a$exports;
$446f8f99167d5415$var$Stack.prototype['delete'] = $fb5181e65507f4f2$exports;
$446f8f99167d5415$var$Stack.prototype.get = $fd177afd096acc29$exports;
$446f8f99167d5415$var$Stack.prototype.has = $5215fa352eadbcab$exports;
$446f8f99167d5415$var$Stack.prototype.set = $700f53b0554bb7bd$exports;
$446f8f99167d5415$exports = $446f8f99167d5415$var$Stack;


var $2d244ee20496afa6$exports = {};
var $9e68628c1c78a1a1$exports = {};
var $2c0fb237f1c4ba93$exports = {};

var $2c0fb237f1c4ba93$var$defineProperty = function() {
    try {
        var func = $9319149f6bf7be4f$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$2c0fb237f1c4ba93$exports = $2c0fb237f1c4ba93$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $9e68628c1c78a1a1$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $2c0fb237f1c4ba93$exports) $2c0fb237f1c4ba93$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$9e68628c1c78a1a1$exports = $9e68628c1c78a1a1$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2d244ee20496afa6$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$483ab919d20f2085$exports(object[key], value) || value === undefined && !(key in object)) $9e68628c1c78a1a1$exports(object, key, value);
}
$2d244ee20496afa6$exports = $2d244ee20496afa6$var$assignMergeValue;



var $g6T55 = parcelRequire("g6T55");

var $94ee666a11b036f5$exports = {};


var $fbycD = parcelRequire("fbycD");

var $e1190ff8550de379$exports = {};
var $7040b4495df8eda0$exports = {};
var $69641912681da91f$exports = {};



/** Built-in value references. */ var $69641912681da91f$var$Uint8Array = $7ueoP.Uint8Array;
$69641912681da91f$exports = $69641912681da91f$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $7040b4495df8eda0$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $69641912681da91f$exports(result).set(new $69641912681da91f$exports(arrayBuffer));
    return result;
}
$7040b4495df8eda0$exports = $7040b4495df8eda0$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $e1190ff8550de379$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $7040b4495df8eda0$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$e1190ff8550de379$exports = $e1190ff8550de379$var$cloneTypedArray;


var $67813e82ac9bc7c1$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $67813e82ac9bc7c1$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$67813e82ac9bc7c1$exports = $67813e82ac9bc7c1$var$copyArray;


var $39c30f4d86b277e4$exports = {};
var $64844b2f02076b48$exports = {};



/** Built-in value references. */ var $64844b2f02076b48$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $64844b2f02076b48$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$b6Iwx(proto)) return {};
        if ($64844b2f02076b48$var$objectCreate) return $64844b2f02076b48$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$64844b2f02076b48$exports = $64844b2f02076b48$var$baseCreate;


var $a2a1a23ff7c1492e$exports = {};

var $lWO9h = parcelRequire("lWO9h");

/** Built-in value references. */ var $a2a1a23ff7c1492e$var$getPrototype = $lWO9h(Object.getPrototypeOf, Object);
$a2a1a23ff7c1492e$exports = $a2a1a23ff7c1492e$var$getPrototype;



var $l6jnG = parcelRequire("l6jnG");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $39c30f4d86b277e4$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$l6jnG(object) ? $64844b2f02076b48$exports($a2a1a23ff7c1492e$exports(object)) : {};
}
$39c30f4d86b277e4$exports = $39c30f4d86b277e4$var$initCloneObject;



var $1tRtN = parcelRequire("1tRtN");


var $dEso5 = parcelRequire("dEso5");

var $926fa08a2883bf17$exports = {};

var $c0eyi = parcelRequire("c0eyi");


var $7Zt5w = parcelRequire("7Zt5w");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $926fa08a2883bf17$var$isArrayLikeObject(value) {
    return $7Zt5w(value) && $c0eyi(value);
}
$926fa08a2883bf17$exports = $926fa08a2883bf17$var$isArrayLikeObject;



var $joXc3 = parcelRequire("joXc3");







var $d328b092881dab88$exports = {};

var $frRyo = parcelRequire("frRyo");





/** `Object#toString` result references. */ var $d328b092881dab88$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $d328b092881dab88$var$funcProto = Function.prototype, $d328b092881dab88$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d328b092881dab88$var$funcToString = $d328b092881dab88$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d328b092881dab88$var$hasOwnProperty = $d328b092881dab88$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $d328b092881dab88$var$objectCtorString = $d328b092881dab88$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $d328b092881dab88$var$isPlainObject(value) {
    if (!$7Zt5w(value) || $frRyo(value) != $d328b092881dab88$var$objectTag) return false;
    var proto = $a2a1a23ff7c1492e$exports(value);
    if (proto === null) return true;
    var Ctor = $d328b092881dab88$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $d328b092881dab88$var$funcToString.call(Ctor) == $d328b092881dab88$var$objectCtorString;
}
$d328b092881dab88$exports = $d328b092881dab88$var$isPlainObject;



var $7Ytzu = parcelRequire("7Ytzu");

var $238503bed6d3e551$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $238503bed6d3e551$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
$238503bed6d3e551$exports = $238503bed6d3e551$var$safeGet;


var $527614382b16f29b$exports = {};
var $d02ab508f23f5f77$exports = {};
var $f92d68d5a0d849bd$exports = {};


/** Used for built-in method references. */ var $f92d68d5a0d849bd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f92d68d5a0d849bd$var$hasOwnProperty = $f92d68d5a0d849bd$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f92d68d5a0d849bd$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($f92d68d5a0d849bd$var$hasOwnProperty.call(object, key) && $483ab919d20f2085$exports(objValue, value)) || value === undefined && !(key in object)) $9e68628c1c78a1a1$exports(object, key, value);
}
$f92d68d5a0d849bd$exports = $f92d68d5a0d849bd$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $d02ab508f23f5f77$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $9e68628c1c78a1a1$exports(object, key, newValue);
        else $f92d68d5a0d849bd$exports(object, key, newValue);
    }
    return object;
}
$d02ab508f23f5f77$exports = $d02ab508f23f5f77$var$copyObject;


var $5c030b9ee5d1a54e$exports = {};

var $bwvzb = parcelRequire("bwvzb");

var $8d450eba34a7336d$exports = {};






var $e28882b439e51cba$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e28882b439e51cba$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$e28882b439e51cba$exports = $e28882b439e51cba$var$nativeKeysIn;


/** Used for built-in method references. */ var $8d450eba34a7336d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8d450eba34a7336d$var$hasOwnProperty = $8d450eba34a7336d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8d450eba34a7336d$var$baseKeysIn(object) {
    if (!$b6Iwx(object)) return $e28882b439e51cba$exports(object);
    var isProto = $l6jnG(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$8d450eba34a7336d$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$8d450eba34a7336d$exports = $8d450eba34a7336d$var$baseKeysIn;





/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $5c030b9ee5d1a54e$var$keysIn(object) {
    return $c0eyi(object) ? $bwvzb(object, true) : $8d450eba34a7336d$exports(object);
}
$5c030b9ee5d1a54e$exports = $5c030b9ee5d1a54e$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $527614382b16f29b$var$toPlainObject(value) {
    return $d02ab508f23f5f77$exports(value, $5c030b9ee5d1a54e$exports(value));
}
$527614382b16f29b$exports = $527614382b16f29b$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $94ee666a11b036f5$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $238503bed6d3e551$exports(object, key), srcValue = $238503bed6d3e551$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $2d244ee20496afa6$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $dEso5(srcValue), isBuff = !isArr && $joXc3(srcValue), isTyped = !isArr && !isBuff && $7Ytzu(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($dEso5(objValue)) newValue = objValue;
            else if ($926fa08a2883bf17$exports(objValue)) newValue = $67813e82ac9bc7c1$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $fbycD(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $e1190ff8550de379$exports(srcValue, true);
            } else newValue = [];
        } else if ($d328b092881dab88$exports(srcValue) || $1tRtN(srcValue)) {
            newValue = objValue;
            if ($1tRtN(objValue)) newValue = $527614382b16f29b$exports(objValue);
            else if (!$b6Iwx(objValue) || $9CMr5(objValue)) newValue = $39c30f4d86b277e4$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $2d244ee20496afa6$exports(object, key, newValue);
}
$94ee666a11b036f5$exports = $94ee666a11b036f5$var$baseMergeDeep;







/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $17e6d5b9816a6144$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $g6T55(source, function(srcValue, key) {
        stack || (stack = new $446f8f99167d5415$exports);
        if ($b6Iwx(srcValue)) $94ee666a11b036f5$exports(object, source, key, srcIndex, $17e6d5b9816a6144$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($238503bed6d3e551$exports(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $2d244ee20496afa6$exports(object, key, newValue);
        }
    }, $5c030b9ee5d1a54e$exports);
}
$17e6d5b9816a6144$exports = $17e6d5b9816a6144$var$baseMerge;


var $5be5cbb02acef438$exports = {};
var $6da90e6f510ca403$exports = {};

var $gMntP = parcelRequire("gMntP");

var $cce9fd2dacdc199e$exports = {};
var $7451ca85aba8025f$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $7451ca85aba8025f$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$7451ca85aba8025f$exports = $7451ca85aba8025f$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $cce9fd2dacdc199e$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $cce9fd2dacdc199e$var$overRest(func, start, transform) {
    start = $cce9fd2dacdc199e$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $cce9fd2dacdc199e$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $7451ca85aba8025f$exports(func, this, otherArgs);
    };
}
$cce9fd2dacdc199e$exports = $cce9fd2dacdc199e$var$overRest;


var $036d2f647f6a20f5$exports = {};
var $5f6cd75d4c058748$exports = {};
var $e003e48c0a73c34f$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $e003e48c0a73c34f$var$constant(value) {
    return function() {
        return value;
    };
}
$e003e48c0a73c34f$exports = $e003e48c0a73c34f$var$constant;






/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $5f6cd75d4c058748$var$baseSetToString = !$2c0fb237f1c4ba93$exports ? $gMntP : function(func, string) {
    return $2c0fb237f1c4ba93$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $e003e48c0a73c34f$exports(string),
        'writable': true
    });
};
$5f6cd75d4c058748$exports = $5f6cd75d4c058748$var$baseSetToString;


var $9fad3e65d4c6d7b7$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $9fad3e65d4c6d7b7$var$HOT_COUNT = 800, $9fad3e65d4c6d7b7$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9fad3e65d4c6d7b7$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $9fad3e65d4c6d7b7$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $9fad3e65d4c6d7b7$var$nativeNow(), remaining = $9fad3e65d4c6d7b7$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $9fad3e65d4c6d7b7$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$9fad3e65d4c6d7b7$exports = $9fad3e65d4c6d7b7$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $036d2f647f6a20f5$var$setToString = $9fad3e65d4c6d7b7$exports($5f6cd75d4c058748$exports);
$036d2f647f6a20f5$exports = $036d2f647f6a20f5$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $6da90e6f510ca403$var$baseRest(func, start) {
    return $036d2f647f6a20f5$exports($cce9fd2dacdc199e$exports(func, start, $gMntP), func + '');
}
$6da90e6f510ca403$exports = $6da90e6f510ca403$var$baseRest;


var $3df3563d261dfc88$exports = {};





var $kVTDC = parcelRequire("kVTDC");




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $3df3563d261dfc88$var$isIterateeCall(value, index, object) {
    if (!$b6Iwx(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $c0eyi(object) && $kVTDC(index, object.length) : type == 'string' && index in object) return $483ab919d20f2085$exports(object[index], value);
    return false;
}
$3df3563d261dfc88$exports = $3df3563d261dfc88$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $5be5cbb02acef438$var$createAssigner(assigner) {
    return $6da90e6f510ca403$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $3df3563d261dfc88$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$5be5cbb02acef438$exports = $5be5cbb02acef438$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $51456b061544123a$var$merge = $5be5cbb02acef438$exports(function(object, source, srcIndex) {
    $17e6d5b9816a6144$exports(object, source, srcIndex);
});
$51456b061544123a$exports = $51456b061544123a$var$merge;


var $19832c17f9f582f1$var$_merge2 = $19832c17f9f582f1$var$_interopRequireDefault($51456b061544123a$exports);
function $19832c17f9f582f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $19832c17f9f582f1$var$Raised = module.exports.Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, $19832c17f9f582f1$var$_reactcss2.default)((0, $19832c17f9f582f1$var$_merge2.default)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return $19832c17f9f582f1$var$_react2.default.createElement('div', {
        style: styles.wrap
    }, $19832c17f9f582f1$var$_react2.default.createElement('div', {
        style: styles.bg
    }), $19832c17f9f582f1$var$_react2.default.createElement('div', {
        style: styles.content
    }, children));
};
$19832c17f9f582f1$var$Raised.propTypes = {
    background: $19832c17f9f582f1$var$_propTypes2.default.string,
    zDepth: $19832c17f9f582f1$var$_propTypes2.default.oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: $19832c17f9f582f1$var$_propTypes2.default.number,
    styles: $19832c17f9f582f1$var$_propTypes2.default.object
};
$19832c17f9f582f1$var$Raised.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
module.exports.default = $19832c17f9f582f1$var$Raised;

});

parcelRegister("Vanfc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Saturation = undefined;
var $0abd5f070374384f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cozmU = parcelRequire("cozmU");

var $0abd5f070374384f$var$_react2 = $0abd5f070374384f$var$_interopRequireDefault($cozmU);

var $3ILwF = parcelRequire("3ILwF");

var $0abd5f070374384f$var$_reactcss2 = $0abd5f070374384f$var$_interopRequireDefault($3ILwF);
var $1574c5a2c418188f$exports = {};

var $g4s48 = parcelRequire("g4s48");


var $b6Iwx = parcelRequire("b6Iwx");

/** Error message constants. */ var $1574c5a2c418188f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $1574c5a2c418188f$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($1574c5a2c418188f$var$FUNC_ERROR_TEXT);
    if ($b6Iwx(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $g4s48(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$1574c5a2c418188f$exports = $1574c5a2c418188f$var$throttle;


var $0abd5f070374384f$var$_throttle2 = $0abd5f070374384f$var$_interopRequireDefault($1574c5a2c418188f$exports);

var $9mIj6 = parcelRequire("9mIj6");

var $0abd5f070374384f$var$saturation = $0abd5f070374384f$var$_interopRequireWildcard($9mIj6);
function $0abd5f070374384f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $0abd5f070374384f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0abd5f070374384f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0abd5f070374384f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0abd5f070374384f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $0abd5f070374384f$var$Saturation = module.exports.Saturation = function(_ref) {
    $0abd5f070374384f$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $0abd5f070374384f$var$_classCallCheck(this, Saturation);
        var _this = $0abd5f070374384f$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, $0abd5f070374384f$var$saturation.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $0abd5f070374384f$var$_throttle2.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $0abd5f070374384f$var$_createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, $0abd5f070374384f$var$_reactcss2.default)({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return $0abd5f070374384f$var$_react2.default.createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $0abd5f070374384f$var$_react2.default.createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), $0abd5f070374384f$var$_react2.default.createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, $0abd5f070374384f$var$_react2.default.createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), $0abd5f070374384f$var$_react2.default.createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? $0abd5f070374384f$var$_react2.default.createElement(this.props.pointer, this.props) : $0abd5f070374384f$var$_react2.default.createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}($cozmU.PureComponent || $cozmU.Component);
module.exports.default = $0abd5f070374384f$var$Saturation;

});

parcelRegister("gPE3Z", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ColorWrap = undefined;
var $c4107c84035395d1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c4107c84035395d1$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cozmU = parcelRequire("cozmU");

var $c4107c84035395d1$var$_react2 = $c4107c84035395d1$var$_interopRequireDefault($cozmU);

var $g4s48 = parcelRequire("g4s48");

var $c4107c84035395d1$var$_debounce2 = $c4107c84035395d1$var$_interopRequireDefault($g4s48);

var $64Z88 = parcelRequire("64Z88");

var $c4107c84035395d1$var$color = $c4107c84035395d1$var$_interopRequireWildcard($64Z88);
function $c4107c84035395d1$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $c4107c84035395d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4107c84035395d1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c4107c84035395d1$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c4107c84035395d1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c4107c84035395d1$var$ColorWrap = module.exports.ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $c4107c84035395d1$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $c4107c84035395d1$var$_classCallCheck(this, ColorPicker);
            var _this = $c4107c84035395d1$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $c4107c84035395d1$var$color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $c4107c84035395d1$var$color.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $c4107c84035395d1$var$color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $c4107c84035395d1$var$color.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $c4107c84035395d1$var$_extends({}, $c4107c84035395d1$var$color.toState(props.color, 0));
            _this.debounce = (0, $c4107c84035395d1$var$_debounce2.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $c4107c84035395d1$var$_createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return $c4107c84035395d1$var$_react2.default.createElement(Picker, $c4107c84035395d1$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $c4107c84035395d1$var$_extends({}, $c4107c84035395d1$var$color.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }($cozmU.PureComponent || $cozmU.Component);
    ColorPicker.propTypes = $c4107c84035395d1$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $c4107c84035395d1$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
module.exports.default = $c4107c84035395d1$var$ColorWrap;

});

parcelRegister("7R0kk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Swatch = undefined;
var $5b7dbc92e54441cf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $cozmU = parcelRequire("cozmU");

var $5b7dbc92e54441cf$var$_react2 = $5b7dbc92e54441cf$var$_interopRequireDefault($cozmU);

var $3ILwF = parcelRequire("3ILwF");

var $5b7dbc92e54441cf$var$_reactcss2 = $5b7dbc92e54441cf$var$_interopRequireDefault($3ILwF);

var $89qQa = parcelRequire("89qQa");


var $7gujn = parcelRequire("7gujn");

var $5b7dbc92e54441cf$var$_Checkboard2 = $5b7dbc92e54441cf$var$_interopRequireDefault($7gujn);
function $5b7dbc92e54441cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5b7dbc92e54441cf$var$ENTER = 13;
var $5b7dbc92e54441cf$var$Swatch = module.exports.Swatch = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, $5b7dbc92e54441cf$var$_reactcss2.default)({
        default: {
            swatch: $5b7dbc92e54441cf$var$_extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $5b7dbc92e54441cf$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return $5b7dbc92e54441cf$var$_react2.default.createElement('div', $5b7dbc92e54441cf$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && $5b7dbc92e54441cf$var$_react2.default.createElement($5b7dbc92e54441cf$var$_Checkboard2.default, {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
module.exports.default = (0, $89qQa.handleFocus)($5b7dbc92e54441cf$var$Swatch);

});

parcelRegister("3ILwF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactCSS = module.exports.loop = module.exports.handleActive = module.exports.handleHover = module.exports.hover = undefined;

var $i7nN9 = parcelRequire("i7nN9");

var $2b5a58d302b87fa3$var$_flattenNames2 = $2b5a58d302b87fa3$var$_interopRequireDefault($i7nN9);

var $gq4T6 = parcelRequire("gq4T6");

var $2b5a58d302b87fa3$var$_mergeClasses2 = $2b5a58d302b87fa3$var$_interopRequireDefault($gq4T6);

var $idbiG = parcelRequire("idbiG");

var $2b5a58d302b87fa3$var$_autoprefix2 = $2b5a58d302b87fa3$var$_interopRequireDefault($idbiG);

var $eAxCt = parcelRequire("eAxCt");

var $2b5a58d302b87fa3$var$_hover3 = $2b5a58d302b87fa3$var$_interopRequireDefault($eAxCt);

var $duht2 = parcelRequire("duht2");

var $2b5a58d302b87fa3$var$_active2 = $2b5a58d302b87fa3$var$_interopRequireDefault($duht2);

var $g6e9Y = parcelRequire("g6e9Y");

var $2b5a58d302b87fa3$var$_loop3 = $2b5a58d302b87fa3$var$_interopRequireDefault($g6e9Y);
function $2b5a58d302b87fa3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.hover = $2b5a58d302b87fa3$var$_hover3.default;
module.exports.handleHover = $2b5a58d302b87fa3$var$_hover3.default;
module.exports.handleActive = $2b5a58d302b87fa3$var$_active2.default;
module.exports.loop = $2b5a58d302b87fa3$var$_loop3.default;
var $2b5a58d302b87fa3$var$ReactCSS = module.exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $2b5a58d302b87fa3$var$_flattenNames2.default)(activations);
    var merged = (0, $2b5a58d302b87fa3$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $2b5a58d302b87fa3$var$_autoprefix2.default)(merged);
};
module.exports.default = $2b5a58d302b87fa3$var$ReactCSS;

});

parcelRegister("gAn7v", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c131f15102099638$var$calculateChange = module.exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};

});

parcelRegister("27Wqk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $18c98dea9c769051$var$checkboardCache = {};
var $18c98dea9c769051$var$render = module.exports.render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $18c98dea9c769051$var$get = module.exports.get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if ($18c98dea9c769051$var$checkboardCache[key]) return $18c98dea9c769051$var$checkboardCache[key];
    var checkboard = $18c98dea9c769051$var$render(c1, c2, size, serverCanvas);
    $18c98dea9c769051$var$checkboardCache[key] = checkboard;
    return checkboard;
};

});

parcelRegister("6kSHQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $49cf0bd7aa79cbc9$var$calculateChange = module.exports.calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};

});

parcelRegister("9CMr5", function(module, exports) {

var $frRyo = parcelRequire("frRyo");


var $b6Iwx = parcelRequire("b6Iwx");

/** `Object#toString` result references. */ var $701d3c02355fee16$var$asyncTag = '[object AsyncFunction]', $701d3c02355fee16$var$funcTag = '[object Function]', $701d3c02355fee16$var$genTag = '[object GeneratorFunction]', $701d3c02355fee16$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $701d3c02355fee16$var$isFunction(value) {
    if (!$b6Iwx(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $frRyo(value);
    return tag == $701d3c02355fee16$var$funcTag || tag == $701d3c02355fee16$var$genTag || tag == $701d3c02355fee16$var$asyncTag || tag == $701d3c02355fee16$var$proxyTag;
}
module.exports = $701d3c02355fee16$var$isFunction;

});

parcelRegister("b6Iwx", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $8162cabcee379ad9$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $8162cabcee379ad9$var$isObject;

});

parcelRegister("g6T55", function(module, exports) {

var $8nkzn = parcelRequire("8nkzn");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $bba7eece749d8e26$var$baseFor = $8nkzn();
module.exports = $bba7eece749d8e26$var$baseFor;

});

parcelRegister("lWO9h", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ffa5ea3a527c7a9c$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ffa5ea3a527c7a9c$var$overArg;

});

parcelRegister("l6jnG", function(module, exports) {
/** Used for built-in method references. */ var $f5c9312df8a83252$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $f5c9312df8a83252$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $f5c9312df8a83252$var$objectProto;
    return value === proto;
}
module.exports = $f5c9312df8a83252$var$isPrototype;

});

parcelRegister("1tRtN", function(module, exports) {

var $cXEVT = parcelRequire("cXEVT");


var $7Zt5w = parcelRequire("7Zt5w");

/** Used for built-in method references. */ var $1141fbd2bc7cd377$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1141fbd2bc7cd377$var$hasOwnProperty = $1141fbd2bc7cd377$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $1141fbd2bc7cd377$var$propertyIsEnumerable = $1141fbd2bc7cd377$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $1141fbd2bc7cd377$var$isArguments = $cXEVT(function() {
    return arguments;
}()) ? $cXEVT : function(value) {
    return $7Zt5w(value) && $1141fbd2bc7cd377$var$hasOwnProperty.call(value, 'callee') && !$1141fbd2bc7cd377$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $1141fbd2bc7cd377$var$isArguments;

});

parcelRegister("dEso5", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $9f0507f0b6ed250a$var$isArray = Array.isArray;
module.exports = $9f0507f0b6ed250a$var$isArray;

});

parcelRegister("c0eyi", function(module, exports) {

var $9CMr5 = parcelRequire("9CMr5");


var $lJsSi = parcelRequire("lJsSi");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $8bd0c5e012c5f3ec$var$isArrayLike(value) {
    return value != null && $lJsSi(value.length) && !$9CMr5(value);
}
module.exports = $8bd0c5e012c5f3ec$var$isArrayLike;

});

parcelRegister("7Zt5w", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5d14cb37379ec6ae$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $5d14cb37379ec6ae$var$isObjectLike;

});

parcelRegister("frRyo", function(module, exports) {

var $2F8DI = parcelRequire("2F8DI");


var $9HwiP = parcelRequire("9HwiP");


var $kVSju = parcelRequire("kVSju");

/** `Object#toString` result references. */ var $b3f2eb4f3eef6899$var$nullTag = '[object Null]', $b3f2eb4f3eef6899$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $b3f2eb4f3eef6899$var$symToStringTag = $2F8DI ? $2F8DI.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $b3f2eb4f3eef6899$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $b3f2eb4f3eef6899$var$undefinedTag : $b3f2eb4f3eef6899$var$nullTag;
    return $b3f2eb4f3eef6899$var$symToStringTag && $b3f2eb4f3eef6899$var$symToStringTag in Object(value) ? $9HwiP(value) : $kVSju(value);
}
module.exports = $b3f2eb4f3eef6899$var$baseGetTag;

});

parcelRegister("7Ytzu", function(module, exports) {

var $krum2 = parcelRequire("krum2");


var $2DOkj = parcelRequire("2DOkj");


var $6Z6Du = parcelRequire("6Z6Du");

/* Node.js helper references. */ var $5ce5134819e3c88a$var$nodeIsTypedArray = $6Z6Du && $6Z6Du.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $5ce5134819e3c88a$var$isTypedArray = $5ce5134819e3c88a$var$nodeIsTypedArray ? $2DOkj($5ce5134819e3c88a$var$nodeIsTypedArray) : $krum2;
module.exports = $5ce5134819e3c88a$var$isTypedArray;

});

parcelRegister("bwvzb", function(module, exports) {

var $5aLoQ = parcelRequire("5aLoQ");


var $1tRtN = parcelRequire("1tRtN");


var $dEso5 = parcelRequire("dEso5");


var $joXc3 = parcelRequire("joXc3");


var $kVTDC = parcelRequire("kVTDC");


var $7Ytzu = parcelRequire("7Ytzu");

/** Used for built-in method references. */ var $863b2b4967927be1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $863b2b4967927be1$var$hasOwnProperty = $863b2b4967927be1$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $863b2b4967927be1$var$arrayLikeKeys(value, inherited) {
    var isArr = $dEso5(value), isArg = !isArr && $1tRtN(value), isBuff = !isArr && !isArg && $joXc3(value), isType = !isArr && !isArg && !isBuff && $7Ytzu(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $5aLoQ(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $863b2b4967927be1$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $kVTDC(key, length)))) result.push(key);
    return result;
}
module.exports = $863b2b4967927be1$var$arrayLikeKeys;

});

parcelRegister("gMntP", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $c37357b2c2df18f0$var$identity(value) {
    return value;
}
module.exports = $c37357b2c2df18f0$var$identity;

});

parcelRegister("kVTDC", function(module, exports) {
/** Used as references for various `Number` constants. */ var $f3d44a13fb4c261a$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $f3d44a13fb4c261a$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $f3d44a13fb4c261a$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $f3d44a13fb4c261a$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $f3d44a13fb4c261a$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $f3d44a13fb4c261a$var$isIndex;

});

parcelRegister("9mIj6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d18899cec061af2$var$calculateChange = module.exports.calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};

});

parcelRegister("g4s48", function(module, exports) {

var $b6Iwx = parcelRequire("b6Iwx");


var $41kYl = parcelRequire("41kYl");


var $cGID5 = parcelRequire("cGID5");

/** Error message constants. */ var $bb32ca508d4977d4$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bb32ca508d4977d4$var$nativeMax = Math.max, $bb32ca508d4977d4$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $bb32ca508d4977d4$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($bb32ca508d4977d4$var$FUNC_ERROR_TEXT);
    wait = $cGID5(wait) || 0;
    if ($b6Iwx(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $bb32ca508d4977d4$var$nativeMax($cGID5(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $bb32ca508d4977d4$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $41kYl();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($41kYl());
    }
    function debounced() {
        var time = $41kYl(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $bb32ca508d4977d4$var$debounce;

});

parcelRegister("64Z88", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isvalidColorString = module.exports.red = module.exports.getContrastingColor = module.exports.isValidHex = module.exports.toState = module.exports.simpleCheckForValidColor = undefined;
var $7f4ca5d4e7852ed8$exports = {};

$7f4ca5d4e7852ed8$exports = (parcelRequire("3lufT"));


var $46d288fdcdaf9e92$var$_each2 = $46d288fdcdaf9e92$var$_interopRequireDefault($7f4ca5d4e7852ed8$exports);

var $gna5h = parcelRequire("gna5h");

var $46d288fdcdaf9e92$var$_tinycolor2 = $46d288fdcdaf9e92$var$_interopRequireDefault($gna5h);
function $46d288fdcdaf9e92$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $46d288fdcdaf9e92$var$simpleCheckForValidColor = module.exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, $46d288fdcdaf9e92$var$_each2.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $46d288fdcdaf9e92$var$toState = module.exports.toState = function toState(data, oldHue) {
    var color = data.hex ? (0, $46d288fdcdaf9e92$var$_tinycolor2.default)(data.hex) : (0, $46d288fdcdaf9e92$var$_tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $46d288fdcdaf9e92$var$isValidHex = module.exports.isValidHex = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, $46d288fdcdaf9e92$var$_tinycolor2.default)(hex).isValid();
};
var $46d288fdcdaf9e92$var$getContrastingColor = module.exports.getContrastingColor = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = $46d288fdcdaf9e92$var$toState(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var $46d288fdcdaf9e92$var$red = module.exports.red = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $46d288fdcdaf9e92$var$isvalidColorString = module.exports.isvalidColorString = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, $46d288fdcdaf9e92$var$_tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};

});

parcelRegister("i7nN9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flattenNames = undefined;
var $350355a721a38e3a$exports = {};

var $iEhAW = parcelRequire("iEhAW");


var $gNbxK = parcelRequire("gNbxK");


var $edunD = parcelRequire("edunD");

/** `Object#toString` result references. */ var $350355a721a38e3a$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $350355a721a38e3a$var$isString(value) {
    return typeof value == 'string' || !$gNbxK(value) && $edunD(value) && $iEhAW(value) == $350355a721a38e3a$var$stringTag;
}
$350355a721a38e3a$exports = $350355a721a38e3a$var$isString;


var $d30b55f8d3dec7f8$var$_isString3 = $d30b55f8d3dec7f8$var$_interopRequireDefault($350355a721a38e3a$exports);

var $7EnRN = parcelRequire("7EnRN");

var $d30b55f8d3dec7f8$var$_forOwn3 = $d30b55f8d3dec7f8$var$_interopRequireDefault($7EnRN);
var $100b0bec86cd1456$exports = {};




var $gxllf = parcelRequire("gxllf");




/** `Object#toString` result references. */ var $100b0bec86cd1456$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $100b0bec86cd1456$var$funcProto = Function.prototype, $100b0bec86cd1456$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $100b0bec86cd1456$var$funcToString = $100b0bec86cd1456$var$funcProto.toString;
/** Used to check objects for own properties. */ var $100b0bec86cd1456$var$hasOwnProperty = $100b0bec86cd1456$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $100b0bec86cd1456$var$objectCtorString = $100b0bec86cd1456$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $100b0bec86cd1456$var$isPlainObject(value) {
    if (!$edunD(value) || $iEhAW(value) != $100b0bec86cd1456$var$objectTag) return false;
    var proto = $gxllf(value);
    if (proto === null) return true;
    var Ctor = $100b0bec86cd1456$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $100b0bec86cd1456$var$funcToString.call(Ctor) == $100b0bec86cd1456$var$objectCtorString;
}
$100b0bec86cd1456$exports = $100b0bec86cd1456$var$isPlainObject;


var $d30b55f8d3dec7f8$var$_isPlainObject3 = $d30b55f8d3dec7f8$var$_interopRequireDefault($100b0bec86cd1456$exports);
var $f0a313b3ebda1dc4$exports = {};
var $05df06851cd76d57$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $05df06851cd76d57$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$05df06851cd76d57$exports = $05df06851cd76d57$var$arrayMap;


var $56fd83aafaf9e538$exports = {};
var $09fe28480a52eb13$exports = {};
var $9a947bf20769ef67$exports = {};

var $6VvrE = parcelRequire("6VvrE");

var $1adaa373be41028c$exports = {};
var $1005900946a463c3$exports = {};



var $dbe4716153d631ba$exports = {};
var $986651b0927c915c$exports = {};

var $8Qg0i = parcelRequire("8Qg0i");

var $86d61c3fbae03442$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $86d61c3fbae03442$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $86d61c3fbae03442$var$setCacheAdd(value) {
    this.__data__.set(value, $86d61c3fbae03442$var$HASH_UNDEFINED);
    return this;
}
$86d61c3fbae03442$exports = $86d61c3fbae03442$var$setCacheAdd;


var $6b9b2c6e23e018b8$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $6b9b2c6e23e018b8$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$6b9b2c6e23e018b8$exports = $6b9b2c6e23e018b8$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $986651b0927c915c$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $8Qg0i;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$986651b0927c915c$var$SetCache.prototype.add = $986651b0927c915c$var$SetCache.prototype.push = $86d61c3fbae03442$exports;
$986651b0927c915c$var$SetCache.prototype.has = $6b9b2c6e23e018b8$exports;
$986651b0927c915c$exports = $986651b0927c915c$var$SetCache;


var $50fa772c64a91e5a$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $50fa772c64a91e5a$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$50fa772c64a91e5a$exports = $50fa772c64a91e5a$var$arraySome;


var $ef84077e622e11d6$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ef84077e622e11d6$var$cacheHas(cache, key) {
    return cache.has(key);
}
$ef84077e622e11d6$exports = $ef84077e622e11d6$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $dbe4716153d631ba$var$COMPARE_PARTIAL_FLAG = 1, $dbe4716153d631ba$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $dbe4716153d631ba$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $dbe4716153d631ba$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $dbe4716153d631ba$var$COMPARE_UNORDERED_FLAG ? new $986651b0927c915c$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$50fa772c64a91e5a$exports(other, function(othValue, othIndex) {
                if (!$ef84077e622e11d6$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$dbe4716153d631ba$exports = $dbe4716153d631ba$var$equalArrays;


var $03b34759c76c9619$exports = {};

var $hs6bh = parcelRequire("hs6bh");


var $hxBlg = parcelRequire("hxBlg");


var $4ESv6 = parcelRequire("4ESv6");


var $f75b9b5f27e9a312$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $f75b9b5f27e9a312$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$f75b9b5f27e9a312$exports = $f75b9b5f27e9a312$var$mapToArray;


var $1a993a9b0ad5b60e$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $1a993a9b0ad5b60e$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$1a993a9b0ad5b60e$exports = $1a993a9b0ad5b60e$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $03b34759c76c9619$var$COMPARE_PARTIAL_FLAG = 1, $03b34759c76c9619$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $03b34759c76c9619$var$boolTag = '[object Boolean]', $03b34759c76c9619$var$dateTag = '[object Date]', $03b34759c76c9619$var$errorTag = '[object Error]', $03b34759c76c9619$var$mapTag = '[object Map]', $03b34759c76c9619$var$numberTag = '[object Number]', $03b34759c76c9619$var$regexpTag = '[object RegExp]', $03b34759c76c9619$var$setTag = '[object Set]', $03b34759c76c9619$var$stringTag = '[object String]', $03b34759c76c9619$var$symbolTag = '[object Symbol]';
var $03b34759c76c9619$var$arrayBufferTag = '[object ArrayBuffer]', $03b34759c76c9619$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $03b34759c76c9619$var$symbolProto = $hs6bh ? $hs6bh.prototype : undefined, $03b34759c76c9619$var$symbolValueOf = $03b34759c76c9619$var$symbolProto ? $03b34759c76c9619$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $03b34759c76c9619$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $03b34759c76c9619$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $03b34759c76c9619$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $hxBlg(object), new $hxBlg(other))) return false;
            return true;
        case $03b34759c76c9619$var$boolTag:
        case $03b34759c76c9619$var$dateTag:
        case $03b34759c76c9619$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $4ESv6(+object, +other);
        case $03b34759c76c9619$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $03b34759c76c9619$var$regexpTag:
        case $03b34759c76c9619$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $03b34759c76c9619$var$mapTag:
            var convert = $f75b9b5f27e9a312$exports;
        case $03b34759c76c9619$var$setTag:
            var isPartial = bitmask & $03b34759c76c9619$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1a993a9b0ad5b60e$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $03b34759c76c9619$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $dbe4716153d631ba$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $03b34759c76c9619$var$symbolTag:
            if ($03b34759c76c9619$var$symbolValueOf) return $03b34759c76c9619$var$symbolValueOf.call(object) == $03b34759c76c9619$var$symbolValueOf.call(other);
    }
    return false;
}
$03b34759c76c9619$exports = $03b34759c76c9619$var$equalByTag;


var $9316a6dfb316fa3b$exports = {};

var $6YdgV = parcelRequire("6YdgV");

/** Used to compose bitmasks for value comparisons. */ var $9316a6dfb316fa3b$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $9316a6dfb316fa3b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9316a6dfb316fa3b$var$hasOwnProperty = $9316a6dfb316fa3b$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9316a6dfb316fa3b$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $9316a6dfb316fa3b$var$COMPARE_PARTIAL_FLAG, objProps = $6YdgV(object), objLength = objProps.length, othProps = $6YdgV(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $9316a6dfb316fa3b$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$9316a6dfb316fa3b$exports = $9316a6dfb316fa3b$var$equalObjects;



var $49wbE = parcelRequire("49wbE");





var $9GzMu = parcelRequire("9GzMu");


var $2vKbG = parcelRequire("2vKbG");

/** Used to compose bitmasks for value comparisons. */ var $1005900946a463c3$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $1005900946a463c3$var$argsTag = '[object Arguments]', $1005900946a463c3$var$arrayTag = '[object Array]', $1005900946a463c3$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $1005900946a463c3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1005900946a463c3$var$hasOwnProperty = $1005900946a463c3$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1005900946a463c3$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $gNbxK(object), othIsArr = $gNbxK(other), objTag = objIsArr ? $1005900946a463c3$var$arrayTag : $49wbE(object), othTag = othIsArr ? $1005900946a463c3$var$arrayTag : $49wbE(other);
    objTag = objTag == $1005900946a463c3$var$argsTag ? $1005900946a463c3$var$objectTag : objTag;
    othTag = othTag == $1005900946a463c3$var$argsTag ? $1005900946a463c3$var$objectTag : othTag;
    var objIsObj = objTag == $1005900946a463c3$var$objectTag, othIsObj = othTag == $1005900946a463c3$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $9GzMu(object)) {
        if (!$9GzMu(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $6VvrE);
        return objIsArr || $2vKbG(object) ? $dbe4716153d631ba$exports(object, other, bitmask, customizer, equalFunc, stack) : $03b34759c76c9619$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $1005900946a463c3$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $1005900946a463c3$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $1005900946a463c3$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $6VvrE);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $6VvrE);
    return $9316a6dfb316fa3b$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$1005900946a463c3$exports = $1005900946a463c3$var$baseIsEqualDeep;





/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $1adaa373be41028c$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$edunD(value) && !$edunD(other)) return value !== value && other !== other;
    return $1005900946a463c3$exports(value, other, bitmask, customizer, $1adaa373be41028c$var$baseIsEqual, stack);
}
$1adaa373be41028c$exports = $1adaa373be41028c$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $9a947bf20769ef67$var$COMPARE_PARTIAL_FLAG = 1, $9a947bf20769ef67$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $9a947bf20769ef67$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $6VvrE;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $1adaa373be41028c$exports(srcValue, objValue, $9a947bf20769ef67$var$COMPARE_PARTIAL_FLAG | $9a947bf20769ef67$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$9a947bf20769ef67$exports = $9a947bf20769ef67$var$baseIsMatch;


var $4cec611677aeaf7f$exports = {};
var $02b5fee709fd0a08$exports = {};

var $Aea15 = parcelRequire("Aea15");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $02b5fee709fd0a08$var$isStrictComparable(value) {
    return value === value && !$Aea15(value);
}
$02b5fee709fd0a08$exports = $02b5fee709fd0a08$var$isStrictComparable;



var $5GZkf = parcelRequire("5GZkf");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $4cec611677aeaf7f$var$getMatchData(object) {
    var result = $5GZkf(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $02b5fee709fd0a08$exports(value)
        ];
    }
    return result;
}
$4cec611677aeaf7f$exports = $4cec611677aeaf7f$var$getMatchData;


var $6a6711d77544b1e4$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6a6711d77544b1e4$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$6a6711d77544b1e4$exports = $6a6711d77544b1e4$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $09fe28480a52eb13$var$baseMatches(source) {
    var matchData = $4cec611677aeaf7f$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $6a6711d77544b1e4$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $9a947bf20769ef67$exports(object, source, matchData);
    };
}
$09fe28480a52eb13$exports = $09fe28480a52eb13$var$baseMatches;


var $d9be5bd5ec8a529b$exports = {};

var $c0f64e3ad7f8d8dc$exports = {};
var $c467c04340f10993$exports = {};
var $e3111924d20c81d3$exports = {};



var $03b7c8a887c6079e$exports = {};



var $cdf5791054895070$exports = {};






/** `Object#toString` result references. */ var $cdf5791054895070$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $cdf5791054895070$var$isSymbol(value) {
    return typeof value == 'symbol' || $edunD(value) && $iEhAW(value) == $cdf5791054895070$var$symbolTag;
}
$cdf5791054895070$exports = $cdf5791054895070$var$isSymbol;


/** Used to match property names within property paths. */ var $03b7c8a887c6079e$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03b7c8a887c6079e$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03b7c8a887c6079e$var$isKey(value, object) {
    if ($gNbxK(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $cdf5791054895070$exports(value)) return true;
    return $03b7c8a887c6079e$var$reIsPlainProp.test(value) || !$03b7c8a887c6079e$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03b7c8a887c6079e$exports = $03b7c8a887c6079e$var$isKey;


var $0474859130e81290$exports = {};
var $8fef98f173000a5d$exports = {};
var $6edd88ef0ef0ad78$exports = {};



/** Error message constants. */ var $6edd88ef0ef0ad78$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $6edd88ef0ef0ad78$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($6edd88ef0ef0ad78$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($6edd88ef0ef0ad78$var$memoize.Cache || $8Qg0i);
    return memoized;
}
// Expose `MapCache`.
$6edd88ef0ef0ad78$var$memoize.Cache = $8Qg0i;
$6edd88ef0ef0ad78$exports = $6edd88ef0ef0ad78$var$memoize;


/** Used as the maximum memoize cache size. */ var $8fef98f173000a5d$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $8fef98f173000a5d$var$memoizeCapped(func) {
    var result = $6edd88ef0ef0ad78$exports(func, function(key) {
        if (cache.size === $8fef98f173000a5d$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$8fef98f173000a5d$exports = $8fef98f173000a5d$var$memoizeCapped;


/** Used to match property names within property paths. */ var $0474859130e81290$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $0474859130e81290$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $0474859130e81290$var$stringToPath = $8fef98f173000a5d$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($0474859130e81290$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($0474859130e81290$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$0474859130e81290$exports = $0474859130e81290$var$stringToPath;


var $f125624195536f6c$exports = {};
var $4d3cb83a11cfed86$exports = {};








/** Used as references for various `Number` constants. */ var $4d3cb83a11cfed86$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $4d3cb83a11cfed86$var$symbolProto = $hs6bh ? $hs6bh.prototype : undefined, $4d3cb83a11cfed86$var$symbolToString = $4d3cb83a11cfed86$var$symbolProto ? $4d3cb83a11cfed86$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $4d3cb83a11cfed86$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($gNbxK(value)) // Recursively convert values (susceptible to call stack limits).
    return $05df06851cd76d57$exports(value, $4d3cb83a11cfed86$var$baseToString) + '';
    if ($cdf5791054895070$exports(value)) return $4d3cb83a11cfed86$var$symbolToString ? $4d3cb83a11cfed86$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$4d3cb83a11cfed86$var$INFINITY ? '-0' : result;
}
$4d3cb83a11cfed86$exports = $4d3cb83a11cfed86$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f125624195536f6c$var$toString(value) {
    return value == null ? '' : $4d3cb83a11cfed86$exports(value);
}
$f125624195536f6c$exports = $f125624195536f6c$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $e3111924d20c81d3$var$castPath(value, object) {
    if ($gNbxK(value)) return value;
    return $03b7c8a887c6079e$exports(value, object) ? [
        value
    ] : $0474859130e81290$exports($f125624195536f6c$exports(value));
}
$e3111924d20c81d3$exports = $e3111924d20c81d3$var$castPath;


var $ffff23b4c8a71364$exports = {};

/** Used as references for various `Number` constants. */ var $ffff23b4c8a71364$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $ffff23b4c8a71364$var$toKey(value) {
    if (typeof value == 'string' || $cdf5791054895070$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$ffff23b4c8a71364$var$INFINITY ? '-0' : result;
}
$ffff23b4c8a71364$exports = $ffff23b4c8a71364$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $c467c04340f10993$var$baseGet(object, path) {
    path = $e3111924d20c81d3$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$ffff23b4c8a71364$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$c467c04340f10993$exports = $c467c04340f10993$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $c0f64e3ad7f8d8dc$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $c467c04340f10993$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$c0f64e3ad7f8d8dc$exports = $c0f64e3ad7f8d8dc$var$get;


var $d8fd6262a215d7ca$exports = {};
var $ee713692a17f21ad$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ee713692a17f21ad$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$ee713692a17f21ad$exports = $ee713692a17f21ad$var$baseHasIn;


var $a6c05feea10786d2$exports = {};


var $7zile = parcelRequire("7zile");





var $fpQin = parcelRequire("fpQin");


var $5SKmw = parcelRequire("5SKmw");


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $a6c05feea10786d2$var$hasPath(object, path, hasFunc) {
    path = $e3111924d20c81d3$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $ffff23b4c8a71364$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $5SKmw(length) && $fpQin(key, length) && ($gNbxK(object) || $7zile(object));
}
$a6c05feea10786d2$exports = $a6c05feea10786d2$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $d8fd6262a215d7ca$var$hasIn(object, path) {
    return object != null && $a6c05feea10786d2$exports(object, path, $ee713692a17f21ad$exports);
}
$d8fd6262a215d7ca$exports = $d8fd6262a215d7ca$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d9be5bd5ec8a529b$var$COMPARE_PARTIAL_FLAG = 1, $d9be5bd5ec8a529b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d9be5bd5ec8a529b$var$baseMatchesProperty(path, srcValue) {
    if ($03b7c8a887c6079e$exports(path) && $02b5fee709fd0a08$exports(srcValue)) return $6a6711d77544b1e4$exports($ffff23b4c8a71364$exports(path), srcValue);
    return function(object) {
        var objValue = $c0f64e3ad7f8d8dc$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $d8fd6262a215d7ca$exports(object, path) : $1adaa373be41028c$exports(srcValue, objValue, $d9be5bd5ec8a529b$var$COMPARE_PARTIAL_FLAG | $d9be5bd5ec8a529b$var$COMPARE_UNORDERED_FLAG);
    };
}
$d9be5bd5ec8a529b$exports = $d9be5bd5ec8a529b$var$baseMatchesProperty;



var $iz2RW = parcelRequire("iz2RW");




var $fc270896871f58aa$exports = {};
var $0bf6431e0ac4c558$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $0bf6431e0ac4c558$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$0bf6431e0ac4c558$exports = $0bf6431e0ac4c558$var$baseProperty;


var $2638677e39d741e5$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $2638677e39d741e5$var$basePropertyDeep(path) {
    return function(object) {
        return $c467c04340f10993$exports(object, path);
    };
}
$2638677e39d741e5$exports = $2638677e39d741e5$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $fc270896871f58aa$var$property(path) {
    return $03b7c8a887c6079e$exports(path) ? $0bf6431e0ac4c558$exports($ffff23b4c8a71364$exports(path)) : $2638677e39d741e5$exports(path);
}
$fc270896871f58aa$exports = $fc270896871f58aa$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $56fd83aafaf9e538$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $iz2RW;
    if (typeof value == 'object') return $gNbxK(value) ? $d9be5bd5ec8a529b$exports(value[0], value[1]) : $09fe28480a52eb13$exports(value);
    return $fc270896871f58aa$exports(value);
}
$56fd83aafaf9e538$exports = $56fd83aafaf9e538$var$baseIteratee;


var $68c63cace3ae4935$exports = {};
var $a67a8c09f9a8b55f$exports = {};

var $bdhSS = parcelRequire("bdhSS");

var $9797e01841306ca3$exports = {};

var $c5hrb = parcelRequire("c5hrb");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $9797e01841306ca3$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$c5hrb(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$9797e01841306ca3$exports = $9797e01841306ca3$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $a67a8c09f9a8b55f$var$baseEach = $9797e01841306ca3$exports($bdhSS);
$a67a8c09f9a8b55f$exports = $a67a8c09f9a8b55f$var$baseEach;





/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $68c63cace3ae4935$var$baseMap(collection, iteratee) {
    var index = -1, result = $c5hrb(collection) ? Array(collection.length) : [];
    $a67a8c09f9a8b55f$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$68c63cace3ae4935$exports = $68c63cace3ae4935$var$baseMap;





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $f0a313b3ebda1dc4$var$map(collection, iteratee) {
    var func = $gNbxK(collection) ? $05df06851cd76d57$exports : $68c63cace3ae4935$exports;
    return func(collection, $56fd83aafaf9e538$exports(iteratee, 3));
}
$f0a313b3ebda1dc4$exports = $f0a313b3ebda1dc4$var$map;


var $d30b55f8d3dec7f8$var$_map3 = $d30b55f8d3dec7f8$var$_interopRequireDefault($f0a313b3ebda1dc4$exports);
function $d30b55f8d3dec7f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d30b55f8d3dec7f8$var$flattenNames = module.exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $d30b55f8d3dec7f8$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $d30b55f8d3dec7f8$var$_isPlainObject3.default)(thing)) (0, $d30b55f8d3dec7f8$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + '-' + value);
        });
        else if ((0, $d30b55f8d3dec7f8$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
module.exports.default = $d30b55f8d3dec7f8$var$flattenNames;

});

parcelRegister("gq4T6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeClasses = undefined;

var $7EnRN = parcelRequire("7EnRN");

var $bf42dda966061f14$var$_forOwn3 = $bf42dda966061f14$var$_interopRequireDefault($7EnRN);
var $75d5fbfc8a666500$exports = {};
var $2e01d5f6baefe377$exports = {};

var $6VvrE = parcelRequire("6VvrE");

var $109dae1ac8fd298a$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $109dae1ac8fd298a$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$109dae1ac8fd298a$exports = $109dae1ac8fd298a$var$arrayEach;


var $aae0e6bf77804298$exports = {};
var $4cf14abc335dafc7$exports = {};
var $96c0f2784b55e6ea$exports = {};

var $i3LrG = parcelRequire("i3LrG");

var $96c0f2784b55e6ea$var$defineProperty = function() {
    try {
        var func = $i3LrG(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$96c0f2784b55e6ea$exports = $96c0f2784b55e6ea$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $4cf14abc335dafc7$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $96c0f2784b55e6ea$exports) $96c0f2784b55e6ea$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$4cf14abc335dafc7$exports = $4cf14abc335dafc7$var$baseAssignValue;



var $4ESv6 = parcelRequire("4ESv6");

/** Used for built-in method references. */ var $aae0e6bf77804298$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $aae0e6bf77804298$var$hasOwnProperty = $aae0e6bf77804298$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $aae0e6bf77804298$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($aae0e6bf77804298$var$hasOwnProperty.call(object, key) && $4ESv6(objValue, value)) || value === undefined && !(key in object)) $4cf14abc335dafc7$exports(object, key, value);
}
$aae0e6bf77804298$exports = $aae0e6bf77804298$var$assignValue;


var $94b580edb7bdd619$exports = {};
var $13a529cf0df9cd30$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $13a529cf0df9cd30$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $4cf14abc335dafc7$exports(object, key, newValue);
        else $aae0e6bf77804298$exports(object, key, newValue);
    }
    return object;
}
$13a529cf0df9cd30$exports = $13a529cf0df9cd30$var$copyObject;



var $5GZkf = parcelRequire("5GZkf");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $94b580edb7bdd619$var$baseAssign(object, source) {
    return object && $13a529cf0df9cd30$exports(source, $5GZkf(source), object);
}
$94b580edb7bdd619$exports = $94b580edb7bdd619$var$baseAssign;


var $f3883a00ddddc510$exports = {};

var $35576a314896de4c$exports = {};

var $5oqbR = parcelRequire("5oqbR");

var $cc0d537fbd1a2fc1$exports = {};

var $Aea15 = parcelRequire("Aea15");


var $3Wi7n = parcelRequire("3Wi7n");

var $ccfde9d532752cb2$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ccfde9d532752cb2$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$ccfde9d532752cb2$exports = $ccfde9d532752cb2$var$nativeKeysIn;


/** Used for built-in method references. */ var $cc0d537fbd1a2fc1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cc0d537fbd1a2fc1$var$hasOwnProperty = $cc0d537fbd1a2fc1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $cc0d537fbd1a2fc1$var$baseKeysIn(object) {
    if (!$Aea15(object)) return $ccfde9d532752cb2$exports(object);
    var isProto = $3Wi7n(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$cc0d537fbd1a2fc1$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$cc0d537fbd1a2fc1$exports = $cc0d537fbd1a2fc1$var$baseKeysIn;



var $c5hrb = parcelRequire("c5hrb");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $35576a314896de4c$var$keysIn(object) {
    return $c5hrb(object) ? $5oqbR(object, true) : $cc0d537fbd1a2fc1$exports(object);
}
$35576a314896de4c$exports = $35576a314896de4c$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $f3883a00ddddc510$var$baseAssignIn(object, source) {
    return object && $13a529cf0df9cd30$exports(source, $35576a314896de4c$exports(source), object);
}
$f3883a00ddddc510$exports = $f3883a00ddddc510$var$baseAssignIn;



var $fytgK = parcelRequire("fytgK");

var $d4334cd7614c746f$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $d4334cd7614c746f$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$d4334cd7614c746f$exports = $d4334cd7614c746f$var$copyArray;


var $49c7a9fbdd9030d4$exports = {};


var $cogiS = parcelRequire("cogiS");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $49c7a9fbdd9030d4$var$copySymbols(source, object) {
    return $13a529cf0df9cd30$exports(source, $cogiS(source), object);
}
$49c7a9fbdd9030d4$exports = $49c7a9fbdd9030d4$var$copySymbols;


var $34d4996b0b63618f$exports = {};

var $7993567b97f9e195$exports = {};

var $3nRKd = parcelRequire("3nRKd");


var $gxllf = parcelRequire("gxllf");





var $9XpeH = parcelRequire("9XpeH");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $7993567b97f9e195$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $7993567b97f9e195$var$getSymbolsIn = !$7993567b97f9e195$var$nativeGetSymbols ? $9XpeH : function(object) {
    var result = [];
    while(object){
        $3nRKd(result, $cogiS(object));
        object = $gxllf(object);
    }
    return result;
};
$7993567b97f9e195$exports = $7993567b97f9e195$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $34d4996b0b63618f$var$copySymbolsIn(source, object) {
    return $13a529cf0df9cd30$exports(source, $7993567b97f9e195$exports(source), object);
}
$34d4996b0b63618f$exports = $34d4996b0b63618f$var$copySymbolsIn;



var $6YdgV = parcelRequire("6YdgV");

var $5d7923de088ea18a$exports = {};

var $2NmsS = parcelRequire("2NmsS");



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5d7923de088ea18a$var$getAllKeysIn(object) {
    return $2NmsS(object, $35576a314896de4c$exports, $7993567b97f9e195$exports);
}
$5d7923de088ea18a$exports = $5d7923de088ea18a$var$getAllKeysIn;



var $49wbE = parcelRequire("49wbE");

var $7c88fef9eae4edd2$exports = {};
/** Used for built-in method references. */ var $7c88fef9eae4edd2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7c88fef9eae4edd2$var$hasOwnProperty = $7c88fef9eae4edd2$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7c88fef9eae4edd2$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $7c88fef9eae4edd2$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$7c88fef9eae4edd2$exports = $7c88fef9eae4edd2$var$initCloneArray;


var $49dd6b2b9d906324$exports = {};
var $2c4b93b136b581c1$exports = {};

var $hxBlg = parcelRequire("hxBlg");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $2c4b93b136b581c1$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $hxBlg(result).set(new $hxBlg(arrayBuffer));
    return result;
}
$2c4b93b136b581c1$exports = $2c4b93b136b581c1$var$cloneArrayBuffer;


var $14cced5a0d95c82e$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $14cced5a0d95c82e$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $2c4b93b136b581c1$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$14cced5a0d95c82e$exports = $14cced5a0d95c82e$var$cloneDataView;


var $048726ee02410471$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $048726ee02410471$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $048726ee02410471$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $048726ee02410471$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$048726ee02410471$exports = $048726ee02410471$var$cloneRegExp;


var $6d758d8a5435b10b$exports = {};

var $hs6bh = parcelRequire("hs6bh");

/** Used to convert symbols to primitives and strings. */ var $6d758d8a5435b10b$var$symbolProto = $hs6bh ? $hs6bh.prototype : undefined, $6d758d8a5435b10b$var$symbolValueOf = $6d758d8a5435b10b$var$symbolProto ? $6d758d8a5435b10b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $6d758d8a5435b10b$var$cloneSymbol(symbol) {
    return $6d758d8a5435b10b$var$symbolValueOf ? Object($6d758d8a5435b10b$var$symbolValueOf.call(symbol)) : {};
}
$6d758d8a5435b10b$exports = $6d758d8a5435b10b$var$cloneSymbol;


var $e57614389922017e$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $e57614389922017e$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $2c4b93b136b581c1$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$e57614389922017e$exports = $e57614389922017e$var$cloneTypedArray;


/** `Object#toString` result references. */ var $49dd6b2b9d906324$var$boolTag = '[object Boolean]', $49dd6b2b9d906324$var$dateTag = '[object Date]', $49dd6b2b9d906324$var$mapTag = '[object Map]', $49dd6b2b9d906324$var$numberTag = '[object Number]', $49dd6b2b9d906324$var$regexpTag = '[object RegExp]', $49dd6b2b9d906324$var$setTag = '[object Set]', $49dd6b2b9d906324$var$stringTag = '[object String]', $49dd6b2b9d906324$var$symbolTag = '[object Symbol]';
var $49dd6b2b9d906324$var$arrayBufferTag = '[object ArrayBuffer]', $49dd6b2b9d906324$var$dataViewTag = '[object DataView]', $49dd6b2b9d906324$var$float32Tag = '[object Float32Array]', $49dd6b2b9d906324$var$float64Tag = '[object Float64Array]', $49dd6b2b9d906324$var$int8Tag = '[object Int8Array]', $49dd6b2b9d906324$var$int16Tag = '[object Int16Array]', $49dd6b2b9d906324$var$int32Tag = '[object Int32Array]', $49dd6b2b9d906324$var$uint8Tag = '[object Uint8Array]', $49dd6b2b9d906324$var$uint8ClampedTag = '[object Uint8ClampedArray]', $49dd6b2b9d906324$var$uint16Tag = '[object Uint16Array]', $49dd6b2b9d906324$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $49dd6b2b9d906324$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $49dd6b2b9d906324$var$arrayBufferTag:
            return $2c4b93b136b581c1$exports(object);
        case $49dd6b2b9d906324$var$boolTag:
        case $49dd6b2b9d906324$var$dateTag:
            return new Ctor(+object);
        case $49dd6b2b9d906324$var$dataViewTag:
            return $14cced5a0d95c82e$exports(object, isDeep);
        case $49dd6b2b9d906324$var$float32Tag:
        case $49dd6b2b9d906324$var$float64Tag:
        case $49dd6b2b9d906324$var$int8Tag:
        case $49dd6b2b9d906324$var$int16Tag:
        case $49dd6b2b9d906324$var$int32Tag:
        case $49dd6b2b9d906324$var$uint8Tag:
        case $49dd6b2b9d906324$var$uint8ClampedTag:
        case $49dd6b2b9d906324$var$uint16Tag:
        case $49dd6b2b9d906324$var$uint32Tag:
            return $e57614389922017e$exports(object, isDeep);
        case $49dd6b2b9d906324$var$mapTag:
            return new Ctor;
        case $49dd6b2b9d906324$var$numberTag:
        case $49dd6b2b9d906324$var$stringTag:
            return new Ctor(object);
        case $49dd6b2b9d906324$var$regexpTag:
            return $048726ee02410471$exports(object);
        case $49dd6b2b9d906324$var$setTag:
            return new Ctor;
        case $49dd6b2b9d906324$var$symbolTag:
            return $6d758d8a5435b10b$exports(object);
    }
}
$49dd6b2b9d906324$exports = $49dd6b2b9d906324$var$initCloneByTag;


var $72e7f7c0a3163f3a$exports = {};
var $adf05534d4da8281$exports = {};



/** Built-in value references. */ var $adf05534d4da8281$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $adf05534d4da8281$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$Aea15(proto)) return {};
        if ($adf05534d4da8281$var$objectCreate) return $adf05534d4da8281$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$adf05534d4da8281$exports = $adf05534d4da8281$var$baseCreate;








/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $72e7f7c0a3163f3a$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$3Wi7n(object) ? $adf05534d4da8281$exports($gxllf(object)) : {};
}
$72e7f7c0a3163f3a$exports = $72e7f7c0a3163f3a$var$initCloneObject;



var $gNbxK = parcelRequire("gNbxK");


var $9GzMu = parcelRequire("9GzMu");

var $a60e3066065de300$exports = {};
var $9a58c1add4c73f8e$exports = {};




var $edunD = parcelRequire("edunD");

/** `Object#toString` result references. */ var $9a58c1add4c73f8e$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9a58c1add4c73f8e$var$baseIsMap(value) {
    return $edunD(value) && $49wbE(value) == $9a58c1add4c73f8e$var$mapTag;
}
$9a58c1add4c73f8e$exports = $9a58c1add4c73f8e$var$baseIsMap;



var $2gYrW = parcelRequire("2gYrW");


var $i0Qa5 = parcelRequire("i0Qa5");

/* Node.js helper references. */ var $a60e3066065de300$var$nodeIsMap = $i0Qa5 && $i0Qa5.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $a60e3066065de300$var$isMap = $a60e3066065de300$var$nodeIsMap ? $2gYrW($a60e3066065de300$var$nodeIsMap) : $9a58c1add4c73f8e$exports;
$a60e3066065de300$exports = $a60e3066065de300$var$isMap;





var $3cfa5d7ba22d03c5$exports = {};
var $312b69c7edaf65e4$exports = {};






/** `Object#toString` result references. */ var $312b69c7edaf65e4$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $312b69c7edaf65e4$var$baseIsSet(value) {
    return $edunD(value) && $49wbE(value) == $312b69c7edaf65e4$var$setTag;
}
$312b69c7edaf65e4$exports = $312b69c7edaf65e4$var$baseIsSet;








/* Node.js helper references. */ var $3cfa5d7ba22d03c5$var$nodeIsSet = $i0Qa5 && $i0Qa5.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $3cfa5d7ba22d03c5$var$isSet = $3cfa5d7ba22d03c5$var$nodeIsSet ? $2gYrW($3cfa5d7ba22d03c5$var$nodeIsSet) : $312b69c7edaf65e4$exports;
$3cfa5d7ba22d03c5$exports = $3cfa5d7ba22d03c5$var$isSet;






/** Used to compose bitmasks for cloning. */ var $2e01d5f6baefe377$var$CLONE_DEEP_FLAG = 1, $2e01d5f6baefe377$var$CLONE_FLAT_FLAG = 2, $2e01d5f6baefe377$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $2e01d5f6baefe377$var$argsTag = '[object Arguments]', $2e01d5f6baefe377$var$arrayTag = '[object Array]', $2e01d5f6baefe377$var$boolTag = '[object Boolean]', $2e01d5f6baefe377$var$dateTag = '[object Date]', $2e01d5f6baefe377$var$errorTag = '[object Error]', $2e01d5f6baefe377$var$funcTag = '[object Function]', $2e01d5f6baefe377$var$genTag = '[object GeneratorFunction]', $2e01d5f6baefe377$var$mapTag = '[object Map]', $2e01d5f6baefe377$var$numberTag = '[object Number]', $2e01d5f6baefe377$var$objectTag = '[object Object]', $2e01d5f6baefe377$var$regexpTag = '[object RegExp]', $2e01d5f6baefe377$var$setTag = '[object Set]', $2e01d5f6baefe377$var$stringTag = '[object String]', $2e01d5f6baefe377$var$symbolTag = '[object Symbol]', $2e01d5f6baefe377$var$weakMapTag = '[object WeakMap]';
var $2e01d5f6baefe377$var$arrayBufferTag = '[object ArrayBuffer]', $2e01d5f6baefe377$var$dataViewTag = '[object DataView]', $2e01d5f6baefe377$var$float32Tag = '[object Float32Array]', $2e01d5f6baefe377$var$float64Tag = '[object Float64Array]', $2e01d5f6baefe377$var$int8Tag = '[object Int8Array]', $2e01d5f6baefe377$var$int16Tag = '[object Int16Array]', $2e01d5f6baefe377$var$int32Tag = '[object Int32Array]', $2e01d5f6baefe377$var$uint8Tag = '[object Uint8Array]', $2e01d5f6baefe377$var$uint8ClampedTag = '[object Uint8ClampedArray]', $2e01d5f6baefe377$var$uint16Tag = '[object Uint16Array]', $2e01d5f6baefe377$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $2e01d5f6baefe377$var$cloneableTags = {};
$2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$argsTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$arrayTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$arrayBufferTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$dataViewTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$boolTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$dateTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$float32Tag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$float64Tag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$int8Tag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$int16Tag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$int32Tag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$mapTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$numberTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$objectTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$regexpTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$setTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$stringTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$symbolTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$uint8Tag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$uint8ClampedTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$uint16Tag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$uint32Tag] = true;
$2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$errorTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$funcTag] = $2e01d5f6baefe377$var$cloneableTags[$2e01d5f6baefe377$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $2e01d5f6baefe377$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $2e01d5f6baefe377$var$CLONE_DEEP_FLAG, isFlat = bitmask & $2e01d5f6baefe377$var$CLONE_FLAT_FLAG, isFull = bitmask & $2e01d5f6baefe377$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$Aea15(value)) return value;
    var isArr = $gNbxK(value);
    if (isArr) {
        result = $7c88fef9eae4edd2$exports(value);
        if (!isDeep) return $d4334cd7614c746f$exports(value, result);
    } else {
        var tag = $49wbE(value), isFunc = tag == $2e01d5f6baefe377$var$funcTag || tag == $2e01d5f6baefe377$var$genTag;
        if ($9GzMu(value)) return $fytgK(value, isDeep);
        if (tag == $2e01d5f6baefe377$var$objectTag || tag == $2e01d5f6baefe377$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $72e7f7c0a3163f3a$exports(value);
            if (!isDeep) return isFlat ? $34d4996b0b63618f$exports(value, $f3883a00ddddc510$exports(result, value)) : $49c7a9fbdd9030d4$exports(value, $94b580edb7bdd619$exports(result, value));
        } else {
            if (!$2e01d5f6baefe377$var$cloneableTags[tag]) return object ? value : {};
            result = $49dd6b2b9d906324$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $6VvrE);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($3cfa5d7ba22d03c5$exports(value)) value.forEach(function(subValue) {
        result.add($2e01d5f6baefe377$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($a60e3066065de300$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $2e01d5f6baefe377$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $5d7923de088ea18a$exports : $6YdgV : isFlat ? $35576a314896de4c$exports : $5GZkf;
    var props = isArr ? undefined : keysFunc(value);
    $109dae1ac8fd298a$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $aae0e6bf77804298$exports(result, key, $2e01d5f6baefe377$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$2e01d5f6baefe377$exports = $2e01d5f6baefe377$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $75d5fbfc8a666500$var$CLONE_DEEP_FLAG = 1, $75d5fbfc8a666500$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $75d5fbfc8a666500$var$cloneDeep(value) {
    return $2e01d5f6baefe377$exports(value, $75d5fbfc8a666500$var$CLONE_DEEP_FLAG | $75d5fbfc8a666500$var$CLONE_SYMBOLS_FLAG);
}
$75d5fbfc8a666500$exports = $75d5fbfc8a666500$var$cloneDeep;


var $bf42dda966061f14$var$_cloneDeep3 = $bf42dda966061f14$var$_interopRequireDefault($75d5fbfc8a666500$exports);
var $bf42dda966061f14$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $bf42dda966061f14$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bf42dda966061f14$var$mergeClasses = module.exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $bf42dda966061f14$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $bf42dda966061f14$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $bf42dda966061f14$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
module.exports.default = $bf42dda966061f14$var$mergeClasses;

});

parcelRegister("idbiG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.autoprefix = undefined;

var $7EnRN = parcelRequire("7EnRN");

var $d42234e1bc9fa95e$var$_forOwn3 = $d42234e1bc9fa95e$var$_interopRequireDefault($7EnRN);
var $d42234e1bc9fa95e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $d42234e1bc9fa95e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d42234e1bc9fa95e$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(' ');
        return {
            position: 'absolute',
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            'extend': name
        };
    }
};
var $d42234e1bc9fa95e$var$autoprefix = module.exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $d42234e1bc9fa95e$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $d42234e1bc9fa95e$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $d42234e1bc9fa95e$var$transforms[key];
            if (transform) expanded = $d42234e1bc9fa95e$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
module.exports.default = $d42234e1bc9fa95e$var$autoprefix;

});

parcelRegister("eAxCt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hover = undefined;
var $a9ee81a38fea37ee$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $cozmU = parcelRequire("cozmU");

var $a9ee81a38fea37ee$var$_react2 = $a9ee81a38fea37ee$var$_interopRequireDefault($cozmU);
function $a9ee81a38fea37ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a9ee81a38fea37ee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a9ee81a38fea37ee$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a9ee81a38fea37ee$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a9ee81a38fea37ee$var$hover = module.exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $a9ee81a38fea37ee$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $a9ee81a38fea37ee$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $a9ee81a38fea37ee$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $a9ee81a38fea37ee$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $a9ee81a38fea37ee$var$_react2.default.createElement(Component, $a9ee81a38fea37ee$var$_extends({}, _this.props, _this.state)));
            }, _temp), $a9ee81a38fea37ee$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($a9ee81a38fea37ee$var$_react2.default.Component);
};
module.exports.default = $a9ee81a38fea37ee$var$hover;

});

parcelRegister("duht2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.active = undefined;
var $9d1ba060af7c9a8b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $cozmU = parcelRequire("cozmU");

var $9d1ba060af7c9a8b$var$_react2 = $9d1ba060af7c9a8b$var$_interopRequireDefault($cozmU);
function $9d1ba060af7c9a8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9d1ba060af7c9a8b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9d1ba060af7c9a8b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9d1ba060af7c9a8b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9d1ba060af7c9a8b$var$active = module.exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $9d1ba060af7c9a8b$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $9d1ba060af7c9a8b$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $9d1ba060af7c9a8b$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $9d1ba060af7c9a8b$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $9d1ba060af7c9a8b$var$_react2.default.createElement(Component, $9d1ba060af7c9a8b$var$_extends({}, _this.props, _this.state)));
            }, _temp), $9d1ba060af7c9a8b$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($9d1ba060af7c9a8b$var$_react2.default.Component);
};
module.exports.default = $9d1ba060af7c9a8b$var$active;

});

parcelRegister("g6e9Y", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0306535dd1cbc9ab$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp('first-child');
    i === length - 1 && setProp('last-child');
    (i === 0 || i % 2 === 0) && setProp('even');
    Math.abs(i % 2) === 1 && setProp('odd');
    setProp('nth-child', i);
    return props;
};
module.exports.default = $0306535dd1cbc9ab$var$loopable;

});

parcelRegister("8nkzn", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $61906d6417d9a1f5$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $61906d6417d9a1f5$var$createBaseFor;

});

parcelRegister("cXEVT", function(module, exports) {

var $frRyo = parcelRequire("frRyo");


var $7Zt5w = parcelRequire("7Zt5w");

/** `Object#toString` result references. */ var $96fabf220a791158$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $96fabf220a791158$var$baseIsArguments(value) {
    return $7Zt5w(value) && $frRyo(value) == $96fabf220a791158$var$argsTag;
}
module.exports = $96fabf220a791158$var$baseIsArguments;

});

parcelRegister("lJsSi", function(module, exports) {
/** Used as references for various `Number` constants. */ var $fd2432dac328514a$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $fd2432dac328514a$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $fd2432dac328514a$var$MAX_SAFE_INTEGER;
}
module.exports = $fd2432dac328514a$var$isLength;

});

parcelRegister("2F8DI", function(module, exports) {

var $7ueoP = parcelRequire("7ueoP");

/** Built-in value references. */ var $1f061cc459584fb1$var$Symbol = $7ueoP.Symbol;
module.exports = $1f061cc459584fb1$var$Symbol;

});

parcelRegister("9HwiP", function(module, exports) {

var $2F8DI = parcelRequire("2F8DI");

/** Used for built-in method references. */ var $71012fdee1d01055$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $71012fdee1d01055$var$hasOwnProperty = $71012fdee1d01055$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $71012fdee1d01055$var$nativeObjectToString = $71012fdee1d01055$var$objectProto.toString;
/** Built-in value references. */ var $71012fdee1d01055$var$symToStringTag = $2F8DI ? $2F8DI.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $71012fdee1d01055$var$getRawTag(value) {
    var isOwn = $71012fdee1d01055$var$hasOwnProperty.call(value, $71012fdee1d01055$var$symToStringTag), tag = value[$71012fdee1d01055$var$symToStringTag];
    try {
        value[$71012fdee1d01055$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $71012fdee1d01055$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$71012fdee1d01055$var$symToStringTag] = tag;
        else delete value[$71012fdee1d01055$var$symToStringTag];
    }
    return result;
}
module.exports = $71012fdee1d01055$var$getRawTag;

});

parcelRegister("kVSju", function(module, exports) {
/** Used for built-in method references. */ var $f3d3430873dc3b42$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f3d3430873dc3b42$var$nativeObjectToString = $f3d3430873dc3b42$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f3d3430873dc3b42$var$objectToString(value) {
    return $f3d3430873dc3b42$var$nativeObjectToString.call(value);
}
module.exports = $f3d3430873dc3b42$var$objectToString;

});

parcelRegister("krum2", function(module, exports) {

var $frRyo = parcelRequire("frRyo");


var $lJsSi = parcelRequire("lJsSi");


var $7Zt5w = parcelRequire("7Zt5w");

/** `Object#toString` result references. */ var $ee1de005ebab1d3f$var$argsTag = '[object Arguments]', $ee1de005ebab1d3f$var$arrayTag = '[object Array]', $ee1de005ebab1d3f$var$boolTag = '[object Boolean]', $ee1de005ebab1d3f$var$dateTag = '[object Date]', $ee1de005ebab1d3f$var$errorTag = '[object Error]', $ee1de005ebab1d3f$var$funcTag = '[object Function]', $ee1de005ebab1d3f$var$mapTag = '[object Map]', $ee1de005ebab1d3f$var$numberTag = '[object Number]', $ee1de005ebab1d3f$var$objectTag = '[object Object]', $ee1de005ebab1d3f$var$regexpTag = '[object RegExp]', $ee1de005ebab1d3f$var$setTag = '[object Set]', $ee1de005ebab1d3f$var$stringTag = '[object String]', $ee1de005ebab1d3f$var$weakMapTag = '[object WeakMap]';
var $ee1de005ebab1d3f$var$arrayBufferTag = '[object ArrayBuffer]', $ee1de005ebab1d3f$var$dataViewTag = '[object DataView]', $ee1de005ebab1d3f$var$float32Tag = '[object Float32Array]', $ee1de005ebab1d3f$var$float64Tag = '[object Float64Array]', $ee1de005ebab1d3f$var$int8Tag = '[object Int8Array]', $ee1de005ebab1d3f$var$int16Tag = '[object Int16Array]', $ee1de005ebab1d3f$var$int32Tag = '[object Int32Array]', $ee1de005ebab1d3f$var$uint8Tag = '[object Uint8Array]', $ee1de005ebab1d3f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ee1de005ebab1d3f$var$uint16Tag = '[object Uint16Array]', $ee1de005ebab1d3f$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $ee1de005ebab1d3f$var$typedArrayTags = {};
$ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$float32Tag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$float64Tag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$int8Tag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$int16Tag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$int32Tag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$uint8Tag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$uint8ClampedTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$uint16Tag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$uint32Tag] = true;
$ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$argsTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$arrayTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$arrayBufferTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$boolTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$dataViewTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$dateTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$errorTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$funcTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$mapTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$numberTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$objectTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$regexpTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$setTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$stringTag] = $ee1de005ebab1d3f$var$typedArrayTags[$ee1de005ebab1d3f$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $ee1de005ebab1d3f$var$baseIsTypedArray(value) {
    return $7Zt5w(value) && $lJsSi(value.length) && !!$ee1de005ebab1d3f$var$typedArrayTags[$frRyo(value)];
}
module.exports = $ee1de005ebab1d3f$var$baseIsTypedArray;

});

parcelRegister("2DOkj", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1ec6431ebd4dc7a1$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $1ec6431ebd4dc7a1$var$baseUnary;

});

parcelRegister("5aLoQ", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $3c42a78665cb8595$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $3c42a78665cb8595$var$baseTimes;

});

parcelRegister("41kYl", function(module, exports) {

var $7ueoP = parcelRequire("7ueoP");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $2ed78611d4c41cab$var$now = function() {
    return $7ueoP.Date.now();
};
module.exports = $2ed78611d4c41cab$var$now;

});

parcelRegister("cGID5", function(module, exports) {

var $8WwLz = parcelRequire("8WwLz");


var $b6Iwx = parcelRequire("b6Iwx");


var $40vup = parcelRequire("40vup");

/** Used as references for various `Number` constants. */ var $93cc06c34e65ec83$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $93cc06c34e65ec83$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $93cc06c34e65ec83$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $93cc06c34e65ec83$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $93cc06c34e65ec83$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $93cc06c34e65ec83$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($40vup(value)) return $93cc06c34e65ec83$var$NAN;
    if ($b6Iwx(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $b6Iwx(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $8WwLz(value);
    var isBinary = $93cc06c34e65ec83$var$reIsBinary.test(value);
    return isBinary || $93cc06c34e65ec83$var$reIsOctal.test(value) ? $93cc06c34e65ec83$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $93cc06c34e65ec83$var$reIsBadHex.test(value) ? $93cc06c34e65ec83$var$NAN : +value;
}
module.exports = $93cc06c34e65ec83$var$toNumber;

});

parcelRegister("gna5h", function(module, exports) {
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});

});

parcelRegister("7EnRN", function(module, exports) {

var $bdhSS = parcelRequire("bdhSS");


var $Ru7al = parcelRequire("Ru7al");

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $591ec84236331ca9$var$forOwn(object, iteratee) {
    return object && $bdhSS(object, $Ru7al(iteratee));
}
module.exports = $591ec84236331ca9$var$forOwn;

});

parcelRegister("6VvrE", function(module, exports) {

var $aqDYW = parcelRequire("aqDYW");


var $fqjF4 = parcelRequire("fqjF4");


var $fJQdQ = parcelRequire("fJQdQ");


var $dvufA = parcelRequire("dvufA");


var $cy9vx = parcelRequire("cy9vx");


var $haegR = parcelRequire("haegR");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $50b07547551c1256$var$Stack(entries) {
    var data = this.__data__ = new $aqDYW(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$50b07547551c1256$var$Stack.prototype.clear = $fqjF4;
$50b07547551c1256$var$Stack.prototype['delete'] = $fJQdQ;
$50b07547551c1256$var$Stack.prototype.get = $dvufA;
$50b07547551c1256$var$Stack.prototype.has = $cy9vx;
$50b07547551c1256$var$Stack.prototype.set = $haegR;
module.exports = $50b07547551c1256$var$Stack;

});

parcelRegister("i3LrG", function(module, exports) {

var $dI8t1 = parcelRequire("dI8t1");


var $bJfEO = parcelRequire("bJfEO");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $d25d4f82895d311f$var$getNative(object, key) {
    var value = $bJfEO(object, key);
    return $dI8t1(value) ? value : undefined;
}
module.exports = $d25d4f82895d311f$var$getNative;

});

parcelRegister("4ESv6", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $36452c888e55182e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $36452c888e55182e$var$eq;

});

parcelRegister("5GZkf", function(module, exports) {

var $5oqbR = parcelRequire("5oqbR");


var $kGMAj = parcelRequire("kGMAj");


var $c5hrb = parcelRequire("c5hrb");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $425071f3df0712ba$var$keys(object) {
    return $c5hrb(object) ? $5oqbR(object) : $kGMAj(object);
}
module.exports = $425071f3df0712ba$var$keys;

});

parcelRegister("5oqbR", function(module, exports) {

var $6JxL2 = parcelRequire("6JxL2");


var $7zile = parcelRequire("7zile");


var $gNbxK = parcelRequire("gNbxK");


var $9GzMu = parcelRequire("9GzMu");


var $fpQin = parcelRequire("fpQin");


var $2vKbG = parcelRequire("2vKbG");

/** Used for built-in method references. */ var $3ed38280f25e25c1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3ed38280f25e25c1$var$hasOwnProperty = $3ed38280f25e25c1$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $3ed38280f25e25c1$var$arrayLikeKeys(value, inherited) {
    var isArr = $gNbxK(value), isArg = !isArr && $7zile(value), isBuff = !isArr && !isArg && $9GzMu(value), isType = !isArr && !isArg && !isBuff && $2vKbG(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $6JxL2(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $3ed38280f25e25c1$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $fpQin(key, length)))) result.push(key);
    return result;
}
module.exports = $3ed38280f25e25c1$var$arrayLikeKeys;

});

parcelRegister("Aea15", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $06ce58e627eb453e$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $06ce58e627eb453e$var$isObject;

});

parcelRegister("3Wi7n", function(module, exports) {
/** Used for built-in method references. */ var $2de4d7b609de4a37$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $2de4d7b609de4a37$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $2de4d7b609de4a37$var$objectProto;
    return value === proto;
}
module.exports = $2de4d7b609de4a37$var$isPrototype;

});

parcelRegister("c5hrb", function(module, exports) {

var $50JNT = parcelRequire("50JNT");


var $5SKmw = parcelRequire("5SKmw");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $8cc37a613c2206db$var$isArrayLike(value) {
    return value != null && $5SKmw(value.length) && !$50JNT(value);
}
module.exports = $8cc37a613c2206db$var$isArrayLike;

});

parcelRegister("cogiS", function(module, exports) {

var $d1RZU = parcelRequire("d1RZU");


var $9XpeH = parcelRequire("9XpeH");

/** Used for built-in method references. */ var $90545f7288eefeee$var$objectProto = Object.prototype;
/** Built-in value references. */ var $90545f7288eefeee$var$propertyIsEnumerable = $90545f7288eefeee$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $90545f7288eefeee$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $90545f7288eefeee$var$getSymbols = !$90545f7288eefeee$var$nativeGetSymbols ? $9XpeH : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $d1RZU($90545f7288eefeee$var$nativeGetSymbols(object), function(symbol) {
        return $90545f7288eefeee$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $90545f7288eefeee$var$getSymbols;

});

parcelRegister("3nRKd", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $276d359848c19ab4$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $276d359848c19ab4$var$arrayPush;

});

parcelRegister("gxllf", function(module, exports) {

var $ht0pM = parcelRequire("ht0pM");

/** Built-in value references. */ var $c0a04868fcc24948$var$getPrototype = $ht0pM(Object.getPrototypeOf, Object);
module.exports = $c0a04868fcc24948$var$getPrototype;

});

parcelRegister("9XpeH", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $73fd331a4d5c3055$var$stubArray() {
    return [];
}
module.exports = $73fd331a4d5c3055$var$stubArray;

});

parcelRegister("6YdgV", function(module, exports) {

var $2NmsS = parcelRequire("2NmsS");


var $cogiS = parcelRequire("cogiS");


var $5GZkf = parcelRequire("5GZkf");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5132a4383ffb57bf$var$getAllKeys(object) {
    return $2NmsS(object, $5GZkf, $cogiS);
}
module.exports = $5132a4383ffb57bf$var$getAllKeys;

});

parcelRegister("2NmsS", function(module, exports) {

var $3nRKd = parcelRequire("3nRKd");


var $gNbxK = parcelRequire("gNbxK");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $209195636bc9ff5d$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $gNbxK(object) ? result : $3nRKd(result, symbolsFunc(object));
}
module.exports = $209195636bc9ff5d$var$baseGetAllKeys;

});

parcelRegister("49wbE", function(module, exports) {

var $jsvAC = parcelRequire("jsvAC");


var $eCI0i = parcelRequire("eCI0i");


var $510U1 = parcelRequire("510U1");


var $ZoZAP = parcelRequire("ZoZAP");


var $6B9zM = parcelRequire("6B9zM");


var $iEhAW = parcelRequire("iEhAW");


var $hVSgE = parcelRequire("hVSgE");

/** `Object#toString` result references. */ var $3060f8509847e8b6$var$mapTag = '[object Map]', $3060f8509847e8b6$var$objectTag = '[object Object]', $3060f8509847e8b6$var$promiseTag = '[object Promise]', $3060f8509847e8b6$var$setTag = '[object Set]', $3060f8509847e8b6$var$weakMapTag = '[object WeakMap]';
var $3060f8509847e8b6$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $3060f8509847e8b6$var$dataViewCtorString = $hVSgE($jsvAC), $3060f8509847e8b6$var$mapCtorString = $hVSgE($eCI0i), $3060f8509847e8b6$var$promiseCtorString = $hVSgE($510U1), $3060f8509847e8b6$var$setCtorString = $hVSgE($ZoZAP), $3060f8509847e8b6$var$weakMapCtorString = $hVSgE($6B9zM);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $3060f8509847e8b6$var$getTag = $iEhAW;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($jsvAC && $3060f8509847e8b6$var$getTag(new $jsvAC(new ArrayBuffer(1))) != $3060f8509847e8b6$var$dataViewTag || $eCI0i && $3060f8509847e8b6$var$getTag(new $eCI0i) != $3060f8509847e8b6$var$mapTag || $510U1 && $3060f8509847e8b6$var$getTag($510U1.resolve()) != $3060f8509847e8b6$var$promiseTag || $ZoZAP && $3060f8509847e8b6$var$getTag(new $ZoZAP) != $3060f8509847e8b6$var$setTag || $6B9zM && $3060f8509847e8b6$var$getTag(new $6B9zM) != $3060f8509847e8b6$var$weakMapTag) $3060f8509847e8b6$var$getTag = function(value) {
    var result = $iEhAW(value), Ctor = result == $3060f8509847e8b6$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $hVSgE(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $3060f8509847e8b6$var$dataViewCtorString:
            return $3060f8509847e8b6$var$dataViewTag;
        case $3060f8509847e8b6$var$mapCtorString:
            return $3060f8509847e8b6$var$mapTag;
        case $3060f8509847e8b6$var$promiseCtorString:
            return $3060f8509847e8b6$var$promiseTag;
        case $3060f8509847e8b6$var$setCtorString:
            return $3060f8509847e8b6$var$setTag;
        case $3060f8509847e8b6$var$weakMapCtorString:
            return $3060f8509847e8b6$var$weakMapTag;
    }
    return result;
};
module.exports = $3060f8509847e8b6$var$getTag;

});

parcelRegister("hxBlg", function(module, exports) {

var $aKMOV = parcelRequire("aKMOV");

/** Built-in value references. */ var $cc527c174ad9b616$var$Uint8Array = $aKMOV.Uint8Array;
module.exports = $cc527c174ad9b616$var$Uint8Array;

});

parcelRegister("hs6bh", function(module, exports) {

var $aKMOV = parcelRequire("aKMOV");

/** Built-in value references. */ var $cb49d89b7672005d$var$Symbol = $aKMOV.Symbol;
module.exports = $cb49d89b7672005d$var$Symbol;

});

parcelRegister("gNbxK", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c39a2d2ef71b3061$var$isArray = Array.isArray;
module.exports = $c39a2d2ef71b3061$var$isArray;

});

parcelRegister("edunD", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a599d8785b916e23$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $a599d8785b916e23$var$isObjectLike;

});

parcelRegister("2gYrW", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1a7bf76e9db4910d$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $1a7bf76e9db4910d$var$baseUnary;

});

parcelRegister("8WwLz", function(module, exports) {

var $gAikR = parcelRequire("gAikR");

/** Used to match leading whitespace. */ var $01ae25cf5866fc7d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $01ae25cf5866fc7d$var$baseTrim(string) {
    return string ? string.slice(0, $gAikR(string) + 1).replace($01ae25cf5866fc7d$var$reTrimStart, '') : string;
}
module.exports = $01ae25cf5866fc7d$var$baseTrim;

});

parcelRegister("40vup", function(module, exports) {

var $frRyo = parcelRequire("frRyo");


var $7Zt5w = parcelRequire("7Zt5w");

/** `Object#toString` result references. */ var $2eaf96acd6535a59$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2eaf96acd6535a59$var$isSymbol(value) {
    return typeof value == 'symbol' || $7Zt5w(value) && $frRyo(value) == $2eaf96acd6535a59$var$symbolTag;
}
module.exports = $2eaf96acd6535a59$var$isSymbol;

});

parcelRegister("bdhSS", function(module, exports) {

var $jH17x = parcelRequire("jH17x");


var $5GZkf = parcelRequire("5GZkf");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $829ec8060184ccaf$var$baseForOwn(object, iteratee) {
    return object && $jH17x(object, iteratee, $5GZkf);
}
module.exports = $829ec8060184ccaf$var$baseForOwn;

});

parcelRegister("Ru7al", function(module, exports) {

var $iz2RW = parcelRequire("iz2RW");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $0a0c4f7ae615955b$var$castFunction(value) {
    return typeof value == 'function' ? value : $iz2RW;
}
module.exports = $0a0c4f7ae615955b$var$castFunction;

});

parcelRegister("aqDYW", function(module, exports) {

var $2Ii0U = parcelRequire("2Ii0U");


var $7lgXV = parcelRequire("7lgXV");


var $dDFuF = parcelRequire("dDFuF");


var $cSJdB = parcelRequire("cSJdB");


var $9891i = parcelRequire("9891i");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $797b58a6e9b91c22$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$797b58a6e9b91c22$var$ListCache.prototype.clear = $2Ii0U;
$797b58a6e9b91c22$var$ListCache.prototype['delete'] = $7lgXV;
$797b58a6e9b91c22$var$ListCache.prototype.get = $dDFuF;
$797b58a6e9b91c22$var$ListCache.prototype.has = $cSJdB;
$797b58a6e9b91c22$var$ListCache.prototype.set = $9891i;
module.exports = $797b58a6e9b91c22$var$ListCache;

});

parcelRegister("fqjF4", function(module, exports) {

var $aqDYW = parcelRequire("aqDYW");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $b3a88913bc0b9574$var$stackClear() {
    this.__data__ = new $aqDYW;
    this.size = 0;
}
module.exports = $b3a88913bc0b9574$var$stackClear;

});

parcelRegister("fJQdQ", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b753913cf30eca01$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $b753913cf30eca01$var$stackDelete;

});

parcelRegister("dvufA", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9d55a2bacdab4914$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $9d55a2bacdab4914$var$stackGet;

});

parcelRegister("cy9vx", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9230090a04a23356$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $9230090a04a23356$var$stackHas;

});

parcelRegister("haegR", function(module, exports) {

var $aqDYW = parcelRequire("aqDYW");


var $eCI0i = parcelRequire("eCI0i");


var $8Qg0i = parcelRequire("8Qg0i");

/** Used as the size to enable large array optimizations. */ var $c7ee70c3cbcb8e6d$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $c7ee70c3cbcb8e6d$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $aqDYW) {
        var pairs = data.__data__;
        if (!$eCI0i || pairs.length < $c7ee70c3cbcb8e6d$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $8Qg0i(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $c7ee70c3cbcb8e6d$var$stackSet;

});

parcelRegister("dI8t1", function(module, exports) {

var $50JNT = parcelRequire("50JNT");


var $8mJ4A = parcelRequire("8mJ4A");


var $Aea15 = parcelRequire("Aea15");


var $hVSgE = parcelRequire("hVSgE");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $9fb5f3d12f31594b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $9fb5f3d12f31594b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $9fb5f3d12f31594b$var$funcProto = Function.prototype, $9fb5f3d12f31594b$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $9fb5f3d12f31594b$var$funcToString = $9fb5f3d12f31594b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $9fb5f3d12f31594b$var$hasOwnProperty = $9fb5f3d12f31594b$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $9fb5f3d12f31594b$var$reIsNative = RegExp('^' + $9fb5f3d12f31594b$var$funcToString.call($9fb5f3d12f31594b$var$hasOwnProperty).replace($9fb5f3d12f31594b$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $9fb5f3d12f31594b$var$baseIsNative(value) {
    if (!$Aea15(value) || $8mJ4A(value)) return false;
    var pattern = $50JNT(value) ? $9fb5f3d12f31594b$var$reIsNative : $9fb5f3d12f31594b$var$reIsHostCtor;
    return pattern.test($hVSgE(value));
}
module.exports = $9fb5f3d12f31594b$var$baseIsNative;

});

parcelRegister("bJfEO", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $88a00ae1f4d48b7d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $88a00ae1f4d48b7d$var$getValue;

});

parcelRegister("kGMAj", function(module, exports) {

var $3Wi7n = parcelRequire("3Wi7n");


var $dbAHm = parcelRequire("dbAHm");

/** Used for built-in method references. */ var $f0fd6aca1b0ad853$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0fd6aca1b0ad853$var$hasOwnProperty = $f0fd6aca1b0ad853$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f0fd6aca1b0ad853$var$baseKeys(object) {
    if (!$3Wi7n(object)) return $dbAHm(object);
    var result = [];
    for(var key in Object(object))if ($f0fd6aca1b0ad853$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $f0fd6aca1b0ad853$var$baseKeys;

});

parcelRegister("6JxL2", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $4e7121a43f471987$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $4e7121a43f471987$var$baseTimes;

});

parcelRegister("7zile", function(module, exports) {

var $gIQaw = parcelRequire("gIQaw");


var $edunD = parcelRequire("edunD");

/** Used for built-in method references. */ var $582a07896775cacb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $582a07896775cacb$var$hasOwnProperty = $582a07896775cacb$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $582a07896775cacb$var$propertyIsEnumerable = $582a07896775cacb$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $582a07896775cacb$var$isArguments = $gIQaw(function() {
    return arguments;
}()) ? $gIQaw : function(value) {
    return $edunD(value) && $582a07896775cacb$var$hasOwnProperty.call(value, 'callee') && !$582a07896775cacb$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $582a07896775cacb$var$isArguments;

});

parcelRegister("fpQin", function(module, exports) {
/** Used as references for various `Number` constants. */ var $b391c1993d0fdfa7$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $b391c1993d0fdfa7$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $b391c1993d0fdfa7$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $b391c1993d0fdfa7$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $b391c1993d0fdfa7$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $b391c1993d0fdfa7$var$isIndex;

});

parcelRegister("2vKbG", function(module, exports) {

var $58T2l = parcelRequire("58T2l");


var $2gYrW = parcelRequire("2gYrW");


var $i0Qa5 = parcelRequire("i0Qa5");

/* Node.js helper references. */ var $1d424ddd9cf89715$var$nodeIsTypedArray = $i0Qa5 && $i0Qa5.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $1d424ddd9cf89715$var$isTypedArray = $1d424ddd9cf89715$var$nodeIsTypedArray ? $2gYrW($1d424ddd9cf89715$var$nodeIsTypedArray) : $58T2l;
module.exports = $1d424ddd9cf89715$var$isTypedArray;

});

parcelRegister("50JNT", function(module, exports) {

var $iEhAW = parcelRequire("iEhAW");


var $Aea15 = parcelRequire("Aea15");

/** `Object#toString` result references. */ var $3a607b7f37b4a63e$var$asyncTag = '[object AsyncFunction]', $3a607b7f37b4a63e$var$funcTag = '[object Function]', $3a607b7f37b4a63e$var$genTag = '[object GeneratorFunction]', $3a607b7f37b4a63e$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3a607b7f37b4a63e$var$isFunction(value) {
    if (!$Aea15(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $iEhAW(value);
    return tag == $3a607b7f37b4a63e$var$funcTag || tag == $3a607b7f37b4a63e$var$genTag || tag == $3a607b7f37b4a63e$var$asyncTag || tag == $3a607b7f37b4a63e$var$proxyTag;
}
module.exports = $3a607b7f37b4a63e$var$isFunction;

});

parcelRegister("5SKmw", function(module, exports) {
/** Used as references for various `Number` constants. */ var $4485f57c87cbeea7$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $4485f57c87cbeea7$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $4485f57c87cbeea7$var$MAX_SAFE_INTEGER;
}
module.exports = $4485f57c87cbeea7$var$isLength;

});

parcelRegister("d1RZU", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $97c5412562d73485$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $97c5412562d73485$var$arrayFilter;

});

parcelRegister("ht0pM", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $cb7577784dca67af$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $cb7577784dca67af$var$overArg;

});

parcelRegister("jsvAC", function(module, exports) {

var $i3LrG = parcelRequire("i3LrG");


var $aKMOV = parcelRequire("aKMOV");

/* Built-in method references that are verified to be native. */ var $e2a922e6a060c10f$var$DataView = $i3LrG($aKMOV, 'DataView');
module.exports = $e2a922e6a060c10f$var$DataView;

});

parcelRegister("eCI0i", function(module, exports) {

var $i3LrG = parcelRequire("i3LrG");


var $aKMOV = parcelRequire("aKMOV");

/* Built-in method references that are verified to be native. */ var $aa56bf89f6f9f966$var$Map = $i3LrG($aKMOV, 'Map');
module.exports = $aa56bf89f6f9f966$var$Map;

});

parcelRegister("510U1", function(module, exports) {

var $i3LrG = parcelRequire("i3LrG");


var $aKMOV = parcelRequire("aKMOV");

/* Built-in method references that are verified to be native. */ var $3a6dbefdd5378407$var$Promise = $i3LrG($aKMOV, 'Promise');
module.exports = $3a6dbefdd5378407$var$Promise;

});

parcelRegister("ZoZAP", function(module, exports) {

var $i3LrG = parcelRequire("i3LrG");


var $aKMOV = parcelRequire("aKMOV");

/* Built-in method references that are verified to be native. */ var $0b891598cfddf39f$var$Set = $i3LrG($aKMOV, 'Set');
module.exports = $0b891598cfddf39f$var$Set;

});

parcelRegister("6B9zM", function(module, exports) {

var $i3LrG = parcelRequire("i3LrG");


var $aKMOV = parcelRequire("aKMOV");

/* Built-in method references that are verified to be native. */ var $4cdda0644d231743$var$WeakMap = $i3LrG($aKMOV, 'WeakMap');
module.exports = $4cdda0644d231743$var$WeakMap;

});

parcelRegister("iEhAW", function(module, exports) {

var $hs6bh = parcelRequire("hs6bh");


var $3ldt3 = parcelRequire("3ldt3");


var $2Skqb = parcelRequire("2Skqb");

/** `Object#toString` result references. */ var $d9399c5f169e0d8f$var$nullTag = '[object Null]', $d9399c5f169e0d8f$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $d9399c5f169e0d8f$var$symToStringTag = $hs6bh ? $hs6bh.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $d9399c5f169e0d8f$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $d9399c5f169e0d8f$var$undefinedTag : $d9399c5f169e0d8f$var$nullTag;
    return $d9399c5f169e0d8f$var$symToStringTag && $d9399c5f169e0d8f$var$symToStringTag in Object(value) ? $3ldt3(value) : $2Skqb(value);
}
module.exports = $d9399c5f169e0d8f$var$baseGetTag;

});

parcelRegister("hVSgE", function(module, exports) {
/** Used for built-in method references. */ var $d0e1daee15160221$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $d0e1daee15160221$var$funcToString = $d0e1daee15160221$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $d0e1daee15160221$var$toSource(func) {
    if (func != null) {
        try {
            return $d0e1daee15160221$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $d0e1daee15160221$var$toSource;

});

parcelRegister("gAikR", function(module, exports) {
/** Used to match a single whitespace character. */ var $c12e3b3265ee3d7b$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $c12e3b3265ee3d7b$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $c12e3b3265ee3d7b$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $c12e3b3265ee3d7b$var$trimmedEndIndex;

});

parcelRegister("jH17x", function(module, exports) {

var $j9Opx = parcelRequire("j9Opx");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $e562e6fdc0cc2f00$var$baseFor = $j9Opx();
module.exports = $e562e6fdc0cc2f00$var$baseFor;

});

parcelRegister("iz2RW", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $d83db89ed3c5c2ea$var$identity(value) {
    return value;
}
module.exports = $d83db89ed3c5c2ea$var$identity;

});

parcelRegister("2Ii0U", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $1f9da9fb35621624$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $1f9da9fb35621624$var$listCacheClear;

});

parcelRegister("7lgXV", function(module, exports) {

var $C0IU9 = parcelRequire("C0IU9");

/** Used for built-in method references. */ var $5587a79399b53342$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $5587a79399b53342$var$splice = $5587a79399b53342$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5587a79399b53342$var$listCacheDelete(key) {
    var data = this.__data__, index = $C0IU9(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $5587a79399b53342$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $5587a79399b53342$var$listCacheDelete;

});

parcelRegister("dDFuF", function(module, exports) {

var $C0IU9 = parcelRequire("C0IU9");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9edf1aa5b4fc20dc$var$listCacheGet(key) {
    var data = this.__data__, index = $C0IU9(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $9edf1aa5b4fc20dc$var$listCacheGet;

});

parcelRegister("cSJdB", function(module, exports) {

var $C0IU9 = parcelRequire("C0IU9");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $960d9aa25b370b38$var$listCacheHas(key) {
    return $C0IU9(this.__data__, key) > -1;
}
module.exports = $960d9aa25b370b38$var$listCacheHas;

});

parcelRegister("9891i", function(module, exports) {

var $C0IU9 = parcelRequire("C0IU9");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $6a5bdb8e5cda07b3$var$listCacheSet(key, value) {
    var data = this.__data__, index = $C0IU9(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $6a5bdb8e5cda07b3$var$listCacheSet;

});

parcelRegister("8Qg0i", function(module, exports) {

var $eMY0W = parcelRequire("eMY0W");


var $cRzSh = parcelRequire("cRzSh");


var $52Wnl = parcelRequire("52Wnl");


var $Kr044 = parcelRequire("Kr044");


var $ewUEj = parcelRequire("ewUEj");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $66ff9810824a016b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$66ff9810824a016b$var$MapCache.prototype.clear = $eMY0W;
$66ff9810824a016b$var$MapCache.prototype['delete'] = $cRzSh;
$66ff9810824a016b$var$MapCache.prototype.get = $52Wnl;
$66ff9810824a016b$var$MapCache.prototype.has = $Kr044;
$66ff9810824a016b$var$MapCache.prototype.set = $ewUEj;
module.exports = $66ff9810824a016b$var$MapCache;

});

parcelRegister("8mJ4A", function(module, exports) {

var $9kWmY = parcelRequire("9kWmY");

/** Used to detect methods masquerading as native. */ var $61735757b8fa00fb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($9kWmY && $9kWmY.keys && $9kWmY.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $61735757b8fa00fb$var$isMasked(func) {
    return !!$61735757b8fa00fb$var$maskSrcKey && $61735757b8fa00fb$var$maskSrcKey in func;
}
module.exports = $61735757b8fa00fb$var$isMasked;

});

parcelRegister("dbAHm", function(module, exports) {

var $ht0pM = parcelRequire("ht0pM");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $9998c4f607dc0a18$var$nativeKeys = $ht0pM(Object.keys, Object);
module.exports = $9998c4f607dc0a18$var$nativeKeys;

});

parcelRegister("gIQaw", function(module, exports) {

var $iEhAW = parcelRequire("iEhAW");


var $edunD = parcelRequire("edunD");

/** `Object#toString` result references. */ var $c2c93900a76c1411$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $c2c93900a76c1411$var$baseIsArguments(value) {
    return $edunD(value) && $iEhAW(value) == $c2c93900a76c1411$var$argsTag;
}
module.exports = $c2c93900a76c1411$var$baseIsArguments;

});

parcelRegister("58T2l", function(module, exports) {

var $iEhAW = parcelRequire("iEhAW");


var $5SKmw = parcelRequire("5SKmw");


var $edunD = parcelRequire("edunD");

/** `Object#toString` result references. */ var $3be864429ed60219$var$argsTag = '[object Arguments]', $3be864429ed60219$var$arrayTag = '[object Array]', $3be864429ed60219$var$boolTag = '[object Boolean]', $3be864429ed60219$var$dateTag = '[object Date]', $3be864429ed60219$var$errorTag = '[object Error]', $3be864429ed60219$var$funcTag = '[object Function]', $3be864429ed60219$var$mapTag = '[object Map]', $3be864429ed60219$var$numberTag = '[object Number]', $3be864429ed60219$var$objectTag = '[object Object]', $3be864429ed60219$var$regexpTag = '[object RegExp]', $3be864429ed60219$var$setTag = '[object Set]', $3be864429ed60219$var$stringTag = '[object String]', $3be864429ed60219$var$weakMapTag = '[object WeakMap]';
var $3be864429ed60219$var$arrayBufferTag = '[object ArrayBuffer]', $3be864429ed60219$var$dataViewTag = '[object DataView]', $3be864429ed60219$var$float32Tag = '[object Float32Array]', $3be864429ed60219$var$float64Tag = '[object Float64Array]', $3be864429ed60219$var$int8Tag = '[object Int8Array]', $3be864429ed60219$var$int16Tag = '[object Int16Array]', $3be864429ed60219$var$int32Tag = '[object Int32Array]', $3be864429ed60219$var$uint8Tag = '[object Uint8Array]', $3be864429ed60219$var$uint8ClampedTag = '[object Uint8ClampedArray]', $3be864429ed60219$var$uint16Tag = '[object Uint16Array]', $3be864429ed60219$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $3be864429ed60219$var$typedArrayTags = {};
$3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$float32Tag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$float64Tag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$int8Tag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$int16Tag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$int32Tag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$uint8Tag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$uint8ClampedTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$uint16Tag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$uint32Tag] = true;
$3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$argsTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$arrayTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$arrayBufferTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$boolTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$dataViewTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$dateTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$errorTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$funcTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$mapTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$numberTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$objectTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$regexpTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$setTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$stringTag] = $3be864429ed60219$var$typedArrayTags[$3be864429ed60219$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $3be864429ed60219$var$baseIsTypedArray(value) {
    return $edunD(value) && $5SKmw(value.length) && !!$3be864429ed60219$var$typedArrayTags[$iEhAW(value)];
}
module.exports = $3be864429ed60219$var$baseIsTypedArray;

});

parcelRegister("3ldt3", function(module, exports) {

var $hs6bh = parcelRequire("hs6bh");

/** Used for built-in method references. */ var $26edc7a0391671ac$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $26edc7a0391671ac$var$hasOwnProperty = $26edc7a0391671ac$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $26edc7a0391671ac$var$nativeObjectToString = $26edc7a0391671ac$var$objectProto.toString;
/** Built-in value references. */ var $26edc7a0391671ac$var$symToStringTag = $hs6bh ? $hs6bh.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $26edc7a0391671ac$var$getRawTag(value) {
    var isOwn = $26edc7a0391671ac$var$hasOwnProperty.call(value, $26edc7a0391671ac$var$symToStringTag), tag = value[$26edc7a0391671ac$var$symToStringTag];
    try {
        value[$26edc7a0391671ac$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $26edc7a0391671ac$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$26edc7a0391671ac$var$symToStringTag] = tag;
        else delete value[$26edc7a0391671ac$var$symToStringTag];
    }
    return result;
}
module.exports = $26edc7a0391671ac$var$getRawTag;

});

parcelRegister("2Skqb", function(module, exports) {
/** Used for built-in method references. */ var $2180772d19ced74f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2180772d19ced74f$var$nativeObjectToString = $2180772d19ced74f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $2180772d19ced74f$var$objectToString(value) {
    return $2180772d19ced74f$var$nativeObjectToString.call(value);
}
module.exports = $2180772d19ced74f$var$objectToString;

});

parcelRegister("j9Opx", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $df25f629d4641a49$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $df25f629d4641a49$var$createBaseFor;

});

parcelRegister("C0IU9", function(module, exports) {

var $4ESv6 = parcelRequire("4ESv6");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $07241c59dd916ff9$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($4ESv6(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $07241c59dd916ff9$var$assocIndexOf;

});

parcelRegister("eMY0W", function(module, exports) {

var $bcSui = parcelRequire("bcSui");


var $aqDYW = parcelRequire("aqDYW");


var $eCI0i = parcelRequire("eCI0i");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $ac4419ee761fe6eb$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $bcSui,
        'map': new ($eCI0i || $aqDYW),
        'string': new $bcSui
    };
}
module.exports = $ac4419ee761fe6eb$var$mapCacheClear;

});

parcelRegister("cRzSh", function(module, exports) {

var $9CvcD = parcelRequire("9CvcD");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $95d6432cd39f0679$var$mapCacheDelete(key) {
    var result = $9CvcD(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $95d6432cd39f0679$var$mapCacheDelete;

});

parcelRegister("52Wnl", function(module, exports) {

var $9CvcD = parcelRequire("9CvcD");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3aca6bcf57cd2ec3$var$mapCacheGet(key) {
    return $9CvcD(this, key).get(key);
}
module.exports = $3aca6bcf57cd2ec3$var$mapCacheGet;

});

parcelRegister("Kr044", function(module, exports) {

var $9CvcD = parcelRequire("9CvcD");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $08b93da385ec61d5$var$mapCacheHas(key) {
    return $9CvcD(this, key).has(key);
}
module.exports = $08b93da385ec61d5$var$mapCacheHas;

});

parcelRegister("ewUEj", function(module, exports) {

var $9CvcD = parcelRequire("9CvcD");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a93fff2f34b9b844$var$mapCacheSet(key, value) {
    var data = $9CvcD(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $a93fff2f34b9b844$var$mapCacheSet;

});

parcelRegister("9kWmY", function(module, exports) {

var $aKMOV = parcelRequire("aKMOV");

/** Used to detect overreaching core-js shims. */ var $6cc3424357d48e45$var$coreJsData = $aKMOV["__core-js_shared__"];
module.exports = $6cc3424357d48e45$var$coreJsData;

});

parcelRegister("bcSui", function(module, exports) {

var $5Uh2K = parcelRequire("5Uh2K");


var $iogdD = parcelRequire("iogdD");


var $j1Qt6 = parcelRequire("j1Qt6");


var $bJst5 = parcelRequire("bJst5");


var $ba3Ee = parcelRequire("ba3Ee");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $828b14cf6569f24c$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$828b14cf6569f24c$var$Hash.prototype.clear = $5Uh2K;
$828b14cf6569f24c$var$Hash.prototype['delete'] = $iogdD;
$828b14cf6569f24c$var$Hash.prototype.get = $j1Qt6;
$828b14cf6569f24c$var$Hash.prototype.has = $bJst5;
$828b14cf6569f24c$var$Hash.prototype.set = $ba3Ee;
module.exports = $828b14cf6569f24c$var$Hash;

});

parcelRegister("9CvcD", function(module, exports) {

var $8pidh = parcelRequire("8pidh");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $700fdde5f796fdf4$var$getMapData(map, key) {
    var data = map.__data__;
    return $8pidh(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $700fdde5f796fdf4$var$getMapData;

});

parcelRegister("5Uh2K", function(module, exports) {

var $scrDJ = parcelRequire("scrDJ");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $44cf6724b61ebdac$var$hashClear() {
    this.__data__ = $scrDJ ? $scrDJ(null) : {};
    this.size = 0;
}
module.exports = $44cf6724b61ebdac$var$hashClear;

});

parcelRegister("iogdD", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d6370ca42000263b$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $d6370ca42000263b$var$hashDelete;

});

parcelRegister("j1Qt6", function(module, exports) {

var $scrDJ = parcelRequire("scrDJ");

/** Used to stand-in for `undefined` hash values. */ var $dda6cf72dd8b59ba$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $dda6cf72dd8b59ba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dda6cf72dd8b59ba$var$hasOwnProperty = $dda6cf72dd8b59ba$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dda6cf72dd8b59ba$var$hashGet(key) {
    var data = this.__data__;
    if ($scrDJ) {
        var result = data[key];
        return result === $dda6cf72dd8b59ba$var$HASH_UNDEFINED ? undefined : result;
    }
    return $dda6cf72dd8b59ba$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $dda6cf72dd8b59ba$var$hashGet;

});

parcelRegister("bJst5", function(module, exports) {

var $scrDJ = parcelRequire("scrDJ");

/** Used for built-in method references. */ var $88a9fae1353e702b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $88a9fae1353e702b$var$hasOwnProperty = $88a9fae1353e702b$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $88a9fae1353e702b$var$hashHas(key) {
    var data = this.__data__;
    return $scrDJ ? data[key] !== undefined : $88a9fae1353e702b$var$hasOwnProperty.call(data, key);
}
module.exports = $88a9fae1353e702b$var$hashHas;

});

parcelRegister("ba3Ee", function(module, exports) {

var $scrDJ = parcelRequire("scrDJ");

/** Used to stand-in for `undefined` hash values. */ var $82037548ef768d3c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $82037548ef768d3c$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $scrDJ && value === undefined ? $82037548ef768d3c$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $82037548ef768d3c$var$hashSet;

});

parcelRegister("8pidh", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $61eec94643ae4ebd$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $61eec94643ae4ebd$var$isKeyable;

});

parcelRegister("scrDJ", function(module, exports) {

var $i3LrG = parcelRequire("i3LrG");

/* Built-in method references that are verified to be native. */ var $054c44eb25cb5641$var$nativeCreate = $i3LrG(Object, 'create');
module.exports = $054c44eb25cb5641$var$nativeCreate;

});


$parcel$global.rlb("7Fou0")
//# sourceMappingURL=cards-extension.35a1ab46.js.map
